(function () {
  "use strict";

  const ATTR_GWP_MANAGED = "_gwp_managed";
  const ATTR_GWP_TIER = "_gwp_tier";
  const ATTR_GWP_SOURCE = "_gwp_source";

  const ATTR_FEE_MANAGED = "_qk_fee_managed";
  const ATTR_FEE_RULE = "_qk_fee_rule";
  const ATTR_FEE_SOURCE = "_qk_fee_source";
  const ATTR_FEE_SOURCE_VARIANT = "_qk_fee_source_variant";

  const ATTR_GIFT_WRAP_SELECTED = "_qk_gift_wrap_selected";
  const ATTR_GIFT_WRAP_MANAGED = "_qk_gift_wrap_managed";
  const ATTR_GIFT_WRAP_SOURCE = "_qk_gift_wrap_source";
  const ATTR_PACKAGE_INSURANCE_SELECTED = "_qk_package_insurance_selected";
  const ATTR_PACKAGE_INSURANCE_MANAGED = "_qk_package_insurance_managed";
  const ATTR_PACKAGE_INSURANCE_SOURCE = "_qk_package_insurance_source";
  const ATTR_B2B_CHECKOUT = "_qk_b2b_checkout";

  const ATTR_LUBE_SELECTED = "_qk_lube_selected";
  const ATTR_LUBE_SCOPE = "_qk_lube_scope";
  const ATTR_LUBE_RULE = "_qk_lube_rule";
  const ATTR_LUBE_LAYOUT = "_qk_lube_layout";
  const ATTR_LUBE_MANAGED = "_qk_lube_managed";
  const ATTR_LUBE_SOURCE = "_qk_lube_source";
  const ATTR_LUBE_SOURCE_VARIANT = "_qk_lube_source_variant";
  const ATTR_LUBE_SELECTED_PUBLIC = "qk_lube_selected";
  const ATTR_LUBE_SCOPE_PUBLIC = "qk_lube_scope";
  const ATTR_LUBE_RULE_PUBLIC = "qk_lube_rule";
  const ATTR_LUBE_LAYOUT_PUBLIC = "qk_lube_layout";
  const ATTR_LUBE_MANAGED_PUBLIC = "qk_lube_managed";
  const ATTR_LUBE_SOURCE_PUBLIC = "qk_lube_source";
  const LUBE_PUBLIC_ATTR_KEYS = [
    ATTR_LUBE_SELECTED_PUBLIC,
    ATTR_LUBE_SCOPE_PUBLIC,
    ATTR_LUBE_RULE_PUBLIC,
    ATTR_LUBE_LAYOUT_PUBLIC,
    ATTR_LUBE_MANAGED_PUBLIC,
    ATTR_LUBE_SOURCE_PUBLIC,
  ];
  const ATTR_UPSELL_MANAGED_PUBLIC = "qk_upsell_managed";
  const ATTR_UPSELL_SOURCE_PUBLIC = "qk_upsell_source";
  const ATTR_UPSELL_PARENT_VARIANT_PUBLIC = "qk_upsell_parent_variant";
  const ATTR_UPSELL_DISCOUNT_PERCENT_PUBLIC = "qk_upsell_discount_percent";
  const UPSELL_PUBLIC_ATTR_KEYS = [
    ATTR_UPSELL_MANAGED_PUBLIC,
    ATTR_UPSELL_SOURCE_PUBLIC,
    ATTR_UPSELL_PARENT_VARIANT_PUBLIC,
    ATTR_UPSELL_DISCOUNT_PERCENT_PUBLIC,
  ];

  const ATTR_CFG_THRESHOLD_1 = "_gwp_threshold_1_ron";
  const ATTR_CFG_THRESHOLD_2 = "_gwp_threshold_2_ron";
  const ATTR_CFG_THRESHOLD_3 = "_gwp_threshold_3_ron";
  const ATTR_CFG_GIFT_1 = "_gwp_gift_product_1_id";
  const ATTR_CFG_GIFT_2 = "_gwp_gift_product_2_id";
  const ATTR_CFG_GIFT_3 = "_gwp_gift_product_3_id";
  const ATTR_CFG_TIER_1_ENABLED = "_gwp_tier_1_enabled";
  const ATTR_CFG_TIER_2_ENABLED = "_gwp_tier_2_enabled";
  const ATTR_CFG_TIER_3_ENABLED = "_gwp_tier_3_enabled";
  const ATTR_CFG_TIER_1_IN_STOCK = "_gwp_tier_1_in_stock";
  const ATTR_CFG_TIER_2_IN_STOCK = "_gwp_tier_2_in_stock";
  const ATTR_CFG_TIER_3_IN_STOCK = "_gwp_tier_3_in_stock";
  const ATTR_CFG_STACK_UNLOCKED = "_gwp_stack_unlocked_tiers";
  const ATTR_CFG_THRESHOLD_BASIS = "_gwp_subtotal_ex_gift_cents";
  const ATTR_CFG_HASH = "_gwp_config_hash";

  const SOURCE_STOREFRONT = "storefront_cart";
  const GIFT_WRAP_PRODUCT_LEGACY_ID = "8654529036622";
  const GIFT_WRAP_MODAL_ELEMENT_ID = "qk-gift-wrap-modal";
  const PACKAGE_INSURANCE_PRODUCT_LEGACY_ID = "9672531607886";
  const PACKAGE_INSURANCE_MODAL_ELEMENT_ID = "qk-package-insurance-modal";
  const LUBE_SCOPE_KEYBOARD = "keyboard";
  const LUBE_SCOPE_SWITCH = "switch";
  const KNOWN_FEE_RULE_KEYS = [
    "heavy_keyboard",
    "casti_or_keyboards",
    "mouse_or_cable_not_mouse_cover",
  ];
  const PROGRESS_CACHE_PREFIX = "qk-progress-cache:v1:";
  const LUBE_INTENT_STORAGE_KEY = "qk:lube-intent:v1";
  const LUBE_INTENT_TTL_MS = 3 * 60 * 1000;
  const LUBE_REMOVE_INTENT_TTL_MS = 2 * 60 * 1000;
  const LINE_MUTATION_DEBOUNCE_MS = 55;
  const GIFT_STOCK_CACHE_TTL_MS = 60 * 1000;
  const GIFT_WRAP_CACHE_TTL_MS = 10 * 60 * 1000;
  const GIFT_WRAP_SESSION_CACHE_KEY = "qk:gift-wrap:v1";
  const PACKAGE_INSURANCE_SESSION_CACHE_KEY = "qk:package-insurance:v1";
  const MAX_SYNC_CONVERGENCE_ITERATIONS = 4;
  const PRODUCT_LOOKUP_PAGE_LIMIT = 250;
  const PRODUCT_LOOKUP_MAX_PAGES = 80;
  const FALLBACK_GIFT_VARIANT_BY_PRODUCT_ID = {
    "9016970510670": "46906364985678",
  };

  const productLookupCacheByLegacyId = {};
  let productCatalogByLegacyId = {};
  let productCatalogNextPage = 1;
  let productCatalogExhausted = false;
  let productCatalogScanPromise = null;
  const LEI_CURRENCY_FORMATTER = new Intl.NumberFormat("ro-RO", {
    style: "currency",
    currency: "RON",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const DEFAULT_RULES = {
    version: 1,
    currency: "RON",
    gift: {
      mode: "cumulative",
      tiers: [
        {
          index: 1,
          enabled: true,
          thresholdRon: 100,
          giftProductLegacyId: "9016970510670",
          giftVariantLegacyId: "",
        },
        {
          index: 2,
          enabled: true,
          thresholdRon: 500,
          giftProductLegacyId: "7832051810519",
          giftVariantLegacyId: "",
        },
        {
          index: 3,
          enabled: false,
          thresholdRon: 800,
          giftProductLegacyId: "0",
          giftVariantLegacyId: "",
        },
      ],
    },
    fees: {
      rules: [
        {
          key: "heavy_keyboard",
          feeProductLegacyId: "8745358426446",
          feeVariantLegacyId: "47677399138638",
          includeTags: ["heavy keyboard"],
          excludeTags: [],
          suppresses: ["casti_or_keyboards"],
        },
        {
          key: "casti_or_keyboards",
          feeProductLegacyId: "8745336570190",
          feeVariantLegacyId: "47677341532494",
          includeTags: ["casti", "keyboards"],
          excludeTags: [],
          suppresses: [],
        },
        {
          key: "mouse_or_cable_not_mouse_cover",
          feeProductLegacyId: "8745361047886",
          feeVariantLegacyId: "47677405790542",
          includeTags: ["mouse", "cable"],
          excludeTags: ["mouse-cover"],
          suppresses: [],
        },
      ],
    },
    ui: {
      progressTitle: "Cadouri in cos",
      unlockedLabel: "Aplicat",
      eligibleLabel: "Eligibil",
      lockedLabel: "Blocat",
    },
    flags: {
      managedRulesEnabled: true,
      shadowMode: false,
      log: false,
      killSwitch: false,
    },
  };

  const DEFAULT_LUBRICATION_CONFIG = {
    version: 1,
    enabled: false,
    keyboard: {
      enabled: true,
      rules: [],
    },
    switch: {
      enabled: false,
      rules: [],
    },
    ui: {
      label_ro: "Lubrifiere premium pentru switch-uri",
      attachment_ro: "Lubrifiere switch-uri inclusa",
    },
  };

  const state = {
    inFlight: false,
    rerun: false,
    syncPromise: null,
    debounceTimer: null,
    lineMutationDrainTimer: null,
    lineMutationInFlight: false,
    lineMutationPromise: null,
    lineMutationQueue: [],
    latestIntendedLineQuantities: {},
    uiRefreshFrame: 0,
    domObserver: null,
    domObserverTargets: [],
    domObserverTargetSignature: "",
    domMutationRefreshQueued: false,
    queuedSeedCart: null,
    cartPageSeedCart: null,
    cartPageBootSyncScheduled: false,
    pendingManagedRemovalKeys: {},
    checkoutErrorMessageByFormKey: {},
    processingLineKeys: {},
    config: null,
    lubricationConfig: null,
    lastCart: null,
    lastPlanSignature: "",
    resolvedGiftVariantsByProductId: {},
    giftStockByProductId: {},
    giftStockFetchedAt: 0,
    resolvedLubricationVariantsByProductId: {},
    lubricationStockByProductId: {},
    lubricationStockFetchedAt: 0,
    lubricationManagedProductIds: {},
    lubricationRemovalIntents: [],
    checkoutFallbackTimer: null,
    giftWrapStockByProductId: {},
    giftWrapStockFetchedAt: 0,
    giftWrapVariantLegacyId: "",
    giftWrapInStock: false,
    giftWrapProduct: null,
    giftWrapUiBusy: false,
    giftWrapModalOpen: false,
    giftWrapModalLastActiveElement: null,
    giftWrapModalContext: "page",
    giftWrapPendingDeselection: false,
    giftWrapPendingSelection: false,
    giftWrapConfirmBusy: false,
    giftWrapAddPerfPending: false,
    giftWrapWarmPromise: null,
    packageInsuranceStockByProductId: {},
    packageInsuranceStockFetchedAt: 0,
    packageInsuranceVariantLegacyId: "",
    packageInsuranceInStock: false,
    packageInsuranceProduct: null,
    packageInsuranceUiBusy: false,
    packageInsuranceModalOpen: false,
    packageInsuranceModalLastActiveElement: null,
    packageInsuranceModalContext: "page",
    packageInsurancePendingDeselection: false,
    packageInsurancePendingSelection: false,
    packageInsuranceConfirmBusy: false,
    packageInsuranceAddPerfPending: false,
    packageInsuranceWarmPromise: null,
    customerContext: null,
  };

  function init() {
    const cartPageContext = isCartPagePath();
    getConfig();
    getLubricationConfig();
    ensureKlarnaPlacementsLocale(document);
    hydrateProgressMountsFromCache();
    hydrateGiftWrapStateFromSessionCache({ allowStale: true });
    hydratePackageInsuranceStateFromSessionCache({ allowStale: true });
    bindCartDrawerLifecycleListeners();

    if (cartPageContext) {
      const cartPageSeed = readCartPageSeed();
      if (cartPageSeed) {
        state.cartPageSeedCart = cartPageSeed;
        state.lastCart = cartPageSeed;
        scheduleUiRefresh("cart-page-seed");
      }
    }

    prewarmManagedVariantCaches();

    if (hasGiftWrapUiMounts() && cartPageContext) {
      warmGiftWrapProductState({ immediate: true });
    }
    if (hasPackageInsuranceUiMounts() && cartPageContext) {
      warmPackageInsuranceProductState({ immediate: true });
    }

    window.updateQuantity = function updateQuantity(lineKey, delta) {
      void handleQuantityDelta(lineKey, delta);
    };

    window.QKCartRules = {
      syncNow: (reason) => syncNow(reason || "manual"),
      isSyncInFlight: () => isSyncInFlight(),
      predictGiftItems: (input) => predictGiftItems(input),
    };

    document.addEventListener("change", onQuantityInputChanged, true);
    document.addEventListener("pointerdown", onLubricationAttachmentRemoveClick, true);
    document.addEventListener("click", onLubricationAttachmentRemoveClick, true);
    document.addEventListener("click", onRemoveLinkClicked, true);
    document.addEventListener("click", onGiftWrapUiClick, true);
    document.addEventListener("keydown", onGiftWrapModalKeyDown, true);
    document.addEventListener("click", onPackageInsuranceUiClick, true);
    document.addEventListener("keydown", onPackageInsuranceModalKeyDown, true);
    document.addEventListener("click", onCheckoutRetryClick, true);
    window.addEventListener("pointerdown", onPrimaryCheckoutPointerDown, true);
    window.addEventListener("click", onPrimaryCheckoutClick, true);
    document.addEventListener("submit", onCheckoutSubmit, true);
    document.addEventListener("cart:change", onExternalCartChange);
    window.addEventListener("pageshow", onPageShow, true);
    window.addEventListener("load", onWindowLoad, { once: true });
    window.addEventListener("beforeunload", clearCheckoutFallbackTimer, { passive: true });

    // Watchdog: if checkout button has been busy for >10s without any sync
    // activity, force-clear it. Catches edge cases where state.inFlight was
    // cleared but refreshCheckoutButtonsBusy() was somehow missed.
    setInterval(function () {
      if (!state.inFlight && !state.debounceTimer) {
        setCheckoutButtonsBusy(false);
      }
    }, 5000);

    if (cartPageContext) {
      queueCartPageBootSync("init-cart-page", getPreferredCartPageSeed(), 0);
    }
  }

  function prewarmManagedVariantCaches() {
    const hasAtcForms = Boolean(document.querySelector('form[action*="/cart/add"]'));
    const cartContext = isCartPagePath() || hasGiftWrapUiMounts() || hasPackageInsuranceUiMounts();
    if (!hasAtcForms && !cartContext) {
      return;
    }

    const run = async () => {
      const seedCart = state.lastCart || { items: [] };
      try {
        await Promise.all([
          ensureGiftVariantIds(seedCart, getConfig()),
          ensureLubricationVariantIds(seedCart, getLubricationConfig()),
          ensurePackageInsuranceVariantId(seedCart),
        ]);
      } catch (error) {
        debugLog("[qk-cart-rules] managed cache prewarm failed", error);
      }
    };

    if (typeof window.requestIdleCallback === "function") {
      window.requestIdleCallback(() => {
        void run();
      }, { timeout: 1200 });
      return;
    }

    window.setTimeout(() => {
      void run();
    }, 120);
  }

  function hasGiftWrapUiMounts() {
    return Boolean(document.querySelector("[data-qk-gift-wrap-mount]"));
  }

  function hasPackageInsuranceUiMounts() {
    return Boolean(document.querySelector("[data-qk-package-insurance-mount]"));
  }

  function canObserveCartUi() {
    return Boolean(isCartPagePath() || isCartDrawerOpen());
  }

  function isCartDrawerOpen() {
    const drawerElement = resolveCartDrawerElement();
    return Boolean(drawerElement && drawerElement.hasAttribute("open"));
  }

  function bindCartDrawerLifecycleListeners() {
    const drawerElement = resolveCartDrawerElement();
    if (!(drawerElement instanceof HTMLElement)) {
      return;
    }

    drawerElement.addEventListener("dialog:after-show", onCartDrawerAfterShow);
    drawerElement.addEventListener("dialog:after-hide", onCartDrawerAfterHide);
  }

  function onCartDrawerAfterShow() {
    activateCartSync("drawer-open", null, 0);
  }

  function onCartDrawerAfterHide() {
    refreshCartUiObserverTargets();
    if (state.giftWrapModalOpen && state.giftWrapModalContext === "drawer") {
      closeGiftWrapModal({ restoreFocus: false });
    }
    if (state.packageInsuranceModalOpen && state.packageInsuranceModalContext === "drawer") {
      closePackageInsuranceModal({ restoreFocus: false });
    }
  }

  function activateCartSync(reason, seedCart, delayMs) {
    startCartUiObserver();
    warmGiftWrapProductState({ immediate: true });
    warmPackageInsuranceProductState({ immediate: true });
    scheduleSync(reason || "cart-ui-activate", seedCart || null, delayMs);
  }

  function queueCartPageBootSync(reason, seedCart, delayMs) {
    if (!isCartPagePath()) {
      return;
    }

    if (state.cartPageBootSyncScheduled) {
      return;
    }

    state.cartPageBootSyncScheduled = true;
    activateCartSync(reason || "cart-page-boot", seedCart || getPreferredCartPageSeed(), delayMs);
  }

  function getPreferredCartPageSeed() {
    return normalizeCartPayload(state.lastCart) || normalizeCartPayload(state.cartPageSeedCart) || readCartPageSeed();
  }

  function readCartPageSeed() {
    if (!isCartPagePath()) {
      return null;
    }

    const scriptElement = document.getElementById("qk-cart-page-seed");
    if (!(scriptElement instanceof HTMLScriptElement)) {
      return null;
    }

    const raw = String(scriptElement.textContent || "").trim();
    if (!raw || raw === "null") {
      return null;
    }

    try {
      return normalizeCartPayload(JSON.parse(raw));
    } catch (error) {
      debugLog("[qk-cart-rules] invalid cart page seed", error);
      return null;
    }
  }

  function hydrateProgressMountsFromCache() {
    const mounts = Array.from(document.querySelectorAll(".qk-cart-progress-mount"));
    mounts.forEach((mount) => {
      const context = getProgressMountContext(mount);
      const cached = readProgressCache(context);
      if (!cached) {
        return;
      }

      mount.innerHTML = cached;
    });
  }

  function getProgressMountContext(mount) {
    if (!(mount instanceof Element)) {
      return "global";
    }

    return String(mount.getAttribute("data-qk-progress-context") || "global").trim().toLowerCase() || "global";
  }

  function getProgressCacheKey(context) {
    return `${PROGRESS_CACHE_PREFIX}${String(context || "global").trim().toLowerCase() || "global"}`;
  }

  function readProgressCache(context) {
    try {
      return String(window.sessionStorage.getItem(getProgressCacheKey(context)) || "").trim();
    } catch {
      return "";
    }
  }

  function writeProgressCache(context, html) {
    try {
      window.sessionStorage.setItem(getProgressCacheKey(context), String(html || ""));
    } catch {
      // ignore storage failures
    }
  }

  function clearProgressCache(context) {
    try {
      window.sessionStorage.removeItem(getProgressCacheKey(context));
    } catch {
      // ignore storage failures
    }
  }

  function startCartUiObserver() {
    if (!canObserveCartUi()) {
      stopCartUiObserver();
      return;
    }

    if (!state.domObserver) {
      state.domObserver = new MutationObserver((mutations) => {
        if (!state.lastCart) {
          return;
        }

        const hasRelevantChanges = mutations.some((mutation) => {
          if (mutation.type !== "childList") {
            return false;
          }

          return Boolean(
            (mutation.addedNodes && mutation.addedNodes.length) ||
              (mutation.removedNodes && mutation.removedNodes.length),
          );
        });

        if (!hasRelevantChanges || state.domMutationRefreshQueued) {
          return;
        }

        state.domMutationRefreshQueued = true;
        Promise.resolve().then(() => {
          state.domMutationRefreshQueued = false;
          scheduleUiRefresh("dom-mutation");
        });
      });
    }

    refreshCartUiObserverTargets();
  }

  function stopCartUiObserver() {
    if (state.domObserver) {
      state.domObserver.disconnect();
    }
    state.domObserverTargets = [];
    state.domObserverTargetSignature = "";
    state.domMutationRefreshQueued = false;
  }

  function getCartUiObserverTargets() {
    const targets = [];
    const mainCartHost = document.querySelector("[data-main-cart-section-id]");
    const mainCartSection =
      (mainCartHost instanceof Element && mainCartHost.closest(".shopify-section")) ||
      (mainCartHost instanceof Element ? mainCartHost : null) ||
      document.querySelector(".shopify-section--main-cart");

    if (isCartPagePath() && mainCartSection instanceof Element) {
      targets.push(mainCartSection);
    }

    const drawerElement = resolveCartDrawerElement();
    if (drawerElement instanceof HTMLElement && drawerElement.hasAttribute("open")) {
      const drawerInner = drawerElement.querySelector(".cart-drawer__inner");
      targets.push(drawerInner instanceof Element ? drawerInner : drawerElement);
    }

    return Array.from(new Set(targets.filter((target) => target instanceof Element)));
  }

  function getObserverTargetSignature(target) {
    if (!(target instanceof Element)) {
      return "";
    }

    const id = String(target.id || "").trim();
    if (id) {
      return `id:${id}`;
    }

    const sectionId = String(target.getAttribute("data-section-id") || target.getAttribute("data-main-cart-section-id") || "").trim();
    if (sectionId) {
      return `section:${sectionId}`;
    }

    const className = String(target.className || "").trim();
    return `node:${target.tagName.toLowerCase()}:${className}`;
  }

  function refreshCartUiObserverTargets() {
    if (!state.domObserver) {
      return;
    }

    if (!canObserveCartUi()) {
      stopCartUiObserver();
      return;
    }

    const targets = getCartUiObserverTargets();
    const signature = targets.map((target) => getObserverTargetSignature(target)).join("|");
    const previousTargets = Array.isArray(state.domObserverTargets) ? state.domObserverTargets : [];
    const sameTargets =
      signature === state.domObserverTargetSignature &&
      previousTargets.length === targets.length &&
      previousTargets.every((target, index) => target === targets[index]);
    if (sameTargets) {
      return;
    }

    state.domObserver.disconnect();
    targets.forEach((target) => {
      state.domObserver.observe(target, {
        childList: true,
        subtree: true,
      });
    });
    state.domObserverTargets = targets;
    state.domObserverTargetSignature = signature;
  }

  function buildCartDomSnapshot() {
    const lineElements = Array.from(document.querySelectorAll("line-item[data-line-key]"));
    const lineElementsByKey = {};
    lineElements.forEach((lineElement) => {
      const lineKey = String(lineElement.getAttribute("data-line-key") || "").trim();
      if (!lineKey) {
        return;
      }

      lineElementsByKey[lineKey] = lineElementsByKey[lineKey] || [];
      lineElementsByKey[lineKey].push(lineElement);
    });

    return {
      lineElements,
      lineElementsByKey,
    };
  }

  function refreshUiFromState() {
    if (!state.lastCart) {
      return;
    }

    ensureKlarnaPlacementsLocale(document);
    const domSnapshot = buildCartDomSnapshot();

    const config = getConfig();
    try {
      renderProgressUI(state.lastCart, config);
    } catch (error) {
      reportError(error, "Nu am putut actualiza progresul din cos.");
    }

    try {
      renderCompactGiftLines(state.lastCart, domSnapshot);
      applyPendingManagedHiddenState(domSnapshot);
    } catch (error) {
      reportError(error, "Nu am putut compacta afisarea cadourilor din cos.");
    }

    try {
      renderFeeAttachments(state.lastCart, config, domSnapshot);
    } catch (error) {
      reportError(error, "Nu am putut actualiza afisarea taxelor din cos.");
    }

    try {
      renderLubricationAttachments(state.lastCart, getLubricationConfig(), domSnapshot);
    } catch (error) {
      reportError(error, "Nu am putut actualiza afisarea lubrifierii din cos.");
    }

    try {
      renderGiftWrapUi(state.lastCart);
    } catch (error) {
      reportError(error, "Nu am putut actualiza optiunea de impachetare cadou.");
    }

    try {
      renderPackageInsuranceUi(state.lastCart);
    } catch (error) {
      reportError(error, "Nu am putut actualiza optiunea de asigurare colet.");
    }

    applyProcessingLineState(domSnapshot);
  }

  function scheduleUiRefresh(reason) {
    if (!state.lastCart) {
      return;
    }

    if (state.uiRefreshFrame) {
      return;
    }

    const scheduleFrame = typeof window.requestAnimationFrame === "function"
      ? window.requestAnimationFrame.bind(window)
      : (callback) => window.setTimeout(callback, 16);
    state.uiRefreshFrame = scheduleFrame(() => {
      state.uiRefreshFrame = 0;
      debugLog("[qk-cart-rules] UI refresh", reason || "scheduled");
      refreshUiFromState();
    });
  }

  function onExternalCartChange(event) {
    const baseEvent = String(event && event.detail && event.detail.baseEvent ? event.detail.baseEvent : "");
    const incomingCartRaw = event && event.detail ? event.detail.cart : state.lastCart;
    const incomingCart = normalizeCartPayload(incomingCartRaw);

    if (incomingCart) {
      state.lastCart = incomingCart;
      scheduleUiRefresh("cart-change");
    }

    const isPackedVariantAdd = baseEvent === "qk:variant:add-packed";
    if (baseEvent.startsWith("qk:") && !isPackedVariantAdd) {
      return;
    }

    const isVariantAdd = baseEvent === "variant:add";
    const cartUiActive = canObserveCartUi();
    const isCartPage = isCartPagePath();
    if (!cartUiActive && !isCartPage) {
      if ((isVariantAdd || isPackedVariantAdd) && incomingCart) {
        state.queuedSeedCart = incomingCart;
      }
      return;
    }

    const shouldPrioritizeSync = isVariantAdd || isPackedVariantAdd;
    scheduleSync("external-cart-change", incomingCart, shouldPrioritizeSync ? 40 : undefined);
  }

  function onPageShow(event) {
    if (!isCartPagePath()) {
      return;
    }

    if (event && event.persisted) {
      activateCartSync("pageshow-persisted", null, 0);
      return;
    }

    queueCartPageBootSync("pageshow", getPreferredCartPageSeed(), 40);
  }

  function onWindowLoad() {
    if (!isCartPagePath()) {
      return;
    }

    queueCartPageBootSync("window-load", getPreferredCartPageSeed(), 80);
  }

  async function handleQuantityDelta(lineKey, delta) {
    const deltaValue = Number(delta);
    if (!lineKey || !Number.isFinite(deltaValue) || deltaValue === 0) {
      return;
    }

    const intendedQuantity = state.latestIntendedLineQuantities[String(lineKey || "").trim()];
    let currentQuantity = Number.isFinite(intendedQuantity) ? Math.max(0, parseInteger(intendedQuantity)) : 0;
    const lineFromCart = findLineByKey(state.lastCart, lineKey);
    if (lineFromCart && !Number.isFinite(intendedQuantity)) {
      currentQuantity = Math.max(0, parseInteger(lineFromCart.quantity));
    } else {
      const matchingInput = findQuantityInputByLineKey(lineKey);
      if (matchingInput && !Number.isFinite(intendedQuantity)) {
        currentQuantity = Math.max(0, parseInteger(matchingInput.value));
      }
    }

    const targetQuantity = Math.max(0, currentQuantity + Math.trunc(deltaValue));
    await changeLineQuantity(lineKey, targetQuantity, "line-item:button");
  }

  async function changeLineQuantity(lineKey, quantity, reason) {
    const targetQuantity = Math.max(0, parseInteger(quantity));
    const normalizedReason = reason || "line-item:change";

    if (targetQuantity === 0) {
      const line = findLineByKey(state.lastCart, lineKey);
      if (line && isManagedGiftWrapLine(line)) {
        try {
          await setGiftWrapSelection(false, {
            reason: "gift-wrap-line-remove-intent",
          });
        } catch (error) {
          debugLog("[qk-cart-rules] gift-wrap deselect before removal failed", error);
        }
      }
      if (line && isManagedPackageInsuranceLine(line)) {
        try {
          await setPackageInsuranceSelection(false, {
            reason: "package-insurance-line-remove-intent",
          });
        } catch (error) {
          debugLog("[qk-cart-rules] package insurance deselect before removal failed", error);
        }
      }
    }

    const impactedLineItems = findLineItemElementsByKey(lineKey);
    impactedLineItems.forEach((element) => {
      element.dispatchEvent(
        new CustomEvent("line-item:will-change", {
          bubbles: true,
          detail: { targetQuantity },
        }),
      );
    });

    try {
      await enqueueLineMutation({
        lineKey,
        targetQuantity,
        reason: normalizedReason,
        impactedLineItems,
      });
    } catch (error) {
      reportError(error, "Nu am putut actualiza cantitatea in cos.");
      impactedLineItems.forEach((element) => {
        element.dispatchEvent(
          new CustomEvent("line-item:change", {
            bubbles: true,
            detail: {
              quantity: targetQuantity,
              cart: state.lastCart || { items: [] },
            },
          }),
        );
      });
    }
  }

  function onQuantityInputChanged(event) {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) {
      return;
    }

    if (!target.matches("input[data-line-key]")) {
      return;
    }

    if (!event.isTrusted || target.readOnly || target.disabled) {
      return;
    }

    const lineKey = target.dataset.lineKey;
    if (!lineKey) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const quantity = Math.max(0, parseInteger(target.value));
    target.value = String(quantity);
    void changeLineQuantity(lineKey, quantity, "line-item:manual-input");
  }

  function onRemoveLinkClicked(event) {
    const target = resolveEventTargetElement(event);
    if (!(target instanceof Element)) {
      return;
    }

    const link = target.closest('a[href*="/cart/change"]');
    if (!(link instanceof HTMLAnchorElement)) {
      return;
    }

    if (!isInsideCartUI(link)) {
      return;
    }

    let url;
    try {
      url = new URL(link.href, window.location.origin);
    } catch {
      return;
    }

    if (!url.pathname.includes("/cart/change")) {
      return;
    }

    const lineKey = url.searchParams.get("id");
    const quantity = parseInteger(url.searchParams.get("quantity"));
    if (!lineKey) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    void changeLineQuantity(lineKey, Math.max(0, quantity), "line-item:remove-link");
  }

  function onLubricationAttachmentRemoveClick(event) {
    const target = resolveEventTargetElement(event);
    if (!(target instanceof Element)) {
      return;
    }

    const removeTrigger = target.closest(
      "[data-qk-lube-remove], .qk-lube-attachment__remove, [data-qk-lube-attachment] a, [data-qk-lube-attachment] button",
    );
    if (!(removeTrigger instanceof HTMLElement)) {
      return;
    }

    const isKnownRemoveControl = removeTrigger.matches("[data-qk-lube-remove], .qk-lube-attachment__remove");
    if (!isKnownRemoveControl) {
      const triggerText = String(removeTrigger.textContent || "").trim().toLowerCase();
      if (!triggerText.includes("elimina")) {
        return;
      }
    }

    const isPointerDown = event.type === "pointerdown";
    if (isPointerDown && typeof event.button === "number" && event.button !== 0) {
      return;
    }

    if (removeTrigger.getAttribute("data-qk-lube-removing") === "1") {
      if (event.type === "click") {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === "function") {
          event.stopImmediatePropagation();
        }
      }
      return;
    }

    if (removeTrigger.getAttribute("aria-disabled") === "true") {
      return;
    }

    const attachment = removeTrigger.closest("[data-qk-lube-attachment]");
    if (!(attachment instanceof HTMLElement)) {
      return;
    }

    if (!isInsideCartUI(attachment)) {
      return;
    }

    const parentLineFromAttachment = String(attachment.getAttribute("data-qk-parent-line-key") || "").trim();
    const managedLineKey = String(attachment.getAttribute("data-qk-managed-line-key") || "").trim();
    const fallbackParentLineElement = attachment.closest('line-item[data-line-key]');
    const fallbackParentLineKey = fallbackParentLineElement instanceof HTMLElement
      ? String(fallbackParentLineElement.getAttribute("data-line-key") || "").trim()
      : "";
    const parentVariantLegacyId = fallbackParentLineElement instanceof HTMLElement
      ? normalizeLegacyId(String(fallbackParentLineElement.getAttribute("data-variant-legacy-id") || "").trim())
      : "";
    const parentLineKey = parentLineFromAttachment || fallbackParentLineKey;
    if (!parentLineKey && !managedLineKey) {
      return;
    }

    const managedRuleKey = String(attachment.getAttribute("data-qk-lube-rule") || "").trim();

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === "function") {
      event.stopImmediatePropagation();
    }

    queueLubricationRemovalIntent({
      parentLineKey,
      parentVariantLegacyId,
      managedLineKey,
      managedRuleKey,
    });

    removeTrigger.setAttribute("data-qk-lube-removing", "1");

    void removeLubricationFromParentLine({
      parentLineKey,
      parentVariantLegacyId,
      managedLineKey,
      managedRuleKey,
      trigger: removeTrigger,
      attachmentElement: attachment,
    });
  }

  function onGiftWrapUiClick(event) {
    const target = resolveEventTargetElement(event);
    if (!(target instanceof Element)) {
      return;
    }

    const toggleButton = target.closest("[data-qk-gift-wrap-toggle]");
    if (toggleButton instanceof HTMLButtonElement) {
      if (toggleButton.disabled || toggleButton.getAttribute("aria-disabled") === "true" || isGiftWrapControlBusy()) {
        return;
      }

      const mount = toggleButton.closest("[data-qk-gift-wrap-mount]");
      const modalContext = mount ? mount.getAttribute("data-qk-gift-wrap-mount") : "";
      const isSelected = toggleButton.getAttribute("aria-pressed") === "true";
      event.preventDefault();
      event.stopPropagation();

      if (isSelected) {
        closeGiftWrapModal({ restoreFocus: false });
        void setGiftWrapSelection(false, {
          reason: "gift-wrap-toggle-off",
          context: modalContext,
        });
        return;
      }

      if (!state.lastCart) {
        activateCartSync("gift-wrap-toggle-open", null, 0);
      }
      openGiftWrapModal(modalContext);
      return;
    }

    const closeTrigger = target.closest("[data-qk-gift-wrap-modal-close]");
    if (closeTrigger) {
      event.preventDefault();
      event.stopPropagation();
      closeGiftWrapModal({ restoreFocus: true });
      return;
    }

    const cancelTrigger = target.closest("[data-qk-gift-wrap-modal-cancel]");
    if (cancelTrigger) {
      event.preventDefault();
      event.stopPropagation();
      closeGiftWrapModal({ restoreFocus: true });
      return;
    }

    const confirmTrigger = target.closest("[data-qk-gift-wrap-modal-confirm]");
    if (confirmTrigger instanceof HTMLButtonElement) {
      if (confirmTrigger.disabled || isGiftWrapControlBusy()) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      markPerf("gift-wrap-add-click");
      markPerf("gift-wrap-add-click-line");
      state.giftWrapAddPerfPending = true;
      state.giftWrapConfirmBusy = true;
      scheduleUiRefresh("gift-wrap-modal-confirm-start");
      const scheduleFrame = typeof window.requestAnimationFrame === "function"
        ? window.requestAnimationFrame.bind(window)
        : (callback) => window.setTimeout(callback, 16);
      scheduleFrame(() => {
        markPerf("gift-wrap-spinner-painted");
        measurePerf("gift-wrap-add-click-to-spinner", "gift-wrap-add-click", "gift-wrap-spinner-painted");
      });
      void setGiftWrapSelection(true, {
        reason: "gift-wrap-modal-confirm",
        context: state.giftWrapModalContext,
      });
    }
  }

  function onGiftWrapModalKeyDown(event) {
    if (!state.giftWrapModalOpen) {
      return;
    }

    const modal = document.getElementById(GIFT_WRAP_MODAL_ELEMENT_ID);
    if (!(modal instanceof HTMLElement) || modal.hidden) {
      return;
    }

    if (event.key === "Escape") {
      event.preventDefault();
      closeGiftWrapModal({ restoreFocus: true });
      return;
    }

    if (event.key !== "Tab") {
      return;
    }

    const focusable = getGiftWrapFocusableElements(modal);
    if (!focusable.length) {
      event.preventDefault();
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const active = document.activeElement;
    const isShift = Boolean(event.shiftKey);

    if (isShift && active === first) {
      event.preventDefault();
      last.focus();
      return;
    }

    if (!isShift && active === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function getGiftWrapFocusableElements(modal) {
    if (!(modal instanceof HTMLElement)) {
      return [];
    }

    return Array.from(
      modal.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
      ),
    ).filter((element) => element instanceof HTMLElement && !element.hidden && element.offsetParent !== null);
  }

  function onPackageInsuranceUiClick(event) {
    const target = resolveEventTargetElement(event);
    if (!(target instanceof Element)) {
      return;
    }

    const toggleButton = target.closest("[data-qk-package-insurance-toggle]");
    if (toggleButton instanceof HTMLButtonElement) {
      if (
        toggleButton.disabled ||
        toggleButton.getAttribute("aria-disabled") === "true" ||
        isPackageInsuranceControlBusy()
      ) {
        return;
      }

      const mount = toggleButton.closest("[data-qk-package-insurance-mount]");
      const modalContext = mount ? mount.getAttribute("data-qk-package-insurance-mount") : "";
      const isSelected = toggleButton.getAttribute("aria-pressed") === "true";
      event.preventDefault();
      event.stopPropagation();

      if (isSelected) {
        closePackageInsuranceModal({ restoreFocus: false });
        void setPackageInsuranceSelection(false, {
          reason: "package-insurance-toggle-off",
          context: modalContext,
        });
        return;
      }

      if (!state.lastCart) {
        activateCartSync("package-insurance-toggle-open", null, 0);
      }
      openPackageInsuranceModal(modalContext);
      return;
    }

    const closeTrigger = target.closest("[data-qk-package-insurance-modal-close]");
    if (closeTrigger) {
      event.preventDefault();
      event.stopPropagation();
      closePackageInsuranceModal({ restoreFocus: true });
      return;
    }

    const cancelTrigger = target.closest("[data-qk-package-insurance-modal-cancel]");
    if (cancelTrigger) {
      event.preventDefault();
      event.stopPropagation();
      closePackageInsuranceModal({ restoreFocus: true });
      return;
    }

    const confirmTrigger = target.closest("[data-qk-package-insurance-modal-confirm]");
    if (confirmTrigger instanceof HTMLButtonElement) {
      if (confirmTrigger.disabled || isPackageInsuranceControlBusy()) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      markPerf("package-insurance-add-click");
      markPerf("package-insurance-add-click-line");
      state.packageInsuranceAddPerfPending = true;
      state.packageInsuranceConfirmBusy = true;
      scheduleUiRefresh("package-insurance-modal-confirm-start");
      const scheduleFrame = typeof window.requestAnimationFrame === "function"
        ? window.requestAnimationFrame.bind(window)
        : (callback) => window.setTimeout(callback, 16);
      scheduleFrame(() => {
        markPerf("package-insurance-spinner-painted");
        measurePerf(
          "package-insurance-add-click-to-spinner",
          "package-insurance-add-click",
          "package-insurance-spinner-painted",
        );
      });
      void setPackageInsuranceSelection(true, {
        reason: "package-insurance-modal-confirm",
        context: state.packageInsuranceModalContext,
      });
    }
  }

  function onPackageInsuranceModalKeyDown(event) {
    if (!state.packageInsuranceModalOpen) {
      return;
    }

    const modal = document.getElementById(PACKAGE_INSURANCE_MODAL_ELEMENT_ID);
    if (!(modal instanceof HTMLElement) || modal.hidden) {
      return;
    }

    if (event.key === "Escape") {
      event.preventDefault();
      closePackageInsuranceModal({ restoreFocus: true });
      return;
    }

    if (event.key !== "Tab") {
      return;
    }

    const focusable = getPackageInsuranceFocusableElements(modal);
    if (!focusable.length) {
      event.preventDefault();
      return;
    }

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const active = document.activeElement;
    const isShift = Boolean(event.shiftKey);

    if (isShift && active === first) {
      event.preventDefault();
      last.focus();
      return;
    }

    if (!isShift && active === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function getPackageInsuranceFocusableElements(modal) {
    if (!(modal instanceof HTMLElement)) {
      return [];
    }

    return Array.from(
      modal.querySelectorAll(
        'button:not([disabled]), [href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
      ),
    ).filter((element) => element instanceof HTMLElement && !element.hidden && element.offsetParent !== null);
  }

  function openGiftWrapModal(context) {
    if (state.giftWrapModalOpen) {
      return;
    }
    if (state.packageInsuranceModalOpen) {
      closePackageInsuranceModal({ restoreFocus: false });
    }

    markPerf("gift-wrap-modal-open");
    warmGiftWrapProductState({ immediate: true });
    state.giftWrapModalContext = normalizeGiftWrapModalContext(context);
    const modal = ensureGiftWrapModalElement();
    if (!(modal instanceof HTMLElement)) {
      return;
    }

    state.giftWrapModalLastActiveElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;
    modal.hidden = false;
    modal.setAttribute("aria-hidden", "false");
    state.giftWrapModalOpen = true;
    updateCartAddonModalBodyState();

    const focusable = getGiftWrapFocusableElements(modal);
    if (focusable.length) {
      focusable[0].focus();
    } else {
      const dialog = modal.querySelector(".qk-gift-wrap-modal__dialog");
      if (dialog instanceof HTMLElement) {
        dialog.focus();
      }
    }
  }

  function closeGiftWrapModal(options) {
    const normalizedOptions = options || {};
    const shouldRestoreFocus = normalizedOptions.restoreFocus !== false;
    const modal = document.getElementById(GIFT_WRAP_MODAL_ELEMENT_ID);
    if (!(modal instanceof HTMLElement)) {
      state.giftWrapModalOpen = false;
      updateCartAddonModalBodyState();
      return;
    }

    modal.hidden = true;
    modal.setAttribute("aria-hidden", "true");
    state.giftWrapModalOpen = false;
    updateCartAddonModalBodyState();

    if (!shouldRestoreFocus) {
      return;
    }

    const lastActive = state.giftWrapModalLastActiveElement;
    if (lastActive instanceof HTMLElement && lastActive.isConnected) {
      lastActive.focus();
    }
  }

  function updateCartAddonModalBodyState() {
    const shouldLock = Boolean(state.giftWrapModalOpen || state.packageInsuranceModalOpen);
    document.body.classList.toggle("qk-gift-wrap-modal-open", shouldLock);
  }

  function ensureGiftWrapModalElement() {
    const modalHost = resolveGiftWrapModalHost();
    let modal = document.getElementById(GIFT_WRAP_MODAL_ELEMENT_ID);
    if (modal instanceof HTMLElement) {
      if (modalHost instanceof HTMLElement && modal.parentElement !== modalHost) {
        modalHost.appendChild(modal);
      }
      modal.classList.toggle("qk-gift-wrap-modal--drawer", state.giftWrapModalContext === "drawer");
      return modal;
    }

    modal = document.createElement("div");
    modal.id = GIFT_WRAP_MODAL_ELEMENT_ID;
    modal.className = "qk-gift-wrap-modal";
    modal.classList.toggle("qk-gift-wrap-modal--drawer", state.giftWrapModalContext === "drawer");
    modal.hidden = true;
    modal.setAttribute("aria-hidden", "true");
    modal.innerHTML = `
      <div class="qk-gift-wrap-modal__backdrop" data-qk-gift-wrap-modal-close></div>
      <div class="qk-gift-wrap-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="qk-gift-wrap-modal-heading" tabindex="-1">
        <button type="button" class="qk-gift-wrap-modal__close" aria-label="Inchide" data-qk-gift-wrap-modal-close>
          <span class="qk-gift-wrap-modal__close-icon" aria-hidden="true"></span>
        </button>
        <div class="qk-gift-wrap-modal__layout">
          <div class="qk-gift-wrap-modal__media">
            <img data-qk-gift-wrap-modal-image alt="" loading="lazy" decoding="async">
          </div>
          <div class="qk-gift-wrap-modal__content">
            <h3 class="qk-gift-wrap-modal__heading" id="qk-gift-wrap-modal-heading">🎁 Impachetare Cadou?</h3>
            <p class="qk-gift-wrap-modal__title" data-qk-gift-wrap-modal-title></p>
            <p class="qk-gift-wrap-modal__price" data-qk-gift-wrap-modal-price></p>
            <p class="qk-gift-wrap-modal__description" data-qk-gift-wrap-modal-description></p>
            <div class="qk-gift-wrap-modal__actions">
              <button type="button" class="button button--secondary" data-qk-gift-wrap-modal-cancel>Anuleaza</button>
              <button type="button" class="button" data-qk-gift-wrap-modal-confirm>
                <span class="qk-gift-wrap-modal__confirm-label">Adauga</span>
                <span class="qk-gift-wrap-modal__confirm-spinner" aria-hidden="true"></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    `;

    if (modalHost instanceof HTMLElement) {
      modalHost.appendChild(modal);
    } else {
      document.body.appendChild(modal);
    }
    return modal;
  }

  function normalizeGiftWrapModalContext(value) {
    const normalized = String(value == null ? "" : value).trim().toLowerCase();
    return normalized === "drawer" ? "drawer" : "page";
  }

  function resolveGiftWrapModalHost() {
    if (state.giftWrapModalContext === "drawer") {
      const drawerHost =
        document.querySelector("cart-drawer#cart-drawer[open]") ||
        document.querySelector("cart-drawer#cart-drawer") ||
        document.querySelector("cart-drawer[open]") ||
        document.querySelector("cart-drawer");

      if (drawerHost instanceof HTMLElement && drawerHost.isConnected) {
        return drawerHost;
      }
    }

    return document.body;
  }

  function openPackageInsuranceModal(context) {
    if (state.packageInsuranceModalOpen) {
      return;
    }
    if (state.giftWrapModalOpen) {
      closeGiftWrapModal({ restoreFocus: false });
    }

    markPerf("package-insurance-modal-open");
    warmPackageInsuranceProductState({ immediate: true });
    state.packageInsuranceModalContext = normalizePackageInsuranceModalContext(context);
    const modal = ensurePackageInsuranceModalElement();
    if (!(modal instanceof HTMLElement)) {
      return;
    }

    state.packageInsuranceModalLastActiveElement =
      document.activeElement instanceof HTMLElement ? document.activeElement : null;
    modal.hidden = false;
    modal.setAttribute("aria-hidden", "false");
    state.packageInsuranceModalOpen = true;
    updateCartAddonModalBodyState();

    const focusable = getPackageInsuranceFocusableElements(modal);
    if (focusable.length) {
      focusable[0].focus();
    } else {
      const dialog = modal.querySelector(".qk-gift-wrap-modal__dialog");
      if (dialog instanceof HTMLElement) {
        dialog.focus();
      }
    }
  }

  function closePackageInsuranceModal(options) {
    const normalizedOptions = options || {};
    const shouldRestoreFocus = normalizedOptions.restoreFocus !== false;
    const modal = document.getElementById(PACKAGE_INSURANCE_MODAL_ELEMENT_ID);
    if (!(modal instanceof HTMLElement)) {
      state.packageInsuranceModalOpen = false;
      updateCartAddonModalBodyState();
      return;
    }

    modal.hidden = true;
    modal.setAttribute("aria-hidden", "true");
    state.packageInsuranceModalOpen = false;
    updateCartAddonModalBodyState();

    if (!shouldRestoreFocus) {
      return;
    }

    const lastActive = state.packageInsuranceModalLastActiveElement;
    if (lastActive instanceof HTMLElement && lastActive.isConnected) {
      lastActive.focus();
    }
  }

  function ensurePackageInsuranceModalElement() {
    const modalHost = resolvePackageInsuranceModalHost();
    let modal = document.getElementById(PACKAGE_INSURANCE_MODAL_ELEMENT_ID);
    if (modal instanceof HTMLElement) {
      if (modalHost instanceof HTMLElement && modal.parentElement !== modalHost) {
        modalHost.appendChild(modal);
      }
      modal.classList.toggle("qk-gift-wrap-modal--drawer", state.packageInsuranceModalContext === "drawer");
      return modal;
    }

    modal = document.createElement("div");
    modal.id = PACKAGE_INSURANCE_MODAL_ELEMENT_ID;
    modal.className = "qk-gift-wrap-modal";
    modal.classList.toggle("qk-gift-wrap-modal--drawer", state.packageInsuranceModalContext === "drawer");
    modal.hidden = true;
    modal.setAttribute("aria-hidden", "true");
    modal.innerHTML = `
      <div class="qk-gift-wrap-modal__backdrop" data-qk-package-insurance-modal-close></div>
      <div class="qk-gift-wrap-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="qk-package-insurance-modal-heading" tabindex="-1">
        <button type="button" class="qk-gift-wrap-modal__close" aria-label="Inchide" data-qk-package-insurance-modal-close>
          <span class="qk-gift-wrap-modal__close-icon" aria-hidden="true"></span>
        </button>
        <div class="qk-gift-wrap-modal__layout">
          <div class="qk-gift-wrap-modal__media">
            <img data-qk-package-insurance-modal-image alt="" loading="lazy" decoding="async">
          </div>
          <div class="qk-gift-wrap-modal__content">
            <h3 class="qk-gift-wrap-modal__heading" id="qk-package-insurance-modal-heading">🛡️ Asigurare Colet?</h3>
            <p class="qk-gift-wrap-modal__title" data-qk-package-insurance-modal-title></p>
            <p class="qk-gift-wrap-modal__price" data-qk-package-insurance-modal-price></p>
            <p class="qk-gift-wrap-modal__description" data-qk-package-insurance-modal-description></p>
            <div class="qk-gift-wrap-modal__actions">
              <button type="button" class="button button--secondary" data-qk-package-insurance-modal-cancel>Anuleaza</button>
              <button type="button" class="button" data-qk-package-insurance-modal-confirm>
                <span class="qk-gift-wrap-modal__confirm-label">Adauga</span>
                <span class="qk-gift-wrap-modal__confirm-spinner" aria-hidden="true"></span>
              </button>
            </div>
          </div>
        </div>
      </div>
    `;

    if (modalHost instanceof HTMLElement) {
      modalHost.appendChild(modal);
    } else {
      document.body.appendChild(modal);
    }
    return modal;
  }

  function normalizePackageInsuranceModalContext(value) {
    const normalized = String(value == null ? "" : value).trim().toLowerCase();
    return normalized === "drawer" ? "drawer" : "page";
  }

  function resolvePackageInsuranceModalHost() {
    if (state.packageInsuranceModalContext === "drawer") {
      const drawerHost =
        document.querySelector("cart-drawer#cart-drawer[open]") ||
        document.querySelector("cart-drawer#cart-drawer") ||
        document.querySelector("cart-drawer[open]") ||
        document.querySelector("cart-drawer");

      if (drawerHost instanceof HTMLElement && drawerHost.isConnected) {
        return drawerHost;
      }
    }

    return document.body;
  }

  function resolveCartDrawerElement() {
    const drawerElement =
      document.querySelector("cart-drawer#cart-drawer") ||
      document.querySelector("cart-drawer");
    return drawerElement instanceof HTMLElement ? drawerElement : null;
  }

  function restoreCartDrawerOpenStateIfNeeded(drawerElement, wasOpen) {
    if (!(drawerElement instanceof HTMLElement) || !wasOpen || drawerElement.hasAttribute("open")) {
      return;
    }

    try {
      if (typeof drawerElement.show === "function") {
        drawerElement.show(false);
      } else {
        drawerElement.setAttribute("open", "");
      }
    } catch (error) {
      debugLog("[qk-cart-rules] failed to restore cart drawer open state", error);
    }
  }

  async function removeLubricationFromParentLine(input) {
    const payload = input && typeof input === "object" ? input : {};
    const parentLineKey = String(payload.parentLineKey || "").trim();
    const parentVariantLegacyId = normalizeLegacyId(payload.parentVariantLegacyId);
    const managedLineKey = String(payload.managedLineKey || "").trim();
    const managedRuleKey = String(payload.managedRuleKey || "").trim();
    const trigger = payload.trigger instanceof HTMLElement ? payload.trigger : null;
    const attachmentElement = payload.attachmentElement instanceof HTMLElement ? payload.attachmentElement : null;

    if (!parentLineKey && !managedLineKey) {
      return;
    }

    // Prevent stale PDP intent from re-selecting lubrication right after cart removal.
    clearPendingLubricationIntentSnapshot();

    if (trigger) {
      if (trigger instanceof HTMLButtonElement) {
        trigger.disabled = true;
      }
      trigger.setAttribute("aria-disabled", "true");
    }
    if (attachmentElement) {
      attachmentElement.setAttribute("aria-busy", "true");
    }

    const previousProcessingLookup = Object.assign({}, safeObject(state.processingLineKeys));
    const nextProcessingLookup = Object.assign({}, previousProcessingLookup);
    if (parentLineKey) {
      nextProcessingLookup[parentLineKey] = true;
    }
    state.processingLineKeys = nextProcessingLookup;
    applyProcessingLineState();

    try {
      await flushPendingLineMutations();

      let baseCart = normalizeCartPayload(state.lastCart) || null;
      if (!baseCart) {
        try {
          baseCart = normalizeCartPayload(await fetchCartJson()) || null;
          if (baseCart) {
            state.lastCart = baseCart;
          }
        } catch (initialRefreshError) {
          debugLog("[qk-cart-rules] initial lube remove cart fetch failed", initialRefreshError);
        }
      }

      if (!baseCart) {
        scheduleSync("lube-remove-no-cart", null);
        return;
      }

      let initialTargets = resolveLubricationRemovalTargets(baseCart, {
        parentLineKey,
        parentVariantLegacyId,
        managedLineKey,
        managedRuleKey,
      });

      if (!initialTargets.parentLine && !initialTargets.managedLineKey) {
        try {
          const refreshedCart = normalizeCartPayload(await fetchCartJson()) || null;
          if (refreshedCart) {
            baseCart = refreshedCart;
            state.lastCart = refreshedCart;
            initialTargets = resolveLubricationRemovalTargets(baseCart, {
              parentLineKey,
              parentVariantLegacyId,
              managedLineKey,
              managedRuleKey,
            });
          }
        } catch (refreshForTargetsError) {
          debugLog("[qk-cart-rules] lube remove target refresh failed", refreshForTargetsError);
        }
      }

      let resolvedParentLine = initialTargets.parentLine;
      let resolvedParentLineKey = String((resolvedParentLine && resolvedParentLine.key) || parentLineKey).trim();

      if (!resolvedParentLine || !resolvedParentLineKey) {
        if (initialTargets.managedLineKey) {
          try {
            const managedOnlyCart = await requestCartLineChangeWithFallback(baseCart, {
              lineKey: initialTargets.managedLineKey,
              quantity: 0,
            });
            const normalizedManagedOnlyCart = normalizeCartPayload(managedOnlyCart) || normalizeCartPayload(baseCart) || state.lastCart;
            if (normalizedManagedOnlyCart) {
              state.lastCart = normalizedManagedOnlyCart;
            }
            scheduleSync("lube-remove-managed-only", normalizedManagedOnlyCart || baseCart || null);
            return;
          } catch (managedOnlyRemovalError) {
            debugLog("[qk-cart-rules] managed-only lube removal failed", managedOnlyRemovalError);
          }
        }
        scheduleSync("lube-remove-parent-missing", baseCart || null);
        return;
      }

      if (!nextProcessingLookup[resolvedParentLineKey]) {
        const refreshedProcessingLookup = Object.assign({}, safeObject(state.processingLineKeys), {
          [resolvedParentLineKey]: true,
        });
        state.processingLineKeys = refreshedProcessingLookup;
        applyProcessingLineState();
      }

      const parentQuantity = Math.max(1, parseInteger(resolvedParentLine.quantity));
      const deselectedProperties = buildLubricationSelectionProperties({
        selected: false,
        scope: "",
        ruleKey: "",
        layoutAlias: "",
      });
      const mergedParentProperties = Object.assign(
        {},
        stripPublicLubricationProperties(resolvedParentLine && resolvedParentLine.properties),
        deselectedProperties,
      );

      let updatedCart = null;
      try {
        updatedCart = await requestCartLineChangeWithFallback(baseCart, {
          lineKey: resolvedParentLineKey,
          quantity: parentQuantity,
          properties: mergedParentProperties,
        });
      } catch (parentChangeError) {
        let retried = false;
        try {
          const refreshedCart = normalizeCartPayload(await fetchCartJson()) || null;
          if (refreshedCart) {
            baseCart = refreshedCart;
            state.lastCart = refreshedCart;
            const retryTargets = resolveLubricationRemovalTargets(baseCart, {
              parentLineKey,
              parentVariantLegacyId,
              managedLineKey,
              managedRuleKey,
            });
            const retryParentLine = retryTargets.parentLine;
            const retryParentLineKey = String((retryParentLine && retryParentLine.key) || "").trim();
            if (retryParentLine && retryParentLineKey) {
              resolvedParentLine = retryParentLine;
              resolvedParentLineKey = retryParentLineKey;
              const retryParentQuantity = Math.max(1, parseInteger(retryParentLine.quantity));
              const retryMergedParentProperties = Object.assign(
                {},
                stripPublicLubricationProperties(retryParentLine && retryParentLine.properties),
                deselectedProperties,
              );
              updatedCart = await requestCartLineChangeWithFallback(baseCart, {
                lineKey: retryParentLineKey,
                quantity: retryParentQuantity,
                properties: retryMergedParentProperties,
              });
              retried = true;
            }
          }
        } catch (retryParentChangeError) {
          debugLog("[qk-cart-rules] lube remove parent retry failed", retryParentChangeError);
        }

        if (!retried || !updatedCart) {
          throw parentChangeError;
        }
      }

      let normalizedCart = normalizeCartPayload(updatedCart) || normalizeCartPayload(baseCart) || state.lastCart;
      const postParentTargets = resolveLubricationRemovalTargets(normalizedCart, {
        parentLineKey: resolvedParentLineKey,
        parentVariantLegacyId,
        managedLineKey: String((initialTargets.managedLine && initialTargets.managedLine.key) || managedLineKey).trim(),
        managedRuleKey: initialTargets.managedRuleKey || managedRuleKey,
      });
      const managedLineKeyToRemove = postParentTargets.managedLineKey;

      if (managedLineKeyToRemove) {
        try {
          updatedCart = await requestCartLineChangeWithFallback(normalizedCart, {
            lineKey: managedLineKeyToRemove,
            quantity: 0,
          });
          normalizedCart = normalizeCartPayload(updatedCart) || normalizedCart;
        } catch (managedRemovalError) {
          try {
            const refreshedCart = normalizeCartPayload(await fetchCartJson()) || null;
            if (refreshedCart) {
              state.lastCart = refreshedCart;
              const refreshedTargets = resolveLubricationRemovalTargets(refreshedCart, {
                parentLineKey: resolvedParentLineKey,
                parentVariantLegacyId,
                managedLineKey,
                managedRuleKey,
              });
              if (refreshedTargets.managedLineKey) {
                updatedCart = await requestCartLineChangeWithFallback(refreshedCart, {
                  lineKey: refreshedTargets.managedLineKey,
                  quantity: 0,
                });
                normalizedCart = normalizeCartPayload(updatedCart) || normalizeCartPayload(refreshedCart) || normalizedCart;
              }
            }
          } catch (managedRetryError) {
            debugLog("[qk-cart-rules] managed lube retry removal failed; fallback sync will reconcile", managedRetryError);
          }
          if (!normalizedCart) {
            debugLog("[qk-cart-rules] managed lube direct removal failed; fallback sync will reconcile", managedRemovalError);
          }
        }
      }

      if (normalizedCart) {
        state.lastCart = normalizedCart;
      }

      // Immediate DOM feedback — remove the attachment visually
      if (attachmentElement && attachmentElement.parentElement) {
        attachmentElement.remove();
      }
      const domManagedLineKey = String(managedLineKeyToRemove || managedLineKey).trim();
      if (domManagedLineKey) {
        document.querySelectorAll(
          'line-item[data-line-key="' + CSS.escape(domManagedLineKey) + '"]'
        ).forEach(function (el) {
          var container = getLineContainer(el);
          if (container) container.classList.add("qk-lube-line--hidden");
        });
      }

      try {
        await syncNow("lube-attachment-remove", {
          seedCart: normalizedCart,
          forceEmit: true,
          hardTimeoutMs: 12000,
        });
      } catch (syncAfterRemoveError) {
        debugLog("[qk-cart-rules] lube remove immediate sync failed; scheduling fallback sync", syncAfterRemoveError);
        scheduleSync("lube-attachment-remove-reconcile-fallback", normalizedCart || null);
      }
    } catch (error) {
      reportError(error, "Nu am putut elimina lubrifierea din cos.");
      scheduleSync("lube-attachment-remove-fallback", null);
    } finally {
      state.processingLineKeys = previousProcessingLookup;
      applyProcessingLineState();

      if (trigger && trigger.isConnected) {
        if (trigger instanceof HTMLButtonElement) {
          trigger.disabled = false;
        }
        trigger.removeAttribute("aria-disabled");
        trigger.removeAttribute("data-qk-lube-removing");
      }
      if (attachmentElement && attachmentElement.isConnected) {
        attachmentElement.removeAttribute("aria-busy");
      }
    }
  }

  function resolveLubricationRemovalTargets(cart, input) {
    const payload = input && typeof input === "object" ? input : {};
    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    const requestedParentLineKey = String(payload.parentLineKey || "").trim();
    const requestedParentVariantLegacyId = normalizeLegacyId(payload.parentVariantLegacyId);
    const requestedManagedLineKey = String(payload.managedLineKey || "").trim();
    const requestedRuleKey = String(payload.managedRuleKey || "").trim();
    const ruleMaps = buildLubricationRuleMaps(getLubricationConfig());

    let parentLine = requestedParentLineKey ? findLineByKey(cart, requestedParentLineKey) : null;
    let managedLine = requestedManagedLineKey ? findLineByKey(cart, requestedManagedLineKey) : null;

    if (!managedLine && requestedParentLineKey) {
      const managedBySource = getManagedLubricationLinesBySourceLineKey(items, requestedParentLineKey);
      if (managedBySource.length === 1) {
        managedLine = managedBySource[0];
      } else if (managedBySource.length > 1 && requestedRuleKey) {
        managedLine = managedBySource.find((line) => lineMatchesLubricationRule(line, requestedRuleKey, ruleMaps)) || null;
      }
    }

    if (!parentLine && requestedParentVariantLegacyId) {
      parentLine =
        items.find((line) => {
          return (
            isEligibleLubricationParentLine(line) &&
            normalizeLegacyId(line && line.variant_id) === requestedParentVariantLegacyId
          );
        }) || null;
    }

    const resolvedRuleKey = requestedRuleKey || getLubricationRuleKeyForLine(managedLine, ruleMaps);

    if (managedLine) {
      const resolvedSourceLineKey = resolveLubricationManagedSourceLineKey(items, managedLine, ruleMaps, {
        preferredParentLineKey: requestedParentLineKey,
      });
      if (resolvedSourceLineKey) {
        parentLine = findLineByKey(cart, resolvedSourceLineKey) || parentLine;
      }
    }

    if (!parentLine && managedLine) {
      const sourceLineKey = normalizeManagedSourceLineKey(getLineProperty(managedLine, ATTR_LUBE_SOURCE));
      const sourceVariantLegacyId =
        normalizeLegacyId(getLineProperty(managedLine, ATTR_LUBE_SOURCE_VARIANT)) ||
        extractVariantLegacyIdFromLineKey(sourceLineKey);
      if (sourceVariantLegacyId) {
        parentLine =
          items.find((line) => {
            return (
              isEligibleLubricationParentLine(line) &&
              normalizeLegacyId(line && line.variant_id) === sourceVariantLegacyId
            );
          }) || null;
      }
    }

    if (!parentLine && resolvedRuleKey) {
      parentLine = findBestLubricationParentLineByRule(items, resolvedRuleKey, ruleMaps, managedLine);
    }

    if (!managedLine && parentLine) {
      const managedBySource = getManagedLubricationLinesBySourceLineKey(items, String(parentLine.key || ""));
      if (managedBySource.length === 1) {
        managedLine = managedBySource[0];
      } else if (managedBySource.length > 1 && resolvedRuleKey) {
        managedLine = managedBySource.find((line) => lineMatchesLubricationRule(line, resolvedRuleKey, ruleMaps)) || null;
      }
    }

    if (!managedLine && resolvedRuleKey) {
      const managedByRule = items.filter((line) => {
        return isManagedLubricationLine(line) && lineMatchesLubricationRule(line, resolvedRuleKey, ruleMaps);
      });
      if (managedByRule.length === 1) {
        managedLine = managedByRule[0];
      }
    }

    return {
      parentLine,
      managedLine,
      parentLineKey: String((parentLine && parentLine.key) || "").trim(),
      managedLineKey: String((managedLine && managedLine.key) || "").trim(),
      managedRuleKey: resolvedRuleKey,
    };
  }

  function getManagedLubricationLinesBySourceLineKey(items, sourceLineKey) {
    const normalizedSourceLineKey = normalizeManagedSourceLineKey(sourceLineKey);
    if (!normalizedSourceLineKey) {
      return [];
    }

    return (Array.isArray(items) ? items : []).filter((line) => {
      return (
        isManagedLubricationLine(line) &&
        normalizeManagedSourceLineKey(getLineProperty(line, ATTR_LUBE_SOURCE)) === normalizedSourceLineKey
      );
    });
  }

  function getLubricationRuleKeyForLine(line, ruleMaps) {
    if (!line) {
      return "";
    }

    const explicitRuleKey = String(getLineProperty(line, ATTR_LUBE_RULE) || "").trim();
    if (explicitRuleKey) {
      return explicitRuleKey;
    }

    const resolvedRule = isManagedLubricationLine(line)
      ? resolveLubricationRuleForManagedLine(line, ruleMaps)
      : resolveLubricationRuleForLine(line, ruleMaps);
    return String((resolvedRule && resolvedRule.key) || "").trim();
  }

  function lineMatchesLubricationRule(line, ruleKey, ruleMaps) {
    const normalizedRuleKey = String(ruleKey || "").trim();
    if (!normalizedRuleKey) {
      return false;
    }

    return getLubricationRuleKeyForLine(line, ruleMaps) === normalizedRuleKey;
  }

  function findBestLubricationParentLineByRule(items, ruleKey, ruleMaps, managedLine) {
    const preferredScope = normalizeLubricationScope(getLineProperty(managedLine, ATTR_LUBE_SCOPE));
    const candidates = (Array.isArray(items) ? items : []).filter((line) => {
      if (!isEligibleLubricationParentLine(line)) {
        return false;
      }

      if (!isTruthyLineProperty(line, ATTR_LUBE_SELECTED)) {
        return false;
      }

      const scope = normalizeLubricationScope(getLineProperty(line, ATTR_LUBE_SCOPE));
      if (!scope) {
        return false;
      }

      if (preferredScope && scope !== preferredScope) {
        return false;
      }

      return lineMatchesLubricationRule(line, ruleKey, ruleMaps);
    });

    if (!candidates.length) {
      return null;
    }

    if (candidates.length === 1) {
      return candidates[0];
    }

    const managedQuantity = Math.max(1, parseInteger(managedLine && managedLine.quantity));
    const exactQuantityMatch = candidates.find((line) => {
      return Math.max(1, parseInteger(line && line.quantity)) === managedQuantity;
    });
    return exactQuantityMatch || candidates[0];
  }

  function isEligibleLubricationParentLine(line) {
    if (
      !line ||
      isManagedLubricationLine(line) ||
      isManagedFeeLine(line) ||
      isManagedGiftLine(line) ||
      isManagedGiftWrapLine(line) ||
      isManagedPackageInsuranceLine(line)
    ) {
      return false;
    }

    const lineKey = String(line && line.key ? line.key : "").trim();
    if (!lineKey) {
      return false;
    }

    return Math.max(0, parseInteger(line && line.quantity)) > 0;
  }

  function isEligibleGiftWrapBaseLine(line) {
    if (
      !line ||
      isManagedGiftWrapLine(line) ||
      isManagedPackageInsuranceLine(line) ||
      isManagedGiftLine(line) ||
      isManagedFeeLine(line) ||
      isManagedLubricationLine(line)
    ) {
      return false;
    }

    const lineKey = String(line && line.key ? line.key : "").trim();
    if (!lineKey) {
      return false;
    }

    return Math.max(0, parseInteger(line && line.quantity)) > 0;
  }

  function hasEligibleGiftWrapBaseLine(items) {
    return (Array.isArray(items) ? items : []).some((line) => isEligibleGiftWrapBaseLine(line));
  }

  async function onCheckoutSubmit(event) {
    try {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) {
        return;
      }

      if (!form.hasAttribute("data-qk-standard-checkout-form")) {
        return;
      }

      if (form.dataset.qkSyncBypass === "1") {
        delete form.dataset.qkSyncBypass;
        return;
      }

      const submitter = "submitter" in event ? event.submitter : null;
      if (submitter instanceof Element && submitter.closest(".shopify-payment-button, .shopify-cleanslate")) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      setCheckoutButtonsBusy(true);
      armCheckoutFallback(getCheckoutFallbackDelayMs());

      clearCheckoutSyncError(form);

      if (hasPendingCheckoutWork() || needsB2bCheckoutAttributeSync()) {
        const CHECKOUT_SYNC_TIMEOUT_MS = getCheckoutSyncTimeoutMs();

        try {
          await Promise.race([
            (async () => {
              await flushPendingLineMutations();
              await syncNow("checkout-submit", { forceEmit: false });
            })(),
            new Promise((_, reject) => {
              window.setTimeout(() => reject(new Error("checkout sync timeout")), CHECKOUT_SYNC_TIMEOUT_MS);
            }),
          ]);
        } catch (error) {
          reportError(error, "Sincronizarea cosului a depasit timeout-ul. Continui catre checkout (fail-open).");
        }
      }

      const liveForm = form.isConnected ? form : resolveCheckoutFormForButton(submitter);
      if (!(liveForm instanceof HTMLFormElement)) {
        window.location.href = `${getRootPath()}checkout`;
        return;
      }

      liveForm.dataset.qkSyncBypass = "1";
      if (typeof liveForm.requestSubmit === "function") {
        liveForm.requestSubmit();
      } else {
        liveForm.submit();
      }
    } catch (submitHandlerError) {
      reportError(submitHandlerError, "Checkout submit a esuat in script; redirectionez direct catre checkout.");
      window.location.href = `${getRootPath()}checkout`;
    }
  }

  function onPrimaryCheckoutPointerDown(event) {
    if (!isCartPagePath()) {
      return;
    }

    const target = event.target;
    if (!(target instanceof Element)) {
      return;
    }

    const checkoutButton = target.closest("button[name='checkout']");
    if (!(checkoutButton instanceof HTMLButtonElement)) {
      return;
    }

    if (checkoutButton.disabled || checkoutButton.getAttribute("aria-busy") === "true") {
      return;
    }

    armCheckoutFallback(getCheckoutFallbackDelayMs());
  }

  function onPrimaryCheckoutClick(event) {
    const target = event.target;
    if (!(target instanceof Element)) {
      return;
    }

    const checkoutButton = target.closest("button[name='checkout']");
    if (!(checkoutButton instanceof HTMLButtonElement)) {
      return;
    }

    const form = resolveCheckoutFormForButton(checkoutButton);
    if (!(form instanceof HTMLFormElement)) {
      if (isCartPagePath()) {
        window.location.href = `${getRootPath()}checkout`;
      }
      return;
    }

    if (checkoutButton.disabled || checkoutButton.getAttribute("aria-busy") === "true") {
      return;
    }

    if (!checkoutButton.contains(target)) {
      return;
    }

    if (checkoutButton.dataset.qkManualCheckoutClick === "1") {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === "function") {
      event.stopImmediatePropagation();
    }

    checkoutButton.dataset.qkManualCheckoutClick = "1";
    try {
      setCheckoutButtonsBusy(true);
      armCheckoutFallback(getCheckoutFallbackDelayMs());
      if (typeof form.requestSubmit === "function") {
        form.requestSubmit();
      } else {
        form.submit();
      }
    } catch (clickSubmitError) {
      reportError(clickSubmitError, "Checkout click a esuat in script; redirectionez direct catre checkout.");
      window.location.href = `${getRootPath()}checkout`;
    } finally {
      delete checkoutButton.dataset.qkManualCheckoutClick;
    }
  }

  function resolveCheckoutFormForButton(button) {
    if (!(button instanceof HTMLButtonElement)) {
      return null;
    }

    const closestForm = button.closest("form[data-qk-standard-checkout-form]");
    if (closestForm instanceof HTMLFormElement) {
      return closestForm;
    }

    if (button.form instanceof HTMLFormElement && button.form.hasAttribute("data-qk-standard-checkout-form")) {
      return button.form;
    }

    const explicitFormId = String(button.getAttribute("form") || "").trim();
    if (!explicitFormId) {
      return null;
    }

    const explicitForm = document.getElementById(explicitFormId);
    if (explicitForm instanceof HTMLFormElement && explicitForm.hasAttribute("data-qk-standard-checkout-form")) {
      return explicitForm;
    }

    return null;
  }

  function isCartPagePath() {
    const path = String(window.location.pathname || "").toLowerCase();
    return /\/cart(?:\/|$)/.test(path);
  }

  function clearCheckoutFallbackTimer() {
    if (state.checkoutFallbackTimer) {
      clearTimeout(state.checkoutFallbackTimer);
      state.checkoutFallbackTimer = null;
    }
  }

  function armCheckoutFallback(delayMs) {
    clearCheckoutFallbackTimer();
    const fallbackHref = `${getRootPath()}checkout`;
    const resolvedDelay = Number(delayMs);
    const timeoutMs = Number.isFinite(resolvedDelay) && resolvedDelay > 0 ? resolvedDelay : 900;
    state.checkoutFallbackTimer = window.setTimeout(() => {
      state.checkoutFallbackTimer = null;
      window.location.href = fallbackHref;
    }, timeoutMs);
  }

  function hasPendingCheckoutWork() {
    return Boolean(
      state.inFlight ||
        state.rerun ||
        state.debounceTimer ||
        state.lineMutationInFlight ||
        state.lineMutationDrainTimer ||
        state.lineMutationQueue.length ||
        Object.keys(safeObject(state.pendingManagedRemovalKeys)).length,
    );
  }

  function isMobileViewport() {
    return Boolean(window.matchMedia && window.matchMedia("(max-width: 768px)").matches);
  }

  function getCheckoutSyncTimeoutMs() {
    return isMobileViewport() ? 900 : 1200;
  }

  function getCheckoutFallbackDelayMs() {
    return isMobileViewport() ? 1800 : 2200;
  }

  function onCheckoutRetryClick(event) {
    const target = event.target;
    if (!(target instanceof Element)) {
      return;
    }

    const retryButton = target.closest("[data-qk-checkout-retry]");
    if (!(retryButton instanceof HTMLElement)) {
      return;
    }

    const form = retryButton.closest("form[data-qk-standard-checkout-form]");
    if (!(form instanceof HTMLFormElement)) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    clearCheckoutSyncError(form);
    if (typeof form.requestSubmit === "function") {
      form.requestSubmit();
    } else {
      form.submit();
    }
  }

  function getCheckoutFormKey(form) {
    const action = String(form && form.getAttribute ? form.getAttribute("action") || "" : "");
    const sectionHost = form && form.closest ? form.closest("[data-section-id], [data-main-cart-section-id], cart-drawer") : null;
    const sectionKey = sectionHost instanceof Element
      ? String(
          sectionHost.getAttribute("data-section-id") ||
            sectionHost.getAttribute("data-main-cart-section-id") ||
            sectionHost.id ||
            "",
        )
      : "";
    return `${action}::${sectionKey}`;
  }

  function showCheckoutSyncError(form, message) {
    if (!(form instanceof HTMLFormElement)) {
      return;
    }

    const normalizedMessage = String(message || "").trim() || "Sincronizarea cosului a esuat. Incearca din nou.";
    const formKey = getCheckoutFormKey(form);
    state.checkoutErrorMessageByFormKey[formKey] = normalizedMessage;

    let errorBox = form.querySelector(".qk-checkout-sync-error");
    if (!(errorBox instanceof HTMLElement)) {
      errorBox = document.createElement("div");
      errorBox.className = "qk-checkout-sync-error";
      errorBox.setAttribute("role", "alert");
      const submitButton = form.querySelector('[name="checkout"]');
      if (submitButton instanceof Element && submitButton.parentNode) {
        submitButton.parentNode.insertBefore(errorBox, submitButton);
      } else {
        form.appendChild(errorBox);
      }
    }

    errorBox.innerHTML = `<span>${escapeHtml(normalizedMessage)}</span><button type="button" data-qk-checkout-retry>Reincearca</button>`;
  }

  function clearCheckoutSyncError(form) {
    if (!(form instanceof HTMLFormElement)) {
      return;
    }

    const formKey = getCheckoutFormKey(form);
    if (formKey && Object.prototype.hasOwnProperty.call(state.checkoutErrorMessageByFormKey, formKey)) {
      delete state.checkoutErrorMessageByFormKey[formKey];
    }

    const errorBox = form.querySelector(".qk-checkout-sync-error");
    if (errorBox) {
      errorBox.remove();
    }
  }

  function refreshCheckoutButtonsBusy() {
    setCheckoutButtonsBusy(
      isSyncInFlight() ||
      Boolean(state.giftWrapUiBusy) ||
      Boolean(state.packageInsuranceUiBusy),
    );
  }

  function scheduleSync(reason, seedCart, delayMs) {
    startCartUiObserver();
    state.queuedSeedCart = seedCart || state.queuedSeedCart;
    const requestedDelay = Number(delayMs);
    const resolvedDelayMs = Number.isFinite(requestedDelay) && requestedDelay >= 0
      ? requestedDelay
      : 120;

    if (state.debounceTimer) {
      clearTimeout(state.debounceTimer);
    }

    state.debounceTimer = window.setTimeout(() => {
      state.debounceTimer = null;
      void syncNow(reason || "debounced", { seedCart: state.queuedSeedCart, forceEmit: false });
      state.queuedSeedCart = null;
      refreshCheckoutButtonsBusy();
    }, resolvedDelayMs);
    refreshCheckoutButtonsBusy();
  }

  function isSyncInFlight() {
    return Boolean(
      state.inFlight ||
        state.debounceTimer ||
        state.lineMutationInFlight ||
        state.lineMutationDrainTimer ||
        state.lineMutationQueue.length,
    );
  }

  function mergeTouchedLineElements(currentElements, nextElements) {
    return Array.from(
      new Set([...(Array.isArray(currentElements) ? currentElements : []), ...(Array.isArray(nextElements) ? nextElements : [])]),
    ).filter((element) => element instanceof Element);
  }

  function enqueueLineMutation(mutation) {
    const normalizedMutation = mutation || {};
    const lineKey = String(normalizedMutation.lineKey || "").trim();
    const targetQuantity = Math.max(0, parseInteger(normalizedMutation.targetQuantity));
    const reason = normalizedMutation.reason || "line-item:change";
    const impactedLineItems = Array.isArray(normalizedMutation.impactedLineItems)
      ? normalizedMutation.impactedLineItems.filter((element) => element instanceof Element)
      : [];

    if (!lineKey) {
      return Promise.resolve(state.lastCart);
    }

    state.latestIntendedLineQuantities[lineKey] = targetQuantity;

    return new Promise((resolve, reject) => {
      const existing = state.lineMutationQueue.find((entry) => entry.lineKey === lineKey);
      if (existing) {
        existing.targetQuantity = targetQuantity;
        existing.reason = reason;
        existing.impactedLineItems = mergeTouchedLineElements(existing.impactedLineItems, impactedLineItems);
        existing.resolvers.push({ resolve, reject });
      } else {
        state.lineMutationQueue.push({
          lineKey,
          targetQuantity,
          reason,
          impactedLineItems,
          resolvers: [{ resolve, reject }],
        });
      }

      scheduleLineMutationDrain();
    });
  }

  function scheduleLineMutationDrain() {
    if (state.lineMutationInFlight) {
      refreshCheckoutButtonsBusy();
      return;
    }

    if (state.lineMutationDrainTimer) {
      refreshCheckoutButtonsBusy();
      return;
    }

    state.lineMutationDrainTimer = window.setTimeout(() => {
      state.lineMutationDrainTimer = null;
      void runLineMutationQueue();
      refreshCheckoutButtonsBusy();
    }, LINE_MUTATION_DEBOUNCE_MS);

    refreshCheckoutButtonsBusy();
  }

  async function flushPendingLineMutations() {
    if (state.lineMutationDrainTimer) {
      clearTimeout(state.lineMutationDrainTimer);
      state.lineMutationDrainTimer = null;
    }

    if (state.lineMutationQueue.length && !state.lineMutationInFlight) {
      void runLineMutationQueue();
    }

    if (state.lineMutationPromise) {
      await state.lineMutationPromise;
    }

    refreshCheckoutButtonsBusy();
  }

  async function runLineMutationQueue() {
    if (state.lineMutationInFlight) {
      return state.lineMutationPromise || Promise.resolve(state.lastCart);
    }

    if (!state.lineMutationQueue.length) {
      return Promise.resolve(state.lastCart);
    }

    state.lineMutationInFlight = true;
    refreshCheckoutButtonsBusy();

    const run = async () => {
      let latestCart = state.lastCart;
      let latestReason = "line-item:change";
      const completedBatches = [];

      while (state.lineMutationQueue.length) {
        const queued = state.lineMutationQueue.shift();
        if (!queued) {
          continue;
        }

        const lineKey = String(queued.lineKey || "").trim();
        const targetQuantity = Math.max(0, parseInteger(queued.targetQuantity));
        const impactedLineItems = Array.isArray(queued.impactedLineItems) ? queued.impactedLineItems : [];
        latestReason = queued.reason || latestReason;

        try {
          const cartAfterMutation = await requestCartJson("cart/change.js", {
            id: lineKey,
            quantity: targetQuantity,
          });
          latestCart = cartAfterMutation && typeof cartAfterMutation === "object" ? cartAfterMutation : latestCart;

          const lineAfterChange = findLineByKey(latestCart, lineKey);
          const changedQuantity = lineAfterChange ? parseInteger(lineAfterChange.quantity) : 0;

          impactedLineItems.forEach((element) => {
            element.dispatchEvent(
              new CustomEvent("line-item:change", {
                bubbles: true,
                detail: {
                  quantity: changedQuantity,
                  cart: latestCart,
                },
              }),
            );
          });

          completedBatches.push(queued);
        } catch (error) {
          impactedLineItems.forEach((element) => {
            element.dispatchEvent(
              new CustomEvent("line-item:change", {
                bubbles: true,
                detail: {
                  quantity: targetQuantity,
                  cart: state.lastCart || { items: [] },
                },
              }),
            );
          });

          queued.resolvers.forEach((resolver) => resolver.reject(error));

          const remainder = state.lineMutationQueue.splice(0, state.lineMutationQueue.length);
          remainder.forEach((entry) => {
            (entry.resolvers || []).forEach((resolver) => resolver.reject(error));
          });
          throw error;
        } finally {
          delete state.latestIntendedLineQuantities[lineKey];
        }
      }

      try {
        const syncedCart = await syncNow(latestReason || "line-item:queued-sync", {
          seedCart: latestCart,
          forceEmit: true,
          skipMutationFlush: true,
        });

        completedBatches.forEach((entry) => {
          (entry.resolvers || []).forEach((resolver) => resolver.resolve(syncedCart));
        });

        return syncedCart;
      } catch (error) {
        completedBatches.forEach((entry) => {
          (entry.resolvers || []).forEach((resolver) => resolver.reject(error));
        });
        throw error;
      }
    };

    state.lineMutationPromise = run()
      .catch((error) => {
        reportError(error, "Nu am putut aplica modificarile rapide din cos.");
        throw error;
      })
      .finally(() => {
        state.lineMutationInFlight = false;
        state.lineMutationPromise = null;
        if (state.lineMutationQueue.length) {
          scheduleLineMutationDrain();
        }
        refreshCheckoutButtonsBusy();
      });

    return state.lineMutationPromise;
  }

  async function syncNow(reason, options) {
    const normalizedOptions = options || {};
    markPerf("sync-start");
    const syncStartedAt = window.performance && typeof window.performance.now === "function"
      ? window.performance.now()
      : Date.now();

    if (!normalizedOptions.skipMutationFlush) {
      await flushPendingLineMutations();
    }

    if (state.debounceTimer) {
      clearTimeout(state.debounceTimer);
      state.debounceTimer = null;
      refreshCheckoutButtonsBusy();
    }

    if (state.inFlight) {
      state.rerun = true;
      if (normalizedOptions.seedCart) {
        state.queuedSeedCart = normalizedOptions.seedCart;
      }
      return state.syncPromise || Promise.resolve(state.lastCart);
    }

    const run = async () => {
      const config = getConfig();
      const lubricationConfig = getLubricationConfig();
      const sectionIds = collectBundledSectionIds();
      dispatchSyncEvent("qk:cart-sync:start", { reason: reason || "sync", startedAt: syncStartedAt });

      let cart = normalizedOptions.seedCart || state.queuedSeedCart || state.lastCart;
      if (!cart) {
        cart = await fetchCartJson();
      }
      state.queuedSeedCart = null;

      let hadMutations = false;
      let reachedConvergenceLimit = false;
      for (let iteration = 0; iteration < MAX_SYNC_CONVERGENCE_ITERATIONS; iteration += 1) {
        state.rerun = false;
        const isB2bCheckout = isB2bCheckoutContext();
        await Promise.all([
          isB2bCheckout ? Promise.resolve() : ensureGiftVariantIds(cart, config),
          ensureLubricationVariantIds(cart, lubricationConfig),
          isB2bCheckout ? Promise.resolve() : ensureGiftWrapVariantId(cart),
        ]);

        const plan = buildSyncPlan(cart, config, lubricationConfig);
        state.lastPlanSignature = plan.signature;
        const mutationOperations = resolveMutationOperations(plan, config);
        const processingLineKeys = deriveProcessingParentLineKeys(cart, mutationOperations);
        setProcessingLineKeys(processingLineKeys);

        if (mutationOperations.length) {
          markManagedLinesPendingRemoval(cart, mutationOperations);
        }

        let result;
        try {
          result = await applySyncPlan(plan, cart, config, sectionIds);
        } finally {
          clearProcessingLineKeys();
        }
        cart = result.cart;
        hadMutations = hadMutations || result.hadMutations;

        if (!state.rerun) {
          break;
        }

        if (iteration === MAX_SYNC_CONVERGENCE_ITERATIONS - 1) {
          reachedConvergenceLimit = true;
          break;
        }

        cart = await fetchCartJson();
      }

      if (reachedConvergenceLimit) {
        scheduleSync("convergence-follow-up", cart);
      }

      const normalizedReason = String(reason || "sync");
      const isCartPageBootReason =
        normalizedReason === "init-cart-page" ||
        normalizedReason === "pageshow" ||
        normalizedReason === "window-load";
      const shouldSkipSectionHydration = isCartPagePath() && !hadMutations && isCartPageBootReason;
      if (shouldSkipSectionHydration) {
        debugLog("[qk-cart-rules] skip section hydration (cart boot, no mutations)");
        cart = normalizeCartPayload(cart);
      } else {
        cart = normalizeCartPayload(await ensureCartSections(cart, sectionIds));
      }
      state.lastCart = cart;

      updateMainCartSection(cart);
      refreshUiFromState();
      scheduleUiRefresh("post-sync");
      clearPendingManagedRemovalKeys();

      dispatchCartChanged("qk:cart-sync", cart);

      dispatchSyncEvent("qk:cart-sync:success", {
        reason: reason || "sync",
        signature: state.lastPlanSignature,
        durationMs: Math.round(
          (window.performance && typeof window.performance.now === "function"
            ? window.performance.now()
            : Date.now()) - syncStartedAt,
        ),
      });

      return cart;
    };

    state.inFlight = true;
    refreshCheckoutButtonsBusy();

    const requestedHardTimeoutMs = Number(normalizedOptions.hardTimeoutMs);
    const resolvedHardTimeoutMs =
      Number.isFinite(requestedHardTimeoutMs) && requestedHardTimeoutMs > 0
        ? Math.max(1000, Math.round(requestedHardTimeoutMs))
        : 15000;
    let syncHardTimeoutTimer = null;

    state.syncPromise = Promise.race([
      run(),
      new Promise(function (_, reject) {
        syncHardTimeoutTimer = setTimeout(function () {
          reject(new Error("sync hard timeout (" + resolvedHardTimeoutMs + "ms)"));
        }, resolvedHardTimeoutMs);
      }),
    ])
      .catch((error) => {
        clearProcessingLineKeys();
        clearPendingManagedRemovalKeys();
        dispatchSyncEvent("qk:cart-sync:error", {
          reason: reason || "sync",
          message: error instanceof Error ? error.message : String(error || "unknown"),
          durationMs: Math.round(
            (window.performance && typeof window.performance.now === "function"
              ? window.performance.now()
              : Date.now()) - syncStartedAt,
          ),
        });
        reportError(error, "Sincronizarea cosului a esuat.");
        throw error;
      })
      .finally(() => {
        if (syncHardTimeoutTimer) {
          clearTimeout(syncHardTimeoutTimer);
          syncHardTimeoutTimer = null;
        }
        clearProcessingLineKeys();
        state.inFlight = false;
        state.syncPromise = null;
        markPerf("sync-end");
        measurePerf("sync-duration", "sync-start", "sync-end");
        refreshCheckoutButtonsBusy();
      });

    return state.syncPromise;
  }

  function buildSyncPlan(cart, config, lubricationConfig) {
    const cartItems = Array.isArray(cart && cart.items) ? cart.items : [];
    const thresholdBasisCents = computeThresholdBasisCents(
      cartItems,
      parseInteger(cart && cart.total_price),
      config.gift.tiers,
    );
    const isB2bCheckout = isB2bCheckoutContext();

    if (isB2bCheckout) {
      const cleanupOperations = buildB2bManagedRuleCleanupOperations({
        items: cartItems,
        config,
      });
      const upsellCleanupOperations = buildUpsellCleanupOperations({
        items: cartItems,
      });
      const operations = [
        ...cleanupOperations,
        ...upsellCleanupOperations,
      ];
      const desiredAttributes = Object.assign({}, buildDesiredB2bCheckoutAttributes(cart), {
        [ATTR_GIFT_WRAP_SELECTED]: "0",
        [ATTR_PACKAGE_INSURANCE_SELECTED]: "0",
      });
      const attributeUpdates = diffCartAttributes(cart, desiredAttributes);
      const desiredFeeQuantities = buildEmptyFeeQuantityMap(config.fees.rules);
      const signature = [
        "b2b:1",
        `cleanup:${cleanupOperations.map(serializeOperation).join("|")}`,
        `upsell:${upsellCleanupOperations.map(serializeOperation).join("|")}`,
        `attr:${Object.keys(attributeUpdates).sort().join(",")}`,
      ].join(";");

      debugLog("[qk-cart-rules] B2B sync plan", {
        cleanup: cleanupOperations.length,
        upsell: upsellCleanupOperations.length,
        attrKeys: Object.keys(attributeUpdates).length,
      });

      return {
        signature,
        operations,
        lubricationOperations: [],
        attributeUpdates,
        desiredAttributes,
        thresholdBasisCents,
        targetTierIndexes: [],
        desiredFeeQuantities,
        feeTagsReady: true,
        giftWrapSelected: false,
        giftWrapVariantLegacyId: "",
        packageInsuranceSelected: false,
        packageInsuranceVariantLegacyId: "",
      };
    }

    const enabledGiftTiers = config.gift.tiers.filter((tier) => Boolean(tier && tier.enabled));
    const unlockedTierIndexes = enabledGiftTiers
      .filter((tier) => thresholdBasisCents >= tier.thresholdCents)
      .map((tier) => tier.index);

    const targetTierIndexes =
      config.gift.mode === "cumulative"
        ? unlockedTierIndexes
        : unlockedTierIndexes.length
          ? [unlockedTierIndexes[unlockedTierIndexes.length - 1]]
          : [];

    const tagLookup = collectFeeTagLookupsFromDom();
    const feeResolution = computeDesiredFeeQuantities({
      items: cartItems,
      feeRules: config.fees.rules,
      tagLookup,
    });
    const desiredFeeQuantities = feeResolution.desiredQuantities;

    const giftOperations = buildGiftOperations({
      items: cartItems,
      giftTiers: config.gift.tiers,
      targetTierIndexes,
    });

    const feeOperations = feeResolution.tagsReady
      ? buildFeeOperations({
          items: cartItems,
          feeRules: config.fees.rules,
          desiredFeeQuantities,
          tagLookup,
        })
      : [];

    const requestedGiftWrapSelection = readGiftWrapSelected(cart, cartItems);
    const giftWrapHasBaseLine = hasEligibleGiftWrapBaseLine(cartItems);
    const giftWrapVariantLegacyId = normalizeLegacyId(state.giftWrapVariantLegacyId);
    const giftWrapCanBeSelected = Boolean(state.giftWrapInStock && giftWrapVariantLegacyId && giftWrapHasBaseLine);
    const targetGiftWrapSelection = requestedGiftWrapSelection && giftWrapCanBeSelected;
    const giftWrapOperations = buildGiftWrapOperations({
      items: cartItems,
      selected: targetGiftWrapSelection,
      variantLegacyId: giftWrapVariantLegacyId,
    });
    const requestedPackageInsuranceSelection = readPackageInsuranceSelected(cart, cartItems);
    const packageInsuranceVariantLegacyId = normalizeLegacyId(state.packageInsuranceVariantLegacyId);
    const packageInsuranceCanBeSelected = Boolean(
      state.packageInsuranceInStock &&
        packageInsuranceVariantLegacyId &&
        giftWrapHasBaseLine,
    );
    const targetPackageInsuranceSelection = requestedPackageInsuranceSelection && packageInsuranceCanBeSelected;
    const packageInsuranceOperations = buildPackageInsuranceOperations({
      items: cartItems,
      selected: targetPackageInsuranceSelection,
      variantLegacyId: packageInsuranceVariantLegacyId,
    });

    const lubricationOperations = buildLubricationOperations({
      items: cartItems,
      lubricationConfig,
    });
    const upsellCleanupOperations = buildUpsellCleanupOperations({
      items: cartItems,
    });

    const desiredAttributes = Object.assign(
      {},
      buildDesiredConfigAttributes(config, thresholdBasisCents),
      buildDesiredB2bCheckoutAttributes(cart),
      {
        [ATTR_GIFT_WRAP_SELECTED]: targetGiftWrapSelection ? "1" : "0",
        [ATTR_PACKAGE_INSURANCE_SELECTED]: targetPackageInsuranceSelection ? "1" : "0",
      },
    );
    const attributeUpdates = diffCartAttributes(cart, desiredAttributes);

    const operations = [
      ...giftOperations,
      ...feeOperations,
      ...giftWrapOperations,
      ...packageInsuranceOperations,
      ...lubricationOperations,
      ...upsellCleanupOperations,
    ];
    const signature = [
      `tiers:${targetTierIndexes.join(",")}`,
      `fees:${feeResolution.tagsReady ? KNOWN_FEE_RULE_KEYS.map((key) => `${key}:${desiredFeeQuantities[key] || 0}`).join(",") : "tags-pending"}`,
      `giftWrap:${targetGiftWrapSelection ? "1" : "0"}:${giftWrapVariantLegacyId || "none"}:base:${giftWrapHasBaseLine ? "1" : "0"}`,
      `packageInsurance:${targetPackageInsuranceSelection ? "1" : "0"}:${packageInsuranceVariantLegacyId || "none"}:base:${giftWrapHasBaseLine ? "1" : "0"}`,
      `ops:${operations.map(serializeOperation).join("|")}`,
      `attr:${Object.keys(attributeUpdates).sort().join(",")}`,
    ].join(";");

    debugLog("[qk-cart-rules] sync plan", {
      ops: operations.length,
      gift: giftOperations.length,
      fee: feeOperations.length,
      lube: lubricationOperations.length,
      wrap: giftWrapOperations.length,
      insurance: packageInsuranceOperations.length,
      upsell: upsellCleanupOperations.length,
      attrKeys: Object.keys(attributeUpdates).length,
      basis: thresholdBasisCents,
      tiers: targetTierIndexes,
    });

    return {
      signature,
      operations,
      lubricationOperations,
      attributeUpdates,
      desiredAttributes,
      thresholdBasisCents,
      targetTierIndexes,
      desiredFeeQuantities,
      feeTagsReady: feeResolution.tagsReady,
      giftWrapSelected: targetGiftWrapSelection,
      giftWrapVariantLegacyId,
      packageInsuranceSelected: targetPackageInsuranceSelection,
      packageInsuranceVariantLegacyId,
    };
  }

  function resolveMutationOperations(plan, config) {
    const allOperations = Array.isArray(plan && plan.operations) ? plan.operations : [];
    const lubricationOperations = Array.isArray(plan && plan.lubricationOperations) ? plan.lubricationOperations : [];
    const canMutateManagedRules =
      Boolean(config && config.flags && config.flags.managedRulesEnabled) &&
      !Boolean(config && config.flags && config.flags.shadowMode) &&
      !Boolean(config && config.flags && config.flags.killSwitch);

    if (canMutateManagedRules) {
      return allOperations;
    }

    return lubricationOperations;
  }

  async function applySyncPlan(plan, cart, config, sectionIds) {
    const canMutateManagedRules =
      Boolean(config.flags.managedRulesEnabled) &&
      !Boolean(config.flags.shadowMode) &&
      !Boolean(config.flags.killSwitch);
    const operations = resolveMutationOperations(plan, config);
    const canMutateRules = operations.length > 0;

    const canMutateAttributes = canMutateManagedRules;

    let hadMutations = false;
    let nextCart = cart;
    const hasAttributeUpdates = Object.keys(plan.attributeUpdates).length > 0;
    const includeBundledSections = Array.isArray(sectionIds) && sectionIds.length > 0;

    const batches = buildOperationBatches(operations);
    const hasUpdates = Object.keys(batches.updates).length > 0;
    const hasPropertyChanges = batches.propertyChanges.length > 0;
    const hasAdds = batches.adds.length > 0;

    const canFoldAttributesIntoUpdate =
      hasAttributeUpdates &&
      canMutateAttributes &&
      (hasUpdates || (!hasPropertyChanges && !hasAdds));
    const needsTrailingAttributeWrite =
      hasAttributeUpdates &&
      canMutateAttributes &&
      !canFoldAttributesIntoUpdate;

    let pendingMutationSteps = 0;
    if ((canMutateRules && hasUpdates) || canFoldAttributesIntoUpdate) {
      pendingMutationSteps += 1;
    }
    if (canMutateRules && hasPropertyChanges) {
      pendingMutationSteps += batches.propertyChanges.length;
    }
    if (canMutateRules && hasAdds) {
      pendingMutationSteps += 1;
    }
    if (needsTrailingAttributeWrite) {
      pendingMutationSteps += 1;
    }

    const attachSectionsIfFinalStep = (payload) => {
      if (!includeBundledSections || pendingMutationSteps !== 1) {
        return;
      }

      payload.sections = sectionIds;
      payload.sections_url = window.location.pathname;
    };

    if (operations.length && !canMutateRules && config.flags.log) {
      debugLog("[qk-cart-rules] shadow operation plan", operations);
    }

    if ((canMutateRules && hasUpdates) || canFoldAttributesIntoUpdate) {
      const payload = {};
      if (hasUpdates) {
        payload.updates = batches.updates;
      }
      if (canFoldAttributesIntoUpdate) {
        payload.attributes = Object.assign({}, safeObject(nextCart && nextCart.attributes), plan.attributeUpdates);
      }
      attachSectionsIfFinalStep(payload);
      debugLog("[qk-cart-rules] >> update.js", {
        updates: hasUpdates,
        attrs: canFoldAttributesIntoUpdate,
      });

      const updatedCart = await requestCartJson("cart/update.js", payload);
      if (updatedCart && typeof updatedCart === "object") {
        nextCart = updatedCart;
      }
      pendingMutationSteps = Math.max(0, pendingMutationSteps - 1);
      hadMutations = true;
    }

    if (canMutateRules) {
      for (const operation of batches.propertyChanges) {
        debugLog("[qk-cart-rules] >> change.js", operation.lineKey);
        const operationCart = await applyOperation(operation, sectionIds, pendingMutationSteps === 1);
        if (operationCart && typeof operationCart === "object") {
          nextCart = operationCart;
        }
        pendingMutationSteps = Math.max(0, pendingMutationSteps - 1);
        hadMutations = true;
      }
    }

    if (canMutateRules && hasAdds) {
      debugLog("[qk-cart-rules] >> add.js", batches.adds.length, "items");
      const payload = {
        items: batches.adds.map((operation) => ({
          id: Number(normalizeLegacyId(operation.variantLegacyId)),
          quantity: Math.max(1, parseInteger(operation.quantity)),
          properties: operation.properties || {},
        })),
      };
      attachSectionsIfFinalStep(payload);

      const addedCart = await requestCartJson("cart/add.js", payload);
      if (addedCart && typeof addedCart === "object") {
        nextCart = addedCart;
      }
      pendingMutationSteps = Math.max(0, pendingMutationSteps - 1);
      hadMutations = true;
    }

    if (needsTrailingAttributeWrite) {
      const mergedAttributes = Object.assign({}, safeObject(nextCart && nextCart.attributes), plan.attributeUpdates);
      const payload = { attributes: mergedAttributes };
      attachSectionsIfFinalStep(payload);
      debugLog("[qk-cart-rules] >> trailing attrs");
      nextCart = await requestCartJson("cart/update.js", payload);
      pendingMutationSteps = Math.max(0, pendingMutationSteps - 1);
      hadMutations = true;
    } else if (hasAttributeUpdates && !canMutateAttributes && config.flags.log) {
      debugLog("[qk-cart-rules] shadow attribute updates", plan.attributeUpdates);
    }

    if (hadMutations && (hasAdds || !isCompleteCartPayload(nextCart))) {
      nextCart = await fetchCartJson();
    }

    return {
      cart: nextCart,
      hadMutations,
    };
  }

  async function applyOperation(operation, sectionIds, includeSections) {
    if (operation.type === "change") {
      const payload = {
        id: operation.lineKey,
        quantity: operation.quantity,
      };

      if (operation.properties) {
        payload.properties = operation.properties;
      }

      if (includeSections && Array.isArray(sectionIds) && sectionIds.length) {
        payload.sections = sectionIds;
        payload.sections_url = window.location.pathname;
      }

      return requestCartJson("cart/change.js", payload);
    }

    if (operation.type === "add") {
      const variantLegacyId = normalizeLegacyId(operation.variantLegacyId);
      if (!variantLegacyId) {
        return null;
      }

      const payload = {
        items: [
          {
            id: Number(variantLegacyId),
            quantity: Math.max(1, parseInteger(operation.quantity)),
            properties: operation.properties || {},
          },
        ],
      };

      if (includeSections && Array.isArray(sectionIds) && sectionIds.length) {
        payload.sections = sectionIds;
        payload.sections_url = window.location.pathname;
      }

      return requestCartJson("cart/add.js", payload);
    }

    return null;
  }

  function buildOperationBatches(operations) {
    const updates = {};
    const propertyChanges = [];
    const addBuckets = {};

    (Array.isArray(operations) ? operations : []).forEach((operation) => {
      if (!operation || typeof operation !== "object") {
        return;
      }

      if (operation.type === "change") {
        const lineKey = String(operation.lineKey || "").trim();
        if (!lineKey) {
          return;
        }

        if (operation.properties && typeof operation.properties === "object") {
          propertyChanges.push(operation);
          return;
        }

        updates[lineKey] = Math.max(0, parseInteger(operation.quantity));
        return;
      }

      if (operation.type !== "add") {
        return;
      }

      const variantLegacyId = normalizeLegacyId(operation.variantLegacyId);
      if (!variantLegacyId) {
        return;
      }

      const quantity = Math.max(1, parseInteger(operation.quantity));
      const properties = operation.properties && typeof operation.properties === "object" ? operation.properties : {};
      const bucketKey = `${variantLegacyId}::${serializeProperties(properties)}`;

      if (!addBuckets[bucketKey]) {
        addBuckets[bucketKey] = {
          type: "add",
          variantLegacyId,
          quantity: 0,
          properties,
        };
      }

      addBuckets[bucketKey].quantity += quantity;
    });

    return {
      updates,
      propertyChanges,
      adds: Object.values(addBuckets),
    };
  }

  function isCartPayload(payload) {
    return Boolean(payload && typeof payload === "object" && Array.isArray(payload.items));
  }

  function isCompleteCartPayload(payload) {
    if (!isCartPayload(payload)) {
      return false;
    }

    const itemCount = Number(payload.item_count);
    const totalPrice = Number(payload.total_price);
    const subtotalPrice = Number(payload.items_subtotal_price);
    const hasToken = Boolean(String(payload.token || "").trim());
    const hasAttributes = payload.attributes && typeof payload.attributes === "object";

    return (
      Number.isFinite(itemCount) &&
      itemCount >= 0 &&
      Number.isFinite(totalPrice) &&
      totalPrice >= 0 &&
      Number.isFinite(subtotalPrice) &&
      subtotalPrice >= 0 &&
      hasToken &&
      hasAttributes
    );
  }

  function normalizeCartPayload(payload) {
    if (!payload || typeof payload !== "object") {
      return null;
    }

    if (!Array.isArray(payload.items)) {
      return null;
    }

    const nextPayload = Object.assign({}, payload);
    const itemCount = Number(nextPayload.item_count);
    if (!Number.isFinite(itemCount) || itemCount < 0) {
      nextPayload.item_count = payload.items.reduce((total, line) => {
        return total + Math.max(0, parseInteger(line && line.quantity));
      }, 0);
    }

    return nextPayload;
  }

  function buildGiftOperations(input) {
    const items = Array.isArray(input.items) ? input.items : [];
    const giftTiers = Array.isArray(input.giftTiers) ? input.giftTiers : [];
    const targetTierIndexes = new Set(Array.isArray(input.targetTierIndexes) ? input.targetTierIndexes : []);

    const managedGiftLines = items.filter((item) => isManagedGiftLine(item));
    const tierByIndex = {};
    giftTiers.forEach((tier) => {
      tierByIndex[tier.index] = tier;
    });

    const targetGiftProductIds = new Set(
      Array.from(targetTierIndexes)
        .map((tierIndex) => tierByIndex[tierIndex])
        .filter(Boolean)
        .map((tier) => tier.giftProductLegacyId),
    );

    const operations = [];

    for (const line of managedGiftLines) {
      const lineTier = parseInteger(getLineProperty(line, ATTR_GWP_TIER));
      const keepByTier = targetTierIndexes.has(lineTier);
      const keepByProduct = targetGiftProductIds.has(normalizeLegacyId(line.product_id));
      if (!keepByTier && !keepByProduct) {
        operations.push({
          type: "change",
          lineKey: line.key,
          quantity: 0,
        });
      }
    }

    for (const targetTierIndex of targetTierIndexes) {
      const tier = tierByIndex[targetTierIndex];
      if (!tier || !tier.enabled) {
        continue;
      }

      const variantLegacyId = normalizeLegacyId(tier.giftVariantLegacyId);
      if (!variantLegacyId) {
        continue;
      }

      const exactMatches = managedGiftLines.filter(
        (line) => parseInteger(getLineProperty(line, ATTR_GWP_TIER)) === targetTierIndex,
      );
      const productMatches = managedGiftLines.filter(
        (line) => normalizeLegacyId(line.product_id) === tier.giftProductLegacyId,
      );
      const existingLines = exactMatches.length ? exactMatches : productMatches;

      const desiredManagedProperties = {
        [ATTR_GWP_MANAGED]: "1",
        [ATTR_GWP_TIER]: String(targetTierIndex),
      };
      const addProperties = {
        ...desiredManagedProperties,
        [ATTR_GWP_SOURCE]: SOURCE_STOREFRONT,
      };

      if (!existingLines.length) {
        operations.push({
          type: "add",
          variantLegacyId,
          quantity: 1,
          properties: addProperties,
        });
        continue;
      }

      const primary =
        existingLines.find((line) => normalizeLegacyId(line.variant_id) === variantLegacyId) || existingLines[0];

      const extras = existingLines.filter((line) => line.key !== primary.key);
      extras.forEach((extra) => {
        const extraMatchesTargetProduct = normalizeLegacyId(extra.product_id) === tier.giftProductLegacyId;
        const extraMatchesTargetVariant = normalizeLegacyId(extra.variant_id) === variantLegacyId;
        if (extraMatchesTargetProduct && extraMatchesTargetVariant) {
          return;
        }

        operations.push({
          type: "change",
          lineKey: extra.key,
          quantity: 0,
        });
      });

      const desiredQuantity = Math.max(1, parseInteger(primary.quantity));
      const primaryVariantMismatch = normalizeLegacyId(primary.variant_id) !== variantLegacyId;
      const needsPropertyUpdate = !lineHasProperties(primary, desiredManagedProperties);

      if (primaryVariantMismatch) {
        operations.push({
          type: "change",
          lineKey: primary.key,
          quantity: 0,
        });
        operations.push({
          type: "add",
          variantLegacyId,
          quantity: desiredQuantity,
          properties: addProperties,
        });
        continue;
      }

      if (needsPropertyUpdate) {
        operations.push({
          type: "change",
          lineKey: primary.key,
          quantity: desiredQuantity,
          properties: desiredManagedProperties,
        });
      }
    }

    return dedupeOperations(operations);
  }

  function buildB2bManagedRuleCleanupOperations(input) {
    const items = Array.isArray(input && input.items) ? input.items : [];
    const config = safeObject(input && input.config);
    const feeProductIds = new Set(
      (Array.isArray(config && config.fees && config.fees.rules) ? config.fees.rules : [])
        .map((rule) => normalizeLegacyId(rule && rule.feeProductLegacyId))
        .filter(Boolean),
    );
    const b2bExcludedProductIds = new Set([
      ...feeProductIds,
      normalizeLegacyId(GIFT_WRAP_PRODUCT_LEGACY_ID),
      normalizeLegacyId(PACKAGE_INSURANCE_PRODUCT_LEGACY_ID),
    ].filter(Boolean));
    const operations = [];

    items.forEach((line) => {
      const lineKey = String(line && line.key ? line.key : "").trim();
      if (!lineKey) {
        return;
      }

      const productLegacyId = normalizeLegacyId(line && line.product_id);
      const shouldRemove =
        isManagedGiftLine(line) ||
        isManagedFeeLine(line) ||
        isManagedGiftWrapLine(line) ||
        isManagedPackageInsuranceLine(line) ||
        b2bExcludedProductIds.has(productLegacyId);

      if (!shouldRemove) {
        return;
      }

      operations.push({
        type: "change",
        lineKey,
        quantity: 0,
      });
    });

    return dedupeOperations(operations);
  }

  function buildGiftWrapOperations(input) {
    const items = Array.isArray(input && input.items) ? input.items : [];
    const selected = Boolean(input && input.selected);
    const variantLegacyId = normalizeLegacyId(input && input.variantLegacyId);
    const giftWrapProductLegacyId = normalizeLegacyId(GIFT_WRAP_PRODUCT_LEGACY_ID);
    const operations = [];

    const relatedLines = items.filter((line) => {
      if (!line) {
        return false;
      }

      if (isManagedGiftWrapLine(line)) {
        return true;
      }

      return normalizeLegacyId(line.product_id) === giftWrapProductLegacyId;
    });

    if (!selected || !variantLegacyId) {
      relatedLines.forEach((line) => {
        operations.push({
          type: "change",
          lineKey: line.key,
          quantity: 0,
        });
      });

      return dedupeOperations(operations);
    }

    const desiredManagedProperties = {
      [ATTR_GIFT_WRAP_MANAGED]: "1",
      [ATTR_GIFT_WRAP_SOURCE]: SOURCE_STOREFRONT,
    };

    if (!relatedLines.length) {
      operations.push({
        type: "add",
        variantLegacyId,
        quantity: 1,
        properties: desiredManagedProperties,
      });
      return dedupeOperations(operations);
    }

    const primary = relatedLines.find((line) => normalizeLegacyId(line && line.variant_id) === variantLegacyId) || relatedLines[0];
    const extras = relatedLines.filter((line) => String(line && line.key ? line.key : "").trim() !== String(primary && primary.key ? primary.key : "").trim());

    extras.forEach((line) => {
      operations.push({
        type: "change",
        lineKey: line.key,
        quantity: 0,
      });
    });

    const primaryVariantMismatch = normalizeLegacyId(primary && primary.variant_id) !== variantLegacyId;
    const primaryQuantity = Math.max(0, parseInteger(primary && primary.quantity));
    const needsQuantityUpdate = primaryQuantity !== 1;
    const needsPropertyUpdate = !lineHasProperties(primary, desiredManagedProperties);

    if (primaryVariantMismatch) {
      operations.push({
        type: "change",
        lineKey: primary.key,
        quantity: 0,
      });
      operations.push({
        type: "add",
        variantLegacyId,
        quantity: 1,
        properties: desiredManagedProperties,
      });
      return dedupeOperations(operations);
    }

    if (needsQuantityUpdate || needsPropertyUpdate) {
      operations.push({
        type: "change",
        lineKey: primary.key,
        quantity: 1,
        properties: desiredManagedProperties,
      });
    }

    return dedupeOperations(operations);
  }

  function buildPackageInsuranceOperations(input) {
    const items = Array.isArray(input && input.items) ? input.items : [];
    const selected = Boolean(input && input.selected);
    const variantLegacyId = normalizeLegacyId(input && input.variantLegacyId);
    const packageInsuranceProductLegacyId = normalizeLegacyId(PACKAGE_INSURANCE_PRODUCT_LEGACY_ID);
    const operations = [];

    const relatedLines = items.filter((line) => {
      if (!line) {
        return false;
      }

      if (isManagedPackageInsuranceLine(line)) {
        return true;
      }

      return normalizeLegacyId(line.product_id) === packageInsuranceProductLegacyId;
    });

    if (!selected || !variantLegacyId) {
      relatedLines.forEach((line) => {
        operations.push({
          type: "change",
          lineKey: line.key,
          quantity: 0,
        });
      });

      return dedupeOperations(operations);
    }

    const desiredManagedProperties = {
      [ATTR_PACKAGE_INSURANCE_MANAGED]: "1",
      [ATTR_PACKAGE_INSURANCE_SOURCE]: SOURCE_STOREFRONT,
    };

    if (!relatedLines.length) {
      operations.push({
        type: "add",
        variantLegacyId,
        quantity: 1,
        properties: desiredManagedProperties,
      });
      return dedupeOperations(operations);
    }

    const primary =
      relatedLines.find((line) => normalizeLegacyId(line && line.variant_id) === variantLegacyId) || relatedLines[0];
    const extras = relatedLines.filter((line) => {
      return String(line && line.key ? line.key : "").trim() !== String(primary && primary.key ? primary.key : "").trim();
    });

    extras.forEach((line) => {
      operations.push({
        type: "change",
        lineKey: line.key,
        quantity: 0,
      });
    });

    const primaryVariantMismatch = normalizeLegacyId(primary && primary.variant_id) !== variantLegacyId;
    const primaryQuantity = Math.max(0, parseInteger(primary && primary.quantity));
    const needsQuantityUpdate = primaryQuantity !== 1;
    const needsPropertyUpdate = !lineHasProperties(primary, desiredManagedProperties);

    if (primaryVariantMismatch) {
      operations.push({
        type: "change",
        lineKey: primary.key,
        quantity: 0,
      });
      operations.push({
        type: "add",
        variantLegacyId,
        quantity: 1,
        properties: desiredManagedProperties,
      });
      return dedupeOperations(operations);
    }

    if (needsQuantityUpdate || needsPropertyUpdate) {
      operations.push({
        type: "change",
        lineKey: primary.key,
        quantity: 1,
        properties: desiredManagedProperties,
      });
    }

    return dedupeOperations(operations);
  }

  function buildUpsellCleanupOperations(input) {
    const items = Array.isArray(input && input.items) ? input.items : [];
    const operations = [];

    items.forEach((line) => {
      if (!lineHasPublicUpsellProperties(line)) {
        return;
      }

      const lineKey = String(line && line.key ? line.key : "").trim();
      if (!lineKey) {
        return;
      }

      const quantity = Math.max(0, parseInteger(line && line.quantity));
      if (!quantity) {
        return;
      }

      const currentProperties = safeObject(line && line.properties);
      const sanitizedProperties = stripPublicUpsellProperties(currentProperties);
      if (serializeProperties(sanitizedProperties) === serializeProperties(currentProperties)) {
        return;
      }

      operations.push({
        type: "change",
        lineKey,
        quantity,
        properties: sanitizedProperties,
      });
    });

    return dedupeOperations(operations);
  }

  function buildFeeOperations(input) {
    const items = Array.isArray(input.items) ? input.items : [];
    const feeRules = Array.isArray(input.feeRules) ? input.feeRules : [];
    const tagLookup = input.tagLookup || { byLineKey: {}, byProductId: {} };

    const managedFeeLines = items.filter((item) => isManagedFeeLine(item));
    const operations = [];
    const feeRuleByKey = {};
    (Array.isArray(feeRules) ? feeRules : []).forEach((rule) => {
      const key = String(rule && rule.key ? rule.key : "").trim();
      if (!key) {
        return;
      }
      feeRuleByKey[key] = rule;
    });

    const desiredTargetsBySourceAndRule = {};
    (Array.isArray(items) ? items : []).forEach((line) => {
      if (!isEligibleFeeParentLine(line)) {
        return;
      }

      const sourceLineKey = String(line && line.key ? line.key : "").trim();
      if (!sourceLineKey) {
        return;
      }

      const targetQuantity = Math.max(0, parseInteger(line && line.quantity));
      if (!targetQuantity) {
        return;
      }

      const tags = resolveFeeTagsForLine(line, tagLookup);
      if (!tags.length) {
        return;
      }

      const matchedRules = resolveMatchedFeeRules(tags, feeRules);
      matchedRules.forEach((ruleKey) => {
        const rule = feeRuleByKey[ruleKey];
        const variantLegacyId = normalizeLegacyId(rule && rule.feeVariantLegacyId);
        if (!variantLegacyId) {
          return;
        }

        const targetKey = `${sourceLineKey}::${ruleKey}`;
        desiredTargetsBySourceAndRule[targetKey] = {
          sourceLineKey,
          sourceVariantLegacyId: normalizeLegacyId(line && line.variant_id),
          ruleKey,
          variantLegacyId,
          quantity: targetQuantity,
        };
      });
    });

    const managedBySourceAndRule = {};
    managedFeeLines.forEach((line) => {
      const lineKey = String(line && line.key ? line.key : "").trim();
      if (!lineKey) {
        return;
      }

      const managedRuleKey = resolveFeeRuleKeyForManagedLine(line, feeRules);
      const sourceLineKey = resolveFeeManagedSourceLineKey(items, line, feeRules, tagLookup);
      if (!managedRuleKey || !sourceLineKey) {
        return;
      }

      const targetKey = `${sourceLineKey}::${managedRuleKey}`;
      managedBySourceAndRule[targetKey] = managedBySourceAndRule[targetKey] || [];
      managedBySourceAndRule[targetKey].push(line);
    });

    const usedManagedLineKeys = new Set();
    Object.values(desiredTargetsBySourceAndRule).forEach((target) => {
      const targetKey = `${target.sourceLineKey}::${target.ruleKey}`;
      const existingLines = Array.isArray(managedBySourceAndRule[targetKey]) ? managedBySourceAndRule[targetKey] : [];

      const desiredManagedProperties = {
        [ATTR_FEE_MANAGED]: "1",
        [ATTR_FEE_RULE]: target.ruleKey,
        [ATTR_FEE_SOURCE]: target.sourceLineKey,
        [ATTR_FEE_SOURCE_VARIANT]:
          normalizeLegacyId(target.sourceVariantLegacyId) || extractVariantLegacyIdFromLineKey(target.sourceLineKey),
      };
      const addProperties = {
        ...desiredManagedProperties,
      };

      if (!existingLines.length) {
        operations.push({
          type: "add",
          variantLegacyId: target.variantLegacyId,
          quantity: target.quantity,
          properties: addProperties,
        });
        return;
      }

      const primary =
        existingLines.find((line) => normalizeLegacyId(line && line.variant_id) === target.variantLegacyId) || existingLines[0];
      const extras = existingLines.filter((line) => String(line && line.key ? line.key : "").trim() !== String(primary && primary.key ? primary.key : "").trim());

      extras.forEach((extra) => {
        const extraLineKey = String(extra && extra.key ? extra.key : "").trim();
        if (!extraLineKey) {
          return;
        }
        usedManagedLineKeys.add(extraLineKey);
        operations.push({
          type: "change",
          lineKey: extraLineKey,
          quantity: 0,
        });
      });

      const primaryLineKey = String(primary && primary.key ? primary.key : "").trim();
      if (!primaryLineKey) {
        operations.push({
          type: "add",
          variantLegacyId: target.variantLegacyId,
          quantity: target.quantity,
          properties: addProperties,
        });
        return;
      }

      usedManagedLineKeys.add(primaryLineKey);

      const primaryVariantMismatch = normalizeLegacyId(primary && primary.variant_id) !== target.variantLegacyId;
      const primaryQuantity = Math.max(0, parseInteger(primary && primary.quantity));
      const needsQuantityUpdate = primaryQuantity !== target.quantity;
      const strictPropertyMatch = lineHasProperties(primary, desiredManagedProperties);
      const needsPropertyUpdate = !lineHasPropertiesExcludingKeys(primary, desiredManagedProperties, [ATTR_FEE_SOURCE]);

      if (primaryVariantMismatch) {
        operations.push({
          type: "change",
          lineKey: primaryLineKey,
          quantity: 0,
        });
        operations.push({
          type: "add",
          variantLegacyId: target.variantLegacyId,
          quantity: target.quantity,
          properties: addProperties,
        });
        return;
      }

      if (needsQuantityUpdate || needsPropertyUpdate) {
        operations.push({
          type: "change",
          lineKey: primaryLineKey,
          quantity: target.quantity,
          properties: desiredManagedProperties,
        });
      } else if (!strictPropertyMatch) {
        debugLog("[qk-cart-rules] fee source-only skip", primaryLineKey);
      }
    });

    managedFeeLines.forEach((line) => {
      const lineKey = String(line && line.key ? line.key : "").trim();
      if (!lineKey || usedManagedLineKeys.has(lineKey)) {
        return;
      }

      operations.push({
        type: "change",
        lineKey,
        quantity: 0,
      });
    });

    return dedupeOperations(operations);
  }

  function buildFeeParentLineKeyMap(items, feeRules, tagLookup) {
    const byRule = {};
    const lineKeyLookup = safeObject(tagLookup && tagLookup.byLineKey);
    const productIdLookup = safeObject(tagLookup && tagLookup.byProductId);

    (Array.isArray(items) ? items : []).forEach((line) => {
      if (
        !line ||
        isManagedFeeLine(line) ||
        isManagedGiftLine(line) ||
        isManagedLubricationLine(line) ||
        isManagedGiftWrapLine(line) ||
        isManagedPackageInsuranceLine(line)
      ) {
        return;
      }

      const lineKey = String(line.key || "").trim();
      if (!lineKey) {
        return;
      }

      const productId = normalizeLegacyId(line.product_id);
      const hasLineTags = Object.prototype.hasOwnProperty.call(lineKeyLookup, lineKey);
      const hasProductTags = productId && Object.prototype.hasOwnProperty.call(productIdLookup, productId);
      if (!hasLineTags && !hasProductTags) {
        return;
      }

      const tags = hasLineTags ? lineKeyLookup[lineKey] : productIdLookup[productId];
      const matchedRules = resolveMatchedFeeRules(tags, feeRules);
      matchedRules.forEach((ruleKey) => {
        if (!byRule[ruleKey]) {
          byRule[ruleKey] = lineKey;
        }
      });
    });

    return byRule;
  }

  function buildLubricationOperations(input) {
    const items = Array.isArray(input.items) ? input.items : [];
    const lubricationConfig = safeObject(input.lubricationConfig);
    const ruleMaps = buildLubricationRuleMaps(lubricationConfig);
    const hydratedIntent = hydrateLubricationIntentFromSession(items, ruleMaps);
    const hydratedItems = Array.isArray(hydratedIntent.items) ? hydratedIntent.items : items;
    const removalIntentResult = applyPendingLubricationRemovalIntents(hydratedItems, ruleMaps);
    const sourceItems = Array.isArray(removalIntentResult.items) ? removalIntentResult.items : hydratedItems;

    const managedLubricationLines = items.filter((item) => isManagedLubricationLine(item));
    const desiredBySourceLineKey = {};
    const parentSelectionOperations = Array.isArray(removalIntentResult.operations)
      ? removalIntentResult.operations.slice()
      : [];

    sourceItems.forEach((line) => {
      if (!isEligibleLubricationParentLine(line)) {
        return;
      }

      const lineKey = String(line.key || "").trim();
      if (!lineKey) {
        return;
      }

      if (!isTruthyLineProperty(line, ATTR_LUBE_SELECTED)) {
        return;
      }

      const scope = normalizeLubricationScope(getLineProperty(line, ATTR_LUBE_SCOPE));
      if (!scope) {
        return;
      }

      const resolvedRule = resolveLubricationRuleForLine(line, ruleMaps);
      if (!resolvedRule) {
        return;
      }

      const targetQuantity = Math.max(1, parseInteger(line.quantity));
      const layoutAlias = resolveDesiredLubricationLayoutAlias({
        scope,
        line,
        rule: resolvedRule,
      });
      const desiredParentProperties = buildLubricationSelectionProperties({
        selected: true,
        scope,
        ruleKey: String(resolvedRule.key || ""),
        layoutAlias,
      });
      if (!lineHasProperties(line, desiredParentProperties) || lineHasPublicLubricationProperties(line)) {
        parentSelectionOperations.push({
          type: "change",
          lineKey,
          quantity: targetQuantity,
          properties: Object.assign({}, stripPublicLubricationProperties(line && line.properties), desiredParentProperties),
        });
      }

      desiredBySourceLineKey[lineKey] = {
        quantity: targetQuantity,
        rule: resolvedRule,
        scope,
        sourceVariantLegacyId: normalizeLegacyId(line && line.variant_id),
      };
    });

    const parentCandidates = sourceItems
      .filter((line) => isEligibleLubricationParentLine(line))
      .map((line) => ({
        line,
        lineKey: String(line.key || "").trim(),
        quantity: Math.max(1, parseInteger(line.quantity)),
        scope: normalizeLubricationScope(getLineProperty(line, ATTR_LUBE_SCOPE)),
        selected: isTruthyLineProperty(line, ATTR_LUBE_SELECTED),
        resolvedRule: resolveLubricationRuleForLine(line, ruleMaps),
      }))
      .filter((candidate) => Boolean(candidate.lineKey));

    if (managedLubricationLines.length && parentCandidates.length) {
      const usedParentLineKeys = new Set(Object.keys(desiredBySourceLineKey));

      managedLubricationLines.forEach((managedLine) => {
        const explicitSourceLineKey = normalizeManagedSourceLineKey(getLineProperty(managedLine, ATTR_LUBE_SOURCE));
        const resolvedSourceLineKey = resolveLubricationManagedSourceLineKey(sourceItems, managedLine, ruleMaps);
        if (resolvedSourceLineKey && desiredBySourceLineKey[resolvedSourceLineKey]) {
          usedParentLineKeys.add(resolvedSourceLineKey);
          return;
        }

        const managedRule = resolveLubricationRuleForManagedLine(managedLine, ruleMaps);
        if (!managedRule) {
          return;
        }

        const managedScope = normalizeLubricationScope(getLineProperty(managedLine, ATTR_LUBE_SCOPE)) || LUBE_SCOPE_KEYBOARD;
        const managedQuantity = Math.max(1, parseInteger(managedLine && managedLine.quantity));
        let selectedCandidate = null;

        if (resolvedSourceLineKey) {
          const resolvedCandidate = parentCandidates.find((candidate) => candidate.lineKey === resolvedSourceLineKey) || null;
          if (resolvedCandidate && resolvedCandidate.selected) {
            selectedCandidate = resolvedCandidate;
          }
        }

        if (!selectedCandidate && explicitSourceLineKey) {
          const explicitCandidate = parentCandidates.find((candidate) => candidate.lineKey === explicitSourceLineKey) || null;
          if (explicitCandidate && explicitCandidate.selected) {
            selectedCandidate = explicitCandidate;
          }
        }

        if (!selectedCandidate) {
          const availableSelectedCandidates = parentCandidates.filter((candidate) => {
            if (usedParentLineKeys.has(candidate.lineKey)) {
              return false;
            }
            return candidate.selected;
          });

          const sameRuleCandidates = availableSelectedCandidates.filter((candidate) => {

            if (managedScope && candidate.scope && candidate.scope !== managedScope) {
              return false;
            }

            if (candidate.resolvedRule && candidate.resolvedRule.key) {
              return candidate.resolvedRule.key === managedRule.key;
            }

            return true;
          });

          const sameScopeCandidates = availableSelectedCandidates.filter((candidate) => {
            if (!managedScope || !candidate.scope) {
              return true;
            }

            return candidate.scope === managedScope;
          });

          selectedCandidate =
            pickLubricationParentCandidate(sameRuleCandidates, managedQuantity) ||
            pickLubricationParentCandidate(sameScopeCandidates, managedQuantity) ||
            pickLubricationParentCandidate(availableSelectedCandidates, managedQuantity);
        }

        if (!selectedCandidate) {
          return;
        }

        const selectedLine = selectedCandidate.line;
        const selectedScope = selectedCandidate.scope || managedScope;
        usedParentLineKeys.add(selectedCandidate.lineKey);
        desiredBySourceLineKey[selectedCandidate.lineKey] = {
          quantity: selectedCandidate.quantity,
          rule: managedRule,
          scope: selectedScope,
          sourceVariantLegacyId: normalizeLegacyId(selectedLine && selectedLine.variant_id),
        };

        const layoutAlias = resolveDesiredLubricationLayoutAlias({
          scope: selectedScope,
          line: selectedLine,
          rule: managedRule,
        });
        const desiredParentProperties = buildLubricationSelectionProperties({
          selected: true,
          scope: selectedScope,
          ruleKey: String(managedRule.key || ""),
          layoutAlias,
        });

        if (!lineHasProperties(selectedLine, desiredParentProperties) || lineHasPublicLubricationProperties(selectedLine)) {
          parentSelectionOperations.push({
            type: "change",
            lineKey: selectedCandidate.lineKey,
            quantity: selectedCandidate.quantity,
            properties: Object.assign(
              {},
              stripPublicLubricationProperties(selectedLine && selectedLine.properties),
              desiredParentProperties,
            ),
          });
        }
      });
    }

    const operations = Array.isArray(hydratedIntent.propertyOperations)
      ? hydratedIntent.propertyOperations.concat(parentSelectionOperations)
      : parentSelectionOperations.slice();

    const managedLineSourceByLineKey = {};
    managedLubricationLines.forEach((line) => {
      const lineKey = String(line && line.key ? line.key : "").trim();
      if (!lineKey) {
        return;
      }
      const resolvedSourceLineKey = resolveLubricationManagedSourceLineKey(sourceItems, line, ruleMaps);
      if (!resolvedSourceLineKey) {
        managedLineSourceByLineKey[lineKey] = "";
        return;
      }

      const resolvedSourceCandidate = parentCandidates.find((candidate) => candidate.lineKey === resolvedSourceLineKey) || null;
      managedLineSourceByLineKey[lineKey] = resolvedSourceCandidate && resolvedSourceCandidate.selected
        ? resolvedSourceLineKey
        : "";
    });

    const seenManagedBySourceAndVariant = {};
    managedLubricationLines.forEach((line) => {
      const lineKey = String(line && line.key ? line.key : "").trim();
      const sourceLineKey =
        String(managedLineSourceByLineKey[lineKey] || "").trim() ||
        normalizeManagedSourceLineKey(getLineProperty(line, ATTR_LUBE_SOURCE));
      const variantLegacyId = normalizeLegacyId(line && line.variant_id);
      if (!sourceLineKey || !variantLegacyId || !lineKey) {
        return;
      }

      const dedupeKey = `${sourceLineKey}::${variantLegacyId}`;
      if (seenManagedBySourceAndVariant[dedupeKey]) {
        operations.push({
          type: "change",
          lineKey,
          quantity: 0,
        });
        return;
      }

      seenManagedBySourceAndVariant[dedupeKey] = lineKey;
    });

    managedLubricationLines.forEach((line) => {
      const lineKey = String(line && line.key ? line.key : "").trim();
      const sourceLineKey =
        String(managedLineSourceByLineKey[lineKey] || "").trim() ||
        normalizeManagedSourceLineKey(getLineProperty(line, ATTR_LUBE_SOURCE));
      if (!sourceLineKey || !desiredBySourceLineKey[sourceLineKey]) {
        operations.push({
          type: "change",
          lineKey: line.key,
          quantity: 0,
        });
      }
    });

    Object.keys(desiredBySourceLineKey).forEach((sourceLineKey) => {
      const desired = desiredBySourceLineKey[sourceLineKey];
      const rule = desired.rule;
      const desiredScope = normalizeLubricationScope(desired.scope) || LUBE_SCOPE_KEYBOARD;
      const variantLegacyId = normalizeLegacyId(rule && rule.variantLegacyId);
      const sourceLineMatches = managedLubricationLines.filter(
        (line) => {
          const lineKey = String(line && line.key ? line.key : "").trim();
          const resolvedSourceLineKey =
            String(managedLineSourceByLineKey[lineKey] || "").trim() ||
            normalizeManagedSourceLineKey(getLineProperty(line, ATTR_LUBE_SOURCE));
          return resolvedSourceLineKey === sourceLineKey;
        },
      );

      if (!variantLegacyId) {
        sourceLineMatches.forEach((line) => {
          operations.push({
            type: "change",
            lineKey: line.key,
            quantity: 0,
          });
        });
        return;
      }

      const desiredManagedProperties = buildLubricationManagedProperties({
        sourceLineKey,
        sourceVariantLegacyId:
          normalizeLegacyId(desired && desired.sourceVariantLegacyId) || extractVariantLegacyIdFromLineKey(sourceLineKey),
        scope: desiredScope,
        ruleKey: String(rule.key || ""),
      });

      const addProperties = {
        ...desiredManagedProperties,
      };

      if (!sourceLineMatches.length) {
        operations.push({
          type: "add",
          variantLegacyId,
          quantity: desired.quantity,
          properties: addProperties,
        });
        return;
      }

      const primary =
        sourceLineMatches.find((line) => normalizeLegacyId(line.variant_id) === variantLegacyId) || sourceLineMatches[0];
      const extras = sourceLineMatches.filter((line) => line.key !== primary.key);

      extras.forEach((line) => {
        operations.push({
          type: "change",
          lineKey: line.key,
          quantity: 0,
        });
      });

      const primaryVariantMismatch = normalizeLegacyId(primary.variant_id) !== variantLegacyId;
      const primaryQuantity = Math.max(0, parseInteger(primary.quantity));
      const needsQuantityUpdate = primaryQuantity !== desired.quantity;
      const strictPropertyMatch = lineHasProperties(primary, desiredManagedProperties);
      const needsPropertyUpdate =
        !lineHasPropertiesExcludingKeys(primary, desiredManagedProperties, [ATTR_LUBE_SOURCE]) ||
        lineHasPublicLubricationProperties(primary);

      if (primaryVariantMismatch) {
        operations.push({
          type: "change",
          lineKey: primary.key,
          quantity: 0,
        });
        operations.push({
          type: "add",
          variantLegacyId,
          quantity: desired.quantity,
          properties: addProperties,
        });
        return;
      }

      if (needsQuantityUpdate || needsPropertyUpdate) {
        operations.push({
          type: "change",
          lineKey: primary.key,
          quantity: desired.quantity,
          properties: desiredManagedProperties,
        });
      } else if (!strictPropertyMatch) {
        debugLog("[qk-cart-rules] lube source-only skip", primary.key);
      }
    });

    if (hydratedIntent.clearIntent) {
      clearPendingLubricationIntentSnapshot();
    }

    return dedupeOperations(operations);
  }

  function normalizeLubricationScope(value) {
    const normalized = String(value == null ? "" : value).trim().toLowerCase();
    if (normalized === LUBE_SCOPE_KEYBOARD || normalized === LUBE_SCOPE_SWITCH) {
      return normalized;
    }

    return "";
  }

  function resolveDesiredLubricationLayoutAlias(input) {
    const payload = input && typeof input === "object" ? input : {};
    const scope = normalizeLubricationScope(payload.scope);
    const line = payload.line;
    const rule = safeObject(payload.rule);
    if (scope !== LUBE_SCOPE_KEYBOARD) {
      return "";
    }

    const explicitLayoutAlias = normalizeLayoutAlias(getLineProperty(line, ATTR_LUBE_LAYOUT));
    const fallbackLayoutAlias = normalizeLayoutAlias(
      (Array.isArray(rule.aliases) && rule.aliases[0]) || rule.key || "",
    );
    return explicitLayoutAlias || fallbackLayoutAlias;
  }

  function buildLubricationSelectionProperties(input) {
    const payload = input && typeof input === "object" ? input : {};
    const selected = payload.selected ? "1" : "0";
    const scope = normalizeLubricationScope(payload.scope);
    const ruleKey = String(payload.ruleKey || "").trim();
    const layoutAlias = normalizeLayoutAlias(payload.layoutAlias);

    return {
      [ATTR_LUBE_SELECTED]: selected,
      [ATTR_LUBE_SCOPE]: scope,
      [ATTR_LUBE_RULE]: ruleKey,
      [ATTR_LUBE_LAYOUT]: layoutAlias,
    };
  }

  function buildLubricationManagedProperties(input) {
    const payload = input && typeof input === "object" ? input : {};
    const sourceLineKey = String(payload.sourceLineKey || "").trim();
    const sourceVariantLegacyId =
      normalizeLegacyId(payload.sourceVariantLegacyId) || extractVariantLegacyIdFromLineKey(sourceLineKey);
    const scope = normalizeLubricationScope(payload.scope);
    const ruleKey = String(payload.ruleKey || "").trim();

    return {
      [ATTR_LUBE_MANAGED]: "1",
      [ATTR_LUBE_SOURCE]: sourceLineKey,
      [ATTR_LUBE_SOURCE_VARIANT]: sourceVariantLegacyId,
      [ATTR_LUBE_SCOPE]: scope,
      [ATTR_LUBE_RULE]: ruleKey,
    };
  }

  function stripPublicLubricationProperties(properties) {
    const sanitized = Object.assign({}, safeObject(properties));
    LUBE_PUBLIC_ATTR_KEYS.forEach((propertyKey) => {
      if (Object.prototype.hasOwnProperty.call(sanitized, propertyKey)) {
        delete sanitized[propertyKey];
      }
    });
    return sanitized;
  }

  function lineHasPublicLubricationProperties(line) {
    const properties = safeObject(line && line.properties);
    return LUBE_PUBLIC_ATTR_KEYS.some((propertyKey) => {
      return Object.prototype.hasOwnProperty.call(properties, propertyKey);
    });
  }

  function stripPublicUpsellProperties(properties) {
    const sanitized = Object.assign({}, safeObject(properties));
    UPSELL_PUBLIC_ATTR_KEYS.forEach((propertyKey) => {
      if (Object.prototype.hasOwnProperty.call(sanitized, propertyKey)) {
        delete sanitized[propertyKey];
      }
    });
    return sanitized;
  }

  function lineHasPublicUpsellProperties(line) {
    const properties = safeObject(line && line.properties);
    return UPSELL_PUBLIC_ATTR_KEYS.some((propertyKey) => {
      return Object.prototype.hasOwnProperty.call(properties, propertyKey);
    });
  }

  function resolveLubricationRuleForManagedLine(line, ruleMaps) {
    const resolvedByProperties = resolveLubricationRuleForLine(line, ruleMaps);
    if (resolvedByProperties) {
      return resolvedByProperties;
    }

    const productLegacyId = normalizeLegacyId(line && line.product_id);
    if (!productLegacyId) {
      return null;
    }

    const rules = Array.isArray(ruleMaps && ruleMaps.rules) ? ruleMaps.rules : [];
    return rules.find((rule) => normalizeLegacyId(rule && rule.productLegacyId) === productLegacyId) || null;
  }

  function pickLubricationParentCandidate(candidates, managedQuantity) {
    const list = Array.isArray(candidates) ? candidates : [];
    if (!list.length) {
      return null;
    }

    const exactMatch = list.find((candidate) => Math.max(1, parseInteger(candidate && candidate.quantity)) === managedQuantity);
    return exactMatch || list[0];
  }

  function hydrateLubricationIntentFromSession(items, ruleMaps) {
    const intent = readPendingLubricationIntentSnapshot();
    if (!intent) {
      return {
        items,
        propertyOperations: [],
        clearIntent: false,
      };
    }

    const intentScope = normalizeLubricationScope(intent.scope);
    if (!intentScope) {
      return {
        items,
        propertyOperations: [],
        clearIntent: true,
      };
    }

    const byKey = safeObject(ruleMaps && ruleMaps.byKey);
    if (!byKey[intent.ruleKey]) {
      return {
        items,
        propertyOperations: [],
        clearIntent: true,
      };
    }

    const candidateLines = (Array.isArray(items) ? items : []).filter((line) => {
      if (!isEligibleLubricationParentLine(line)) {
        return false;
      }

      if (normalizeLegacyId(line.product_id) !== intent.productLegacyId) {
        return false;
      }

      return Math.max(0, parseInteger(line.quantity)) > 0;
    });

    if (!candidateLines.length) {
      return {
        items,
        propertyOperations: [],
        clearIntent: false,
      };
    }

    const hasMatchingSelectedLine = candidateLines.some((line) => {
      if (!isTruthyLineProperty(line, ATTR_LUBE_SELECTED)) {
        return false;
      }

      const scope = normalizeLubricationScope(getLineProperty(line, ATTR_LUBE_SCOPE));
      if (scope !== intentScope) {
        return false;
      }

      const resolvedRule = resolveLubricationRuleForLine(line, ruleMaps);
      return Boolean(resolvedRule && resolvedRule.key === intent.ruleKey);
    });

    if (hasMatchingSelectedLine) {
      return {
        items,
        propertyOperations: [],
        clearIntent: true,
      };
    }

    const preferredByVariant = intent.variantLegacyId
      ? candidateLines.filter((line) => normalizeLegacyId(line.variant_id) === intent.variantLegacyId)
      : [];
    let candidatePool = preferredByVariant.length ? preferredByVariant : candidateLines;

    const unselectedCandidates = candidatePool.filter((line) => !isTruthyLineProperty(line, ATTR_LUBE_SELECTED));
    if (unselectedCandidates.length) {
      candidatePool = unselectedCandidates;
    }

    const quantityMatchedCandidate = candidatePool.find(
      (line) => Math.max(1, parseInteger(line.quantity)) === intent.quantity,
    );
    const candidate = quantityMatchedCandidate || candidatePool[0];
    if (!candidate) {
      return {
        items,
        propertyOperations: [],
        clearIntent: false,
      };
    }

    const rule = safeObject(byKey[intent.ruleKey]);
    const fallbackLayoutAlias = intentScope === LUBE_SCOPE_KEYBOARD
      ? normalizeLayoutAlias((Array.isArray(rule.aliases) && rule.aliases[0]) || intent.ruleKey || "")
      : "";
    const desiredLayoutAlias = intentScope === LUBE_SCOPE_KEYBOARD
      ? (
          normalizeLayoutAlias(intent.layoutKey) ||
          normalizeLayoutAlias(getLineProperty(candidate, ATTR_LUBE_LAYOUT)) ||
          fallbackLayoutAlias
        )
      : "";

    const desiredSelectionProperties = buildLubricationSelectionProperties({
      selected: true,
      scope: intentScope,
      ruleKey: intent.ruleKey,
      layoutAlias: desiredLayoutAlias,
    });

    if (lineHasProperties(candidate, desiredSelectionProperties) && !lineHasPublicLubricationProperties(candidate)) {
      return {
        items,
        propertyOperations: [],
        clearIntent: true,
      };
    }

    const lineKey = String(candidate.key || "").trim();
    if (!lineKey) {
      return {
        items,
        propertyOperations: [],
        clearIntent: false,
      };
    }

    const mergedProperties = Object.assign(
      {},
      stripPublicLubricationProperties(candidate && candidate.properties),
      desiredSelectionProperties,
    );
    const nextItems = items.map((line) => {
      if (String(line && line.key ? line.key : "").trim() !== lineKey) {
        return line;
      }

      return Object.assign({}, line, {
        properties: mergedProperties,
      });
    });

    return {
      items: nextItems,
      propertyOperations: [
        {
          type: "change",
          lineKey,
          quantity: Math.max(1, parseInteger(candidate.quantity)),
          properties: mergedProperties,
        },
      ],
      clearIntent: false,
    };
  }

  function readPendingLubricationIntentSnapshot() {
    let rawValue = "";
    try {
      rawValue = String(window.sessionStorage.getItem(LUBE_INTENT_STORAGE_KEY) || "").trim();
    } catch {
      return null;
    }

    if (!rawValue) {
      return null;
    }

    let parsed = null;
    try {
      parsed = JSON.parse(rawValue);
    } catch {
      clearPendingLubricationIntentSnapshot();
      return null;
    }

    const source = safeObject(parsed);
    const selected = Boolean(source.selected);
    const createdAt = Number(source.createdAt || 0);
    const isExpired = !Number.isFinite(createdAt) || createdAt <= 0 || Date.now() - createdAt > LUBE_INTENT_TTL_MS;

    if (!selected || isExpired) {
      clearPendingLubricationIntentSnapshot();
      return null;
    }

    const scope = normalizeLubricationScope(source.scope);
    const productLegacyId = normalizeLegacyId(source.productLegacyId);
    const ruleKey = String(source.ruleKey || "").trim();

    if (!scope || !productLegacyId || !ruleKey) {
      clearPendingLubricationIntentSnapshot();
      return null;
    }

    return {
      scope,
      productLegacyId,
      variantLegacyId: normalizeLegacyId(source.variantLegacyId),
      quantity: Math.max(1, parseInteger(source.quantity)),
      ruleKey,
      layoutKey: scope === LUBE_SCOPE_KEYBOARD ? normalizeLayoutAlias(source.layoutKey) : "",
    };
  }

  function clearPendingLubricationIntentSnapshot() {
    try {
      window.sessionStorage.removeItem(LUBE_INTENT_STORAGE_KEY);
    } catch {
      // ignore storage failures
    }
  }

  function queueLubricationRemovalIntent(input) {
    const payload = input && typeof input === "object" ? input : {};
    const parentLineKey = String(payload.parentLineKey || "").trim();
    const parentVariantLegacyId = normalizeLegacyId(payload.parentVariantLegacyId);
    const managedLineKey = String(payload.managedLineKey || "").trim();
    const managedRuleKey = String(payload.managedRuleKey || "").trim();

    if (!parentLineKey && !parentVariantLegacyId && !managedLineKey) {
      return;
    }

    const intents = Array.isArray(state.lubricationRemovalIntents) ? state.lubricationRemovalIntents : [];
    const now = Date.now();
    const dedupeKey = [parentLineKey, parentVariantLegacyId, managedLineKey, managedRuleKey].join("::");
    const nextIntents = intents.filter((intent) => {
      const intentCreatedAt = Number(intent && intent.createdAt ? intent.createdAt : 0);
      if (!Number.isFinite(intentCreatedAt) || now - intentCreatedAt > LUBE_REMOVE_INTENT_TTL_MS) {
        return false;
      }
      const intentDedupeKey = [
        String(intent && intent.parentLineKey ? intent.parentLineKey : ""),
        String(intent && intent.parentVariantLegacyId ? intent.parentVariantLegacyId : ""),
        String(intent && intent.managedLineKey ? intent.managedLineKey : ""),
        String(intent && intent.managedRuleKey ? intent.managedRuleKey : ""),
      ].join("::");
      return intentDedupeKey !== dedupeKey;
    });

    nextIntents.push({
      createdAt: now,
      parentLineKey,
      parentVariantLegacyId,
      managedLineKey,
      managedRuleKey,
    });

    state.lubricationRemovalIntents = nextIntents;
  }

  function applyPendingLubricationRemovalIntents(items, ruleMaps) {
    const sourceItems = Array.isArray(items) ? items : [];
    const intents = Array.isArray(state.lubricationRemovalIntents) ? state.lubricationRemovalIntents : [];
    if (!sourceItems.length || !intents.length) {
      return {
        items: sourceItems,
        operations: [],
      };
    }

    const now = Date.now();
    const activeIntents = intents.filter((intent) => {
      const createdAt = Number(intent && intent.createdAt ? intent.createdAt : 0);
      return Number.isFinite(createdAt) && now - createdAt <= LUBE_REMOVE_INTENT_TTL_MS;
    });
    if (!activeIntents.length) {
      state.lubricationRemovalIntents = [];
      return {
        items: sourceItems,
        operations: [],
      };
    }

    const operationsByLineKey = {};
    const mutatedItemsByLineKey = {};
    sourceItems.forEach((line) => {
      const lineKey = String(line && line.key ? line.key : "").trim();
      if (!lineKey) {
        return;
      }
      mutatedItemsByLineKey[lineKey] = line;
    });

    const remainingIntents = [];
    activeIntents.forEach((intent) => {
      const parentLineKey = String(intent && intent.parentLineKey ? intent.parentLineKey : "").trim();
      const parentVariantLegacyId = normalizeLegacyId(intent && intent.parentVariantLegacyId);
      const managedLineKey = String(intent && intent.managedLineKey ? intent.managedLineKey : "").trim();
      const managedRuleKey = String(intent && intent.managedRuleKey ? intent.managedRuleKey : "").trim();

      let parentLine = null;
      if (parentLineKey) {
        parentLine = mutatedItemsByLineKey[parentLineKey] || null;
      }

      if (!parentLine && parentVariantLegacyId) {
        parentLine =
          sourceItems.find((line) => {
            return (
              isEligibleLubricationParentLine(line) &&
              normalizeLegacyId(line && line.variant_id) === parentVariantLegacyId
            );
          }) || null;
      }

      if (!parentLine && managedLineKey) {
        const managedLine = mutatedItemsByLineKey[managedLineKey] || null;
        if (managedLine) {
          const resolvedSourceLineKey = resolveLubricationManagedSourceLineKey(sourceItems, managedLine, ruleMaps);
          if (resolvedSourceLineKey) {
            parentLine = mutatedItemsByLineKey[resolvedSourceLineKey] || parentLine;
          }
        }
      }

      if (!parentLine && managedRuleKey) {
        parentLine =
          sourceItems.find((line) => {
            if (!isEligibleLubricationParentLine(line)) {
              return false;
            }
            if (!isTruthyLineProperty(line, ATTR_LUBE_SELECTED)) {
              return false;
            }
            const resolvedRule = resolveLubricationRuleForLine(line, ruleMaps);
            return Boolean(resolvedRule && String(resolvedRule.key || "") === managedRuleKey);
          }) || null;
      }

      const resolvedParentLineKey = String(parentLine && parentLine.key ? parentLine.key : "").trim();
      if (!resolvedParentLineKey || !parentLine) {
        remainingIntents.push(intent);
        return;
      }

      const parentQuantity = Math.max(1, parseInteger(parentLine && parentLine.quantity));
      const deselectedProperties = buildLubricationSelectionProperties({
        selected: false,
        scope: "",
        ruleKey: "",
        layoutAlias: "",
      });
      const mergedParentProperties = Object.assign(
        {},
        stripPublicLubricationProperties(parentLine && parentLine.properties),
        deselectedProperties,
      );

      operationsByLineKey[resolvedParentLineKey] = {
        type: "change",
        lineKey: resolvedParentLineKey,
        quantity: parentQuantity,
        properties: mergedParentProperties,
      };

      mutatedItemsByLineKey[resolvedParentLineKey] = Object.assign({}, parentLine, {
        properties: mergedParentProperties,
      });
    });

    state.lubricationRemovalIntents = remainingIntents;

    const nextItems = sourceItems.map((line) => {
      const lineKey = String(line && line.key ? line.key : "").trim();
      return lineKey && mutatedItemsByLineKey[lineKey] ? mutatedItemsByLineKey[lineKey] : line;
    });

    return {
      items: nextItems,
      operations: Object.values(operationsByLineKey),
    };
  }

  function buildLubricationRuleMaps(config) {
    const rules = collectLubricationConfigRules(config);

    const byKey = {};
    const byAlias = {};

    rules.forEach((rawRule) => {
      const rule = safeObject(rawRule);
      const key = String(rule.key || "").trim();
      const productLegacyId = normalizeLegacyId(rule.productLegacyId);
      const variantLegacyId = normalizeLegacyId(rule.variantLegacyId);
      const aliases = Array.isArray(rule.aliases)
        ? rule.aliases.map((alias) => normalizeLayoutAlias(alias)).filter(Boolean)
        : [];

      if (!key || !productLegacyId) {
        return;
      }

      const normalizedRule = {
        key,
        productLegacyId,
        variantLegacyId,
        aliases,
        inStock: rule.inStock !== false,
      };

      byKey[key] = normalizedRule;
      aliases.forEach((alias) => {
        if (!byAlias[alias]) {
          byAlias[alias] = normalizedRule;
        }
      });
    });

    return {
      rules: Object.values(byKey),
      byKey,
      byAlias,
    };
  }

  function resolveLubricationRuleForLine(line, ruleMaps) {
    const maps = safeObject(ruleMaps);
    const byKey = safeObject(maps.byKey);
    const byAlias = safeObject(maps.byAlias);

    const explicitRuleKey = String(getLineProperty(line, ATTR_LUBE_RULE) || "").trim();
    if (explicitRuleKey && byKey[explicitRuleKey]) {
      return byKey[explicitRuleKey];
    }

    const layoutAlias = normalizeLayoutAlias(getLineProperty(line, ATTR_LUBE_LAYOUT));
    if (layoutAlias && byAlias[layoutAlias]) {
      return byAlias[layoutAlias];
    }

    return null;
  }

  function isTruthyLineProperty(line, propertyName) {
    const raw = String(getLineProperty(line, propertyName) || "").trim().toLowerCase();
    return ["1", "true", "yes", "da", "on"].includes(raw);
  }

  function dedupeOperations(operations) {
    const seen = new Set();
    const deduped = [];

    for (const operation of operations) {
      const key = serializeOperation(operation);
      if (seen.has(key)) {
        continue;
      }
      seen.add(key);
      deduped.push(operation);
    }

    return deduped;
  }

  function serializeOperation(operation) {
    if (operation.type === "add") {
      return `add:${operation.variantLegacyId}:${operation.quantity}:${serializeProperties(operation.properties)}`;
    }

    return `change:${operation.lineKey}:${operation.quantity}:${serializeProperties(operation.properties)}`;
  }

  function serializeProperties(properties) {
    if (!properties || typeof properties !== "object") {
      return "";
    }

    return Object.keys(properties)
      .sort()
      .map((key) => `${key}=${properties[key]}`)
      .join("|");
  }

  function computeDesiredFeeQuantities(input) {
    const items = Array.isArray(input.items) ? input.items : [];
    const feeRules = Array.isArray(input.feeRules) ? input.feeRules : [];
    const tagLookup = input.tagLookup || { byLineKey: {}, byProductId: {} };

    const desired = buildEmptyFeeQuantityMap(feeRules);

    for (const line of items) {
      if (
        isManagedFeeLine(line) ||
        isManagedGiftLine(line) ||
        isManagedLubricationLine(line) ||
        isManagedGiftWrapLine(line) ||
        isManagedPackageInsuranceLine(line)
      ) {
        continue;
      }

      const quantity = Math.max(0, parseInteger(line.quantity));
      if (!quantity) {
        continue;
      }

      const lineKey = String(line.key || "");
      const productId = normalizeLegacyId(line.product_id);
      const hasLineTags = lineKey ? Object.prototype.hasOwnProperty.call(tagLookup.byLineKey, lineKey) : false;
      const hasProductTags = productId ? Object.prototype.hasOwnProperty.call(tagLookup.byProductId, productId) : false;
      if (!hasLineTags && !hasProductTags) {
        return {
          desiredQuantities: buildEmptyFeeQuantityMap(feeRules),
          tagsReady: false,
        };
      }

      const tags = hasLineTags ? tagLookup.byLineKey[lineKey] : tagLookup.byProductId[productId];

      if (!tags.length) {
        continue;
      }

      const matchedRules = resolveMatchedFeeRules(tags, feeRules);
      matchedRules.forEach((ruleKey) => {
        desired[ruleKey] += quantity;
      });
    }

    return {
      desiredQuantities: desired,
      tagsReady: true,
    };
  }

  function buildEmptyFeeQuantityMap(feeRules) {
    const map = {
      heavy_keyboard: 0,
      casti_or_keyboards: 0,
      mouse_or_cable_not_mouse_cover: 0,
    };

    if (!Array.isArray(feeRules)) {
      return map;
    }

    feeRules.forEach((rule) => {
      const key = String(rule && rule.key ? rule.key : "");
      if (KNOWN_FEE_RULE_KEYS.includes(key)) {
        map[key] = 0;
      }
    });

    return map;
  }

  function resolveMatchedFeeRules(tags, feeRules) {
    const normalizedTags = normalizeTagList(tags);
    const tagSet = new Set(normalizedTags);

    const matchedRules = feeRules.filter((rule) => {
      const includesAny = (rule.includeTags || []).some((tag) => tagSet.has(tag));
      if (!includesAny) {
        return false;
      }

      const excluded = (rule.excludeTags || []).some((tag) => tagSet.has(tag));
      return !excluded;
    });

    if (!matchedRules.length) {
      return [];
    }

    const suppressed = new Set();
    matchedRules.forEach((rule) => {
      (rule.suppresses || []).forEach((suppressedRule) => {
        suppressed.add(suppressedRule);
      });
    });

    return matchedRules
      .map((rule) => rule.key)
      .filter((ruleKey) => !suppressed.has(ruleKey));
  }

  function buildDesiredConfigAttributes(config, thresholdBasisCents) {
    const tier1 = config.gift.tiers[0];
    const tier2 = config.gift.tiers[1];
    const tier3 = config.gift.tiers[2];

    const stockByTier = {
      1: Boolean(tier1 && tier1.inStock !== false && normalizeLegacyId(tier1.giftVariantLegacyId)),
      2: Boolean(tier2 && tier2.inStock !== false && normalizeLegacyId(tier2.giftVariantLegacyId)),
      3: Boolean(tier3 && tier3.inStock !== false && normalizeLegacyId(tier3.giftVariantLegacyId)),
    };

    const raw = {
      threshold1: String(Math.round(tier1.thresholdCents / 100)),
      threshold2: String(Math.round(tier2.thresholdCents / 100)),
      threshold3: String(Math.round(tier3.thresholdCents / 100)),
      gift1: tier1.giftProductLegacyId,
      gift2: tier2.giftProductLegacyId,
      gift3: tier3.giftProductLegacyId,
      tier1Enabled: tier1.enabled ? "1" : "0",
      tier2Enabled: tier2.enabled ? "1" : "0",
      tier3Enabled: tier3.enabled ? "1" : "0",
      tier1InStock: stockByTier[1] ? "1" : "0",
      tier2InStock: stockByTier[2] ? "1" : "0",
      tier3InStock: stockByTier[3] ? "1" : "0",
      stackUnlocked: config.gift.mode === "cumulative" ? "1" : "0",
    };

    const hashInput = [
      raw.threshold1,
      raw.threshold2,
      raw.threshold3,
      raw.gift1,
      raw.gift2,
      raw.gift3,
      raw.tier1Enabled,
      raw.tier2Enabled,
      raw.tier3Enabled,
      raw.tier1InStock,
      raw.tier2InStock,
      raw.tier3InStock,
      raw.stackUnlocked,
    ].join("|");

    return {
      [ATTR_CFG_THRESHOLD_1]: raw.threshold1,
      [ATTR_CFG_THRESHOLD_2]: raw.threshold2,
      [ATTR_CFG_THRESHOLD_3]: raw.threshold3,
      [ATTR_CFG_GIFT_1]: raw.gift1,
      [ATTR_CFG_GIFT_2]: raw.gift2,
      [ATTR_CFG_GIFT_3]: raw.gift3,
      [ATTR_CFG_TIER_1_ENABLED]: raw.tier1Enabled,
      [ATTR_CFG_TIER_2_ENABLED]: raw.tier2Enabled,
      [ATTR_CFG_TIER_3_ENABLED]: raw.tier3Enabled,
      [ATTR_CFG_TIER_1_IN_STOCK]: raw.tier1InStock,
      [ATTR_CFG_TIER_2_IN_STOCK]: raw.tier2InStock,
      [ATTR_CFG_TIER_3_IN_STOCK]: raw.tier3InStock,
      [ATTR_CFG_STACK_UNLOCKED]: raw.stackUnlocked,
      [ATTR_CFG_THRESHOLD_BASIS]: String(Math.max(0, Math.round(thresholdBasisCents))),
      [ATTR_CFG_HASH]: hashInput,
    };
  }

  function buildDesiredB2bCheckoutAttributes(cart) {
    const currentAttributes = safeObject(cart && cart.attributes);
    const currentValue = String(currentAttributes[ATTR_B2B_CHECKOUT] == null ? "" : currentAttributes[ATTR_B2B_CHECKOUT]);

    if (isB2bCheckoutContext()) {
      return {
        [ATTR_B2B_CHECKOUT]: "1",
      };
    }

    if (currentValue) {
      return {
        [ATTR_B2B_CHECKOUT]: "0",
      };
    }

    return {};
  }

  function diffCartAttributes(cart, desiredAttributes) {
    const currentAttributes = safeObject(cart && cart.attributes);
    const updates = {};

    Object.keys(desiredAttributes).forEach((key) => {
      const desiredValue = String(desiredAttributes[key]);
      const currentValue = String(currentAttributes[key] == null ? "" : currentAttributes[key]);
      if (desiredValue !== currentValue) {
        updates[key] = desiredValue;
      }
    });

    return updates;
  }

  function needsB2bCheckoutAttributeSync() {
    const cart = normalizeCartPayload(state.lastCart) || getPreferredCartPageSeed();
    const isB2bCheckout = isB2bCheckoutContext();
    if (!cart) {
      return isB2bCheckout;
    }

    const currentAttributes = safeObject(cart && cart.attributes);
    const currentValue = String(currentAttributes[ATTR_B2B_CHECKOUT] == null ? "" : currentAttributes[ATTR_B2B_CHECKOUT]);
    return isB2bCheckout ? currentValue !== "1" : currentValue === "1";
  }

  function isB2bCheckoutContext() {
    return Boolean(getCustomerContext().b2b);
  }

  function getCustomerContext() {
    if (state.customerContext) {
      return state.customerContext;
    }

    const rawContext = safeObject(parseJsonScript("qk-customer-context"));
    state.customerContext = {
      b2b: readBoolean(rawContext.b2b, false),
      companyId: String(rawContext.companyId || "").trim(),
      companyName: String(rawContext.companyName || "").trim(),
    };
    return state.customerContext;
  }

  function collectFeeTagLookupsFromDom() {
    const byLineKey = {};
    const byProductId = {};
    const roots = [];
    const mainCartHost = document.querySelector("[data-main-cart-section-id]");
    const mainCartSection =
      (mainCartHost instanceof Element && mainCartHost.closest(".shopify-section")) ||
      (mainCartHost instanceof Element ? mainCartHost : null);
    if (isCartPagePath() && mainCartSection instanceof Element) {
      roots.push(mainCartSection);
    }

    const drawerElement = resolveCartDrawerElement();
    if (drawerElement instanceof HTMLElement && drawerElement.hasAttribute("open")) {
      const drawerInner = drawerElement.querySelector(".cart-drawer__inner");
      roots.push(drawerInner instanceof Element ? drawerInner : drawerElement);
    }

    if (!roots.length) {
      roots.push(document);
    }

    const seenLineKeys = new Set();
    roots.forEach((root) => {
      const lineItemElements = root && root.querySelectorAll ? root.querySelectorAll("line-item[data-line-key]") : [];
      lineItemElements.forEach((lineItemElement) => {
        const lineKey = String(lineItemElement.getAttribute("data-line-key") || "");
        if (!lineKey || seenLineKeys.has(lineKey)) {
          return;
        }
        seenLineKeys.add(lineKey);

        const productId = normalizeLegacyId(lineItemElement.getAttribute("data-product-legacy-id"));
        const rawTags = lineItemElement.getAttribute("data-product-tags") || "";
        const tags = normalizeTagList(rawTags.split("||"));

        byLineKey[lineKey] = tags;

        if (productId) {
          const existing = byProductId[productId];
          if (!existing || !existing.length || tags.length) {
            byProductId[productId] = tags;
          }
        }
      });
    });

    return {
      byLineKey,
      byProductId,
    };
  }

  function computeThresholdBasisCents(items, cartTotalPriceCents, giftTiers) {
    let thresholdBasisCents = Math.max(0, parseInteger(cartTotalPriceCents));
    const tierList = Array.isArray(giftTiers) ? giftTiers : [];
    const giftProductIds = new Set(
      tierList
        .map((tier) => normalizeLegacyId(tier && tier.giftProductLegacyId))
        .filter(Boolean),
    );

    for (const line of items) {
      const productLegacyId = normalizeLegacyId(line && line.product_id);
      const isGiftLine = isManagedGiftLine(line) || giftProductIds.has(productLegacyId);
      if (!isGiftLine) {
        continue;
      }

      thresholdBasisCents -= Math.max(0, parseInteger(line.final_line_price));
    }

    return Math.max(0, thresholdBasisCents);
  }

  function predictGiftItems(input) {
    if (window.__QK_PREDICTIVE_GIFT_PACK__ !== true) {
      return [];
    }

    const payload = input && typeof input === "object" ? input : {};
    const config = getConfig();
    const cart = normalizeCartPayload(payload.cart || state.lastCart);
    if (!cart || !Array.isArray(cart.items)) {
      return [];
    }

    // Conservative rollout: predict only for empty-cart ATC.
    if (cart.items.length > 0) {
      return [];
    }

    const giftTiers = Array.isArray(config && config.gift && config.gift.tiers)
      ? config.gift.tiers
      : [];
    if (!giftTiers.length) {
      return [];
    }

    const addedPriceCents = Math.max(0, parseInteger(payload.addedPriceCents));
    const addedQuantity = Math.max(1, parseInteger(payload.addedQuantity, 1));
    const cartTotalDeltaCents = Math.max(0, addedPriceCents * addedQuantity);
    if (!cartTotalDeltaCents) {
      return [];
    }

    const currentBasisCents = computeThresholdBasisCents(
      cart.items,
      parseInteger(cart && cart.total_price),
      giftTiers,
    );
    const predictedBasisCents = Math.max(0, currentBasisCents + cartTotalDeltaCents);
    const enabledGiftTiers = giftTiers.filter((tier) => Boolean(tier && tier.enabled));
    if (!enabledGiftTiers.length) {
      return [];
    }

    const unlockedNow = enabledGiftTiers
      .filter((tier) => currentBasisCents >= tier.thresholdCents)
      .map((tier) => tier.index);
    const unlockedAfterAdd = enabledGiftTiers
      .filter((tier) => predictedBasisCents >= tier.thresholdCents)
      .map((tier) => tier.index);

    const targetTierIndexes = config.gift.mode === "cumulative"
      ? unlockedAfterAdd
      : unlockedAfterAdd.length
        ? [unlockedAfterAdd[unlockedAfterAdd.length - 1]]
        : [];

    const currentTargetTierIndexes = config.gift.mode === "cumulative"
      ? unlockedNow
      : unlockedNow.length
        ? [unlockedNow[unlockedNow.length - 1]]
        : [];
    const currentTargetLookup = {};
    currentTargetTierIndexes.forEach((tierIndex) => {
      currentTargetLookup[String(tierIndex)] = true;
    });

    const managedGiftLineByTier = buildManagedGiftLineMap(cart.items, enabledGiftTiers);
    const predictedItems = [];
    targetTierIndexes.forEach((targetTierIndex) => {
      if (currentTargetLookup[String(targetTierIndex)]) {
        return;
      }

      if (Math.max(0, parseInteger(managedGiftLineByTier[targetTierIndex])) > 0) {
        return;
      }

      const tier = enabledGiftTiers.find((candidateTier) => candidateTier.index === targetTierIndex);
      if (!tier || !tier.enabled || tier.inStock === false || tier.hasSellableVariant === false) {
        return;
      }

      const variantLegacyId = normalizeLegacyId(tier.giftVariantLegacyId);
      if (!variantLegacyId) {
        return;
      }

      predictedItems.push({
        id: Number(variantLegacyId),
        quantity: 1,
        properties: {
          [ATTR_GWP_MANAGED]: "1",
          [ATTR_GWP_TIER]: String(targetTierIndex),
          [ATTR_GWP_SOURCE]: SOURCE_STOREFRONT,
        },
      });
    });

    if (predictedItems.length) {
      debugLog("[qk-cart-rules] predictive gift items", {
        count: predictedItems.length,
        currentBasisCents,
        predictedBasisCents,
        targetTierIndexes,
      });
    }

    return predictedItems;
  }

  function renderProgressUI(cart, config) {
    const mounts = Array.from(document.querySelectorAll(".qk-cart-progress-mount"));
    if (!mounts.length) {
      return;
    }

    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    const thresholdBasisCents = items.length
      ? computeThresholdBasisCents(
          items,
          parseInteger(cart && cart.total_price),
          config.gift.tiers,
        )
      : 0;

    const enabledTiers = config.gift.tiers.filter((tier) => Boolean(tier && tier.enabled));

    const maxThreshold = enabledTiers.length ? enabledTiers[enabledTiers.length - 1].thresholdCents : 100;
    const percent = maxThreshold > 0 ? Math.min(100, Math.round((thresholdBasisCents / maxThreshold) * 100)) : 100;

    const managedGiftLinesByTier = buildManagedGiftLineMap(items, enabledTiers);
    const managedGiftMetaByTier = buildManagedGiftMetaMap(items, enabledTiers);

    const markersMarkup = enabledTiers
      .map((tier) => {
        const left = maxThreshold > 0 ? Math.min(100, Math.max(0, Math.round((tier.thresholdCents / maxThreshold) * 100))) : 100;
        const unlocked = thresholdBasisCents >= tier.thresholdCents;
        const applied = unlocked && managedGiftLinesByTier[tier.index] > 0;
        const statusClass = applied ? " is-applied" : unlocked ? " is-eligible" : "";
        const statusLabel = applied ? config.ui.unlockedLabel : unlocked ? config.ui.eligibleLabel : config.ui.lockedLabel;
        const giftMeta = managedGiftMetaByTier[tier.index];
        const fallbackTitle = String(tier.giftTitle || `Cadou ${tier.index}`).trim();
        const title = String((giftMeta && giftMeta.title) || fallbackTitle || `Cadou ${tier.index}`);
        const thresholdShort = `${Math.round(tier.thresholdCents / 100)}+`;
        const markerTitle = `${title} • ${formatThresholdLabel(tier.thresholdCents)} • ${statusLabel}`;

        return `<span class=\"qk-progress__marker${statusClass}\" style=\"--qk-marker-left:${left}%;\" title=\"${escapeHtml(markerTitle)}\"><span class=\"qk-progress__marker-dot\" aria-hidden=\"true\">🎁</span><span class=\"qk-progress__marker-label\">${escapeHtml(thresholdShort)}</span></span>`;
      })
      .join("");

    const appliedGiftsMarkup = enabledTiers
      .map((tier) => {
        if (managedGiftLinesByTier[tier.index] <= 0) {
          return "";
        }

        const giftMeta = managedGiftMetaByTier[tier.index];
        const fallbackTitle = String(tier.giftTitle || `Cadou ${tier.index}`).trim();
        const title = String((giftMeta && giftMeta.title) || fallbackTitle || `Cadou ${tier.index}`);
        const quantity = Math.max(1, parseInteger((giftMeta && giftMeta.quantity) || managedGiftLinesByTier[tier.index]));
        const imageUrl = String((giftMeta && giftMeta.image) || "").trim();
        const imageMarkup = imageUrl
          ? `<img src="${escapeHtml(imageUrl)}" alt="${escapeHtml(title)}" loading="lazy" decoding="async">`
          : "🎁";

        return `
          <span class="qk-progress__gift" title="${escapeHtml(title)}">
            <span class="qk-progress__gift-thumb" aria-hidden="${imageUrl ? "false" : "true"}">${imageMarkup}</span>
            <span class="qk-progress__gift-label"><strong>${quantity}x</strong> ${escapeHtml(title)}</span>
          </span>
        `;
      })
      .filter(Boolean)
      .join("");

    const nextTier = enabledTiers.find((tier) => thresholdBasisCents < tier.thresholdCents) || null;
    const message = enabledTiers.length
      ? nextTier
        ? `Mai adaugi ${formatLei(nextTier.thresholdCents - thresholdBasisCents)} pentru urmatorul cadou.`
        : "Ai deblocat toate cadourile disponibile."
      : "Cadourile sunt indisponibile momentan.";

    const html = `
      <div class="qk-progress">
        <div class="qk-progress__head">
          <span class="qk-progress__title">${escapeHtml(config.ui.progressTitle)}</span>
          <span class="qk-progress__status">${escapeHtml(message)}</span>
        </div>
        <div class="qk-progress__track-wrap">
          <div class="qk-progress__track"><span class="qk-progress__track-fill" style="--qk-fill:${percent}%;"></span></div>
          <div class="qk-progress__markers">${markersMarkup}</div>
        </div>
        ${appliedGiftsMarkup ? `<div class="qk-progress__gifts" aria-label="Cadouri aplicate">${appliedGiftsMarkup}</div>` : ""}
      </div>
    `;

    mounts.forEach((mount) => {
      if (mount.innerHTML !== html) {
        mount.innerHTML = html;
      }
      writeProgressCache(getProgressMountContext(mount), html);
    });
  }

  function buildManagedGiftLineMap(items, giftTiers) {
    const byTier = {
      1: 0,
      2: 0,
      3: 0,
    };
    const tierByProductLegacyId = buildGiftTierIndexByProductLegacyId(giftTiers);

    items.forEach((line) => {
      if (!isManagedGiftLine(line)) {
        return;
      }

      const explicitTier = parseInteger(getLineProperty(line, ATTR_GWP_TIER));
      const inferredTier = parseInteger(tierByProductLegacyId[normalizeLegacyId(line && line.product_id)]);
      const tier = explicitTier >= 1 && explicitTier <= 3 ? explicitTier : inferredTier;
      if (tier >= 1 && tier <= 3) {
        byTier[tier] += Math.max(0, parseInteger(line.quantity));
      }
    });

    return byTier;
  }

  function buildManagedGiftMetaMap(items, giftTiers) {
    const byTier = {
      1: null,
      2: null,
      3: null,
    };
    const tierByProductLegacyId = buildGiftTierIndexByProductLegacyId(giftTiers);

    items.forEach((line) => {
      if (!isManagedGiftLine(line)) {
        return;
      }

      const explicitTier = parseInteger(getLineProperty(line, ATTR_GWP_TIER));
      const inferredTier = parseInteger(tierByProductLegacyId[normalizeLegacyId(line && line.product_id)]);
      const tier = explicitTier >= 1 && explicitTier <= 3 ? explicitTier : inferredTier;
      if (!(tier >= 1 && tier <= 3)) {
        return;
      }

      if (byTier[tier]) {
        return;
      }

      byTier[tier] = {
        title: String(line.product_title || line.title || "").trim(),
        image: resolveLineImageUrl(line),
        quantity: Math.max(0, parseInteger(line.quantity)),
      };
    });

    return byTier;
  }

  function buildGiftTierIndexByProductLegacyId(giftTiers) {
    const map = {};
    (Array.isArray(giftTiers) ? giftTiers : []).forEach((tier) => {
      const index = parseInteger(tier && tier.index);
      const productLegacyId = normalizeLegacyId(tier && tier.giftProductLegacyId);
      if (!(index >= 1 && index <= 3) || !productLegacyId) {
        return;
      }
      if (!Object.prototype.hasOwnProperty.call(map, productLegacyId)) {
        map[productLegacyId] = index;
      }
    });
    return map;
  }

  function resolveLineImageUrl(line) {
    const featuredImage = safeObject(line && line.featured_image);
    const imageObject = safeObject(line && line.image);
    const rawLineImage = line && typeof line.image === "string" ? line.image : "";
    const candidates = [
      featuredImage.url,
      featuredImage.src,
      rawLineImage,
      imageObject.url,
      imageObject.src,
    ];

    for (const candidate of candidates) {
      const raw = String(candidate == null ? "" : candidate).trim();
      if (!raw) {
        continue;
      }

      if (raw.startsWith("//")) {
        return `https:${raw}`;
      }

      if (raw.startsWith("/")) {
        return `${window.location.origin}${raw}`;
      }

      return raw;
    }

    return "";
  }

  function renderCompactGiftLines(cart, domSnapshot) {
    const lineElements = Array.isArray(domSnapshot && domSnapshot.lineElements)
      ? domSnapshot.lineElements
      : Array.from(document.querySelectorAll("line-item[data-line-key]"));
    if (!lineElements.length) {
      return;
    }

    const hasCompactGiftUI = Boolean(document.querySelector(".qk-progress__gifts"));

    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    const managedGiftLineKeys = new Set();
    items.forEach((item) => {
      const lineKey = String(item && item.key ? item.key : "");
      if (lineKey && isManagedGiftLine(item)) {
        managedGiftLineKeys.add(lineKey);
      }
    });

    lineElements.forEach((lineElement) => {
      const lineKey = String(lineElement.getAttribute("data-line-key") || "");
      const container = getLineContainer(lineElement);
      const shouldHide = hasCompactGiftUI && managedGiftLineKeys.has(lineKey);
      container.classList.toggle("qk-gift-line--hidden", shouldHide);
    });
  }

  function markManagedLinesPendingRemoval(cart, operations) {
    const nextPending = Object.assign({}, state.pendingManagedRemovalKeys || {});
    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    const itemByKey = {};
    items.forEach((line) => {
      const lineKey = String(line && line.key ? line.key : "");
      if (lineKey) {
        itemByKey[lineKey] = line;
      }
    });

    (Array.isArray(operations) ? operations : []).forEach((operation) => {
      if (!operation || operation.type !== "change") {
        return;
      }

      if (Math.max(0, parseInteger(operation.quantity)) !== 0) {
        return;
      }

      const lineKey = String(operation.lineKey || "").trim();
      if (!lineKey) {
        return;
      }

      const line = itemByKey[lineKey];
      if (!line || (!isManagedFeeLine(line) && !isManagedGiftLine(line) && !isManagedLubricationLine(line))) {
        return;
      }

      nextPending[lineKey] = true;
    });

    state.pendingManagedRemovalKeys = nextPending;
    applyPendingManagedHiddenState();
  }

  function applyPendingManagedHiddenState(domSnapshot) {
    const pending = safeObject(state.pendingManagedRemovalKeys);
    const pendingKeys = Object.keys(pending);
    if (!pendingKeys.length) {
      return;
    }

    const pendingSet = new Set(pendingKeys);
    const lineElements = Array.isArray(domSnapshot && domSnapshot.lineElements)
      ? domSnapshot.lineElements
      : Array.from(document.querySelectorAll("line-item[data-line-key]"));
    lineElements.forEach((lineElement) => {
      const lineKey = String(lineElement.getAttribute("data-line-key") || "");
      if (!pendingSet.has(lineKey)) {
        return;
      }

      const container = getLineContainer(lineElement);
      container.classList.add("qk-line--optimistic-hidden");
    });
  }

  function clearPendingManagedRemovalKeys() {
    state.pendingManagedRemovalKeys = {};
    document.querySelectorAll(".qk-line--optimistic-hidden").forEach((element) => {
      element.classList.remove("qk-line--optimistic-hidden");
    });
  }

  function deriveProcessingParentLineKeys(cart, operations) {
    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    const itemByKey = {};
    items.forEach((line) => {
      const key = String(line && line.key ? line.key : "").trim();
      if (key) {
        itemByKey[key] = line;
      }
    });

    const parentLineKeys = new Set();
    (Array.isArray(operations) ? operations : []).forEach((operation) => {
      if (!operation || typeof operation !== "object") {
        return;
      }

      const operationProperties = safeObject(operation.properties);

      if (operation.type === "add") {
        const lubeSourceLineKey = normalizeManagedSourceLineKey(operationProperties[ATTR_LUBE_SOURCE]);
        if (lubeSourceLineKey) {
          parentLineKeys.add(lubeSourceLineKey);
        }

        const feeSourceLineKey = normalizeManagedSourceLineKey(operationProperties[ATTR_FEE_SOURCE]);
        if (feeSourceLineKey) {
          parentLineKeys.add(feeSourceLineKey);
        }
        return;
      }

      if (operation.type !== "change") {
        return;
      }

      const lineKey = String(operation.lineKey || "").trim();
      if (!lineKey) {
        return;
      }

      if (
        Object.prototype.hasOwnProperty.call(operationProperties, ATTR_LUBE_SELECTED) ||
        Object.prototype.hasOwnProperty.call(operationProperties, ATTR_LUBE_SCOPE) ||
        Object.prototype.hasOwnProperty.call(operationProperties, ATTR_LUBE_RULE) ||
        Object.prototype.hasOwnProperty.call(operationProperties, ATTR_LUBE_LAYOUT)
      ) {
        parentLineKeys.add(lineKey);
      }

      const line = itemByKey[lineKey];
      if (!line) {
        return;
      }

      if (isManagedLubricationLine(line)) {
        let sourceLineKey = normalizeManagedSourceLineKey(getLineProperty(line, ATTR_LUBE_SOURCE));
        if (!sourceLineKey || !itemByKey[sourceLineKey]) {
          const sourceVariantLegacyId =
            normalizeLegacyId(getLineProperty(line, ATTR_LUBE_SOURCE_VARIANT)) ||
            extractVariantLegacyIdFromLineKey(sourceLineKey);
          if (sourceVariantLegacyId) {
            const candidate = items.find((candidateLine) => {
              return (
                isEligibleLubricationParentLine(candidateLine) &&
                normalizeLegacyId(candidateLine && candidateLine.variant_id) === sourceVariantLegacyId
              );
            });
            sourceLineKey = String((candidate && candidate.key) || "").trim();
          }
        }
        if (sourceLineKey) {
          parentLineKeys.add(sourceLineKey);
        }
        return;
      }

      if (isManagedFeeLine(line)) {
        let sourceLineKey = normalizeManagedSourceLineKey(getLineProperty(line, ATTR_FEE_SOURCE));
        if (!sourceLineKey || !itemByKey[sourceLineKey]) {
          const sourceVariantLegacyId =
            normalizeLegacyId(getLineProperty(line, ATTR_FEE_SOURCE_VARIANT)) ||
            extractVariantLegacyIdFromLineKey(sourceLineKey);
          if (sourceVariantLegacyId) {
            const candidate = items.find((candidateLine) => {
              return (
                isEligibleFeeParentLine(candidateLine) &&
                normalizeLegacyId(candidateLine && candidateLine.variant_id) === sourceVariantLegacyId
              );
            });
            sourceLineKey = String((candidate && candidate.key) || "").trim();
          }
        }
        if (sourceLineKey) {
          parentLineKeys.add(sourceLineKey);
        }
      }
    });

    return Array.from(parentLineKeys);
  }

  function normalizeManagedSourceLineKey(value) {
    const key = String(value || "").trim();
    if (!key || key === SOURCE_STOREFRONT) {
      return "";
    }
    return key;
  }

  function extractVariantLegacyIdFromLineKey(lineKey) {
    const normalizedLineKey = String(lineKey || "").trim();
    if (!normalizedLineKey) {
      return "";
    }

    const prefix = normalizedLineKey.split(":")[0];
    return normalizeLegacyId(prefix);
  }

  function isEligibleFeeParentLine(line) {
    if (
      !line ||
      isManagedFeeLine(line) ||
      isManagedGiftLine(line) ||
      isManagedLubricationLine(line) ||
      isManagedGiftWrapLine(line) ||
      isManagedPackageInsuranceLine(line)
    ) {
      return false;
    }

    const lineKey = String(line && line.key ? line.key : "").trim();
    if (!lineKey) {
      return false;
    }

    return Math.max(0, parseInteger(line && line.quantity)) > 0;
  }

  function resolveFeeTagsForLine(line, tagLookup) {
    const lineKey = String(line && line.key ? line.key : "").trim();
    const productLegacyId = normalizeLegacyId(line && line.product_id);
    const byLineKey = safeObject(tagLookup && tagLookup.byLineKey);
    const byProductId = safeObject(tagLookup && tagLookup.byProductId);

    if (lineKey && Object.prototype.hasOwnProperty.call(byLineKey, lineKey)) {
      return normalizeTagList(byLineKey[lineKey]);
    }

    if (productLegacyId && Object.prototype.hasOwnProperty.call(byProductId, productLegacyId)) {
      return normalizeTagList(byProductId[productLegacyId]);
    }

    return [];
  }

  function resolveFeeRuleKeyForManagedLine(line, feeRules) {
    const explicitRuleKey = String(getLineProperty(line, ATTR_FEE_RULE) || "").trim();
    if (explicitRuleKey) {
      return explicitRuleKey;
    }

    const feeRuleByProductLegacyId = {};
    (Array.isArray(feeRules) ? feeRules : []).forEach((rule) => {
      const key = String(rule && rule.key ? rule.key : "").trim();
      const productLegacyId = normalizeLegacyId(rule && rule.feeProductLegacyId);
      if (!key || !productLegacyId) {
        return;
      }
      feeRuleByProductLegacyId[productLegacyId] = key;
    });

    return String(feeRuleByProductLegacyId[normalizeLegacyId(line && line.product_id)] || "").trim();
  }

  function resolveFeeManagedSourceLineKey(items, managedLine, feeRules, tagLookup) {
    const candidates = (Array.isArray(items) ? items : []).filter((line) => isEligibleFeeParentLine(line));
    if (!managedLine || !candidates.length) {
      return "";
    }

    const explicitSourceLineKey = normalizeManagedSourceLineKey(getLineProperty(managedLine, ATTR_FEE_SOURCE));
    if (
      explicitSourceLineKey &&
      candidates.some((candidate) => String(candidate && candidate.key ? candidate.key : "").trim() === explicitSourceLineKey)
    ) {
      return explicitSourceLineKey;
    }

    const sourceVariantLegacyId =
      normalizeLegacyId(getLineProperty(managedLine, ATTR_FEE_SOURCE_VARIANT)) ||
      extractVariantLegacyIdFromLineKey(explicitSourceLineKey);
    const managedRuleKey = resolveFeeRuleKeyForManagedLine(managedLine, feeRules);

    const matchedByRule = managedRuleKey
      ? candidates.filter((candidate) => {
          const tags = resolveFeeTagsForLine(candidate, tagLookup);
          if (!tags.length) {
            return false;
          }
          return resolveMatchedFeeRules(tags, feeRules).includes(managedRuleKey);
        })
      : candidates.slice();

    const variantMatchedByRule = sourceVariantLegacyId
      ? matchedByRule.filter((candidate) => normalizeLegacyId(candidate && candidate.variant_id) === sourceVariantLegacyId)
      : [];
    if (variantMatchedByRule.length) {
      return String(variantMatchedByRule[0].key || "").trim();
    }

    if (matchedByRule.length === 1) {
      return String(matchedByRule[0].key || "").trim();
    }

    if (sourceVariantLegacyId) {
      const variantMatchedAny = candidates.filter((candidate) => {
        return normalizeLegacyId(candidate && candidate.variant_id) === sourceVariantLegacyId;
      });
      if (variantMatchedAny.length) {
        return String(variantMatchedAny[0].key || "").trim();
      }
    }

    if (matchedByRule.length > 1) {
      return String(matchedByRule[0].key || "").trim();
    }

    if (candidates.length === 1) {
      return String(candidates[0].key || "").trim();
    }

    return "";
  }

  function resolveLubricationManagedSourceLineKey(items, managedLine, ruleMaps, options) {
    const payload = options && typeof options === "object" ? options : {};
    const candidates = (Array.isArray(items) ? items : []).filter((line) => isEligibleLubricationParentLine(line));
    if (!managedLine || !candidates.length) {
      return "";
    }

    const explicitSourceLineKey = normalizeManagedSourceLineKey(getLineProperty(managedLine, ATTR_LUBE_SOURCE));
    if (
      explicitSourceLineKey &&
      candidates.some((candidate) => String(candidate && candidate.key ? candidate.key : "").trim() === explicitSourceLineKey)
    ) {
      return explicitSourceLineKey;
    }

    const preferredParentLineKey = normalizeManagedSourceLineKey(payload.preferredParentLineKey);
    if (
      preferredParentLineKey &&
      candidates.some((candidate) => String(candidate && candidate.key ? candidate.key : "").trim() === preferredParentLineKey)
    ) {
      return preferredParentLineKey;
    }

    const sourceVariantLegacyId =
      normalizeLegacyId(getLineProperty(managedLine, ATTR_LUBE_SOURCE_VARIANT)) ||
      extractVariantLegacyIdFromLineKey(explicitSourceLineKey);
    const managedRule = resolveLubricationRuleForManagedLine(managedLine, ruleMaps);
    const managedRuleKey = String((managedRule && managedRule.key) || getLineProperty(managedLine, ATTR_LUBE_RULE) || "").trim();
    const managedScope = normalizeLubricationScope(getLineProperty(managedLine, ATTR_LUBE_SCOPE));
    const managedQuantity = Math.max(1, parseInteger(managedLine && managedLine.quantity));

    let bestCandidate = null;
    let bestScore = -1;
    candidates.forEach((candidate) => {
      if (!candidate) {
        return;
      }

      let score = 0;
      if (sourceVariantLegacyId && normalizeLegacyId(candidate.variant_id) === sourceVariantLegacyId) {
        score += 8;
      }

      const candidateRule = resolveLubricationRuleForLine(candidate, ruleMaps);
      const candidateRuleKey = String((candidateRule && candidateRule.key) || getLineProperty(candidate, ATTR_LUBE_RULE) || "").trim();
      if (managedRuleKey && candidateRuleKey && candidateRuleKey === managedRuleKey) {
        score += 6;
      }

      const candidateScope = normalizeLubricationScope(getLineProperty(candidate, ATTR_LUBE_SCOPE));
      if (managedScope) {
        if (candidateScope === managedScope) {
          score += 3;
        } else if (!candidateScope) {
          score += 1;
        }
      }

      if (isTruthyLineProperty(candidate, ATTR_LUBE_SELECTED)) {
        score += 2;
      }

      if (Math.max(1, parseInteger(candidate && candidate.quantity)) === managedQuantity) {
        score += 1;
      }

      if (score > bestScore) {
        bestScore = score;
        bestCandidate = candidate;
      }
    });

    if (bestCandidate && bestScore > 0) {
      return String(bestCandidate.key || "").trim();
    }

    if (candidates.length === 1) {
      return String(candidates[0].key || "").trim();
    }

    return "";
  }

  function setProcessingLineKeys(lineKeys) {
    const normalizedKeys = uniqueStrings(Array.isArray(lineKeys) ? lineKeys : []);
    const nextLookup = {};
    normalizedKeys.forEach((lineKey) => {
      nextLookup[lineKey] = true;
    });
    state.processingLineKeys = nextLookup;
    applyProcessingLineState();
  }

  function clearProcessingLineKeys() {
    if (!Object.keys(safeObject(state.processingLineKeys)).length) {
      return;
    }

    state.processingLineKeys = {};
    applyProcessingLineState();
  }

  function applyProcessingLineState(domSnapshot) {
    const processingLookup = safeObject(state.processingLineKeys);
    const processingKeys = new Set(Object.keys(processingLookup));
    const shouldShowPendingLubricationProcessing = Boolean(state.inFlight || state.lineMutationInFlight);
    const pendingLubricationParentLineKeys = shouldShowPendingLubricationProcessing
      ? derivePendingLubricationParentLineKeys(
          state.lastCart,
          getLubricationConfig(),
        )
      : [];
    pendingLubricationParentLineKeys.forEach((lineKey) => {
      processingKeys.add(lineKey);
    });
    const lineElements = Array.isArray(domSnapshot && domSnapshot.lineElements)
      ? domSnapshot.lineElements
      : Array.from(document.querySelectorAll("line-item[data-line-key]"));

    lineElements.forEach((lineElement) => {
      const lineKey = String(lineElement.getAttribute("data-line-key") || "").trim();
      const shouldShowProcessing = Boolean(lineKey && processingKeys.has(lineKey));

      lineElement.classList.toggle("qk-line--processing", shouldShowProcessing);

      const container = getLineContainer(lineElement);
      if (container instanceof Element && container !== lineElement) {
        container.classList.toggle("qk-line--processing", shouldShowProcessing);
      }
    });
  }

  function derivePendingLubricationParentLineKeys(cart, lubricationConfig) {
    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    if (!items.length) {
      return [];
    }

    const ruleMaps = buildLubricationRuleMaps(lubricationConfig);
    const managedBySourceLineKey = {};
    const managedCountByScopeAndRule = {};

    items.forEach((line) => {
      if (!line || !isManagedLubricationLine(line)) {
        return;
      }

      const sourceLineKey =
        resolveLubricationManagedSourceLineKey(items, line, ruleMaps) ||
        normalizeManagedSourceLineKey(getLineProperty(line, ATTR_LUBE_SOURCE));
      if (sourceLineKey) {
        managedBySourceLineKey[sourceLineKey] = true;
      }

      const scope = normalizeLubricationScope(getLineProperty(line, ATTR_LUBE_SCOPE));
      const ruleKey = getLubricationRuleKeyForLine(line, ruleMaps);
      if (!scope || !ruleKey) {
        return;
      }

      const bucketKey = `${scope}::${ruleKey}`;
      managedCountByScopeAndRule[bucketKey] = Math.max(0, parseInteger(managedCountByScopeAndRule[bucketKey])) + 1;
    });

    const pendingParentLineKeys = [];
    items.forEach((line) => {
      if (!isEligibleLubricationParentLine(line)) {
        return;
      }

      if (!isTruthyLineProperty(line, ATTR_LUBE_SELECTED)) {
        return;
      }

      const scope = normalizeLubricationScope(getLineProperty(line, ATTR_LUBE_SCOPE));
      if (!scope) {
        return;
      }

      const resolvedRule = resolveLubricationRuleForLine(line, ruleMaps);
      const ruleKey = String(resolvedRule && resolvedRule.key ? resolvedRule.key : "").trim();
      if (!ruleKey) {
        return;
      }

      const lineKey = String(line && line.key ? line.key : "").trim();
      if (!lineKey) {
        return;
      }

      if (managedBySourceLineKey[lineKey]) {
        return;
      }

      const bucketKey = `${scope}::${ruleKey}`;
      const matchedManagedCount = Math.max(0, parseInteger(managedCountByScopeAndRule[bucketKey]));
      if (matchedManagedCount > 0) {
        managedCountByScopeAndRule[bucketKey] = matchedManagedCount - 1;
        return;
      }

      pendingParentLineKeys.push(lineKey);
    });

    return uniqueStrings(pendingParentLineKeys);
  }

  function renderFeeAttachments(cart, config, domSnapshot) {
    const lineElements = Array.isArray(domSnapshot && domSnapshot.lineElements)
      ? domSnapshot.lineElements
      : Array.from(document.querySelectorAll("line-item[data-line-key]"));
    if (!lineElements.length) {
      return;
    }

    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    const itemByKey = {};
    items.forEach((item) => {
      const key = String(item && item.key ? item.key : "");
      if (key) {
        itemByKey[key] = item;
      }
    });

    const feeRuleByProductLegacyId = {};
    (Array.isArray(config && config.fees && config.fees.rules) ? config.fees.rules : []).forEach((rule) => {
      const productId = normalizeLegacyId(rule && rule.feeProductLegacyId);
      const key = String(rule && rule.key ? rule.key : "");
      if (productId && key) {
        feeRuleByProductLegacyId[productId] = key;
      }
    });

    const lineElementsByKey = (() => {
      if (domSnapshot && typeof domSnapshot === "object" && domSnapshot.lineElementsByKey) {
        return safeObject(domSnapshot.lineElementsByKey);
      }

      const fallback = {};
      lineElements.forEach((lineElement) => {
        const lineKey = String(lineElement.getAttribute("data-line-key") || "").trim();
        if (!lineKey) {
          return;
        }
        fallback[lineKey] = fallback[lineKey] || [];
        fallback[lineKey].push(lineElement);
      });
      return fallback;
    })();

    document.querySelectorAll(".qk-fee-attachment").forEach((element) => {
      element.remove();
    });

    lineElements.forEach((lineElement) => {
      lineElement.removeAttribute("data-qk-fee-rule");
    });

    const feeTagLookupFromDom = { byLineKey: {}, byProductId: {} };
    lineElements.forEach((lineElement) => {
      const lineKey = String(lineElement.getAttribute("data-line-key") || "").trim();
      if (!lineKey) {
        return;
      }
      const line = itemByKey[lineKey];
      if (!line) {
        return;
      }
      const rawTags = String(lineElement.getAttribute("data-product-tags") || "");
      const tags = normalizeTagList(rawTags.split("||"));
      feeTagLookupFromDom.byLineKey[lineKey] = tags;
      const productLegacyId = normalizeLegacyId(line && line.product_id);
      if (productLegacyId && (!feeTagLookupFromDom.byProductId[productLegacyId] || tags.length)) {
        feeTagLookupFromDom.byProductId[productLegacyId] = tags;
      }
    });

    const parentLineKeyByRule = {};
    lineElements.forEach((lineElement) => {
      const lineKey = String(lineElement.getAttribute("data-line-key") || "");
      if (!lineKey) {
        return;
      }

      const line = itemByKey[lineKey];
      if (!line) {
        return;
      }

      if (!isEligibleFeeParentLine(line)) {
        return;
      }

      const tags = resolveFeeTagsForLine(line, feeTagLookupFromDom);
      const matchedRules = resolveMatchedFeeRules(tags, config.fees.rules);
      matchedRules.forEach((ruleKey) => {
        if (!parentLineKeyByRule[ruleKey]) {
          parentLineKeyByRule[ruleKey] = lineKey;
        }
      });
    });

    const attachmentPayloadByParent = {};
    const hiddenManagedFeeLineKeys = new Set();
    const processedManagedFeeLineKeys = new Set();

    lineElements.forEach((lineElement) => {
      const lineKey = String(lineElement.getAttribute("data-line-key") || "");
      if (!lineKey) {
        return;
      }

      if (processedManagedFeeLineKeys.has(lineKey)) {
        return;
      }

      const line = itemByKey[lineKey];
      if (!line || !isManagedFeeLine(line)) {
        return;
      }
      processedManagedFeeLineKeys.add(lineKey);

      const fallbackRule = feeRuleByProductLegacyId[normalizeLegacyId(line.product_id)] || "";
      const ruleKey = String(getLineProperty(line, ATTR_FEE_RULE) || fallbackRule || "").trim();
      if (!ruleKey) {
        return;
      }

      lineElement.setAttribute("data-qk-fee-rule", ruleKey);

      const explicitSourceLineKey = resolveFeeManagedSourceLineKey(items, line, config.fees.rules, feeTagLookupFromDom);
      const parentKey =
        (explicitSourceLineKey && Array.isArray(lineElementsByKey[explicitSourceLineKey]) ? explicitSourceLineKey : "") ||
        parentLineKeyByRule[ruleKey];
      if (!parentKey || !Array.isArray(lineElementsByKey[parentKey])) {
        return;
      }

      hiddenManagedFeeLineKeys.add(lineKey);

      const label = "Taxa Verde Inclusa";
      const payloadKey = String(ruleKey || normalizeLegacyId(line && line.variant_id) || lineKey).trim() || lineKey;
      const nextQuantity = Math.max(1, parseInteger(line && line.quantity));
      attachmentPayloadByParent[parentKey] = attachmentPayloadByParent[parentKey] || {};
      const existingPayload = attachmentPayloadByParent[parentKey][payloadKey] || {
        label,
        quantity: 0,
      };
      existingPayload.quantity += nextQuantity;
      attachmentPayloadByParent[parentKey][payloadKey] = existingPayload;
    });

    lineElements.forEach((lineElement) => {
      const lineKey = String(lineElement.getAttribute("data-line-key") || "");
      const container = getLineContainer(lineElement);
      container.classList.toggle("qk-fee-line--hidden", hiddenManagedFeeLineKeys.has(lineKey));
    });

    Object.keys(attachmentPayloadByParent).forEach((parentKey) => {
      const parentElements = Array.isArray(lineElementsByKey[parentKey]) ? lineElementsByKey[parentKey] : [];
      if (!parentElements.length) {
        return;
      }

      parentElements.forEach((parentElement) => {
        if (!(parentElement instanceof Element)) {
          return;
        }

        const info = parentElement.querySelector(".line-item__info");
        if (!(info instanceof Element)) {
          return;
        }

        const priceAndQuantity = info.querySelector(".price-quantity");
        const payloadEntries = Object.values(attachmentPayloadByParent[parentKey] || {});
        payloadEntries.forEach((payload) => {
          const quantity = Math.max(1, parseInteger(payload && payload.quantity));
          const quantityMarkup = quantity > 1
            ? `<span class=\"qk-fee-attachment__qty\">x${quantity}</span>`
            : "";
          const attachment = document.createElement("div");
          attachment.className = "qk-fee-attachment";
          attachment.innerHTML = `<span class=\"qk-fee-attachment__dot\" aria-hidden=\"true\"></span><span>${escapeHtml(payload && payload.label ? payload.label : "Taxa Verde Inclusa")}</span>${quantityMarkup}`;
          if (priceAndQuantity instanceof Element) {
            info.insertBefore(attachment, priceAndQuantity);
          } else {
            info.appendChild(attachment);
          }
        });
      });
    });
  }

  function renderLubricationAttachments(cart, lubricationConfig, domSnapshot) {
    const lineElements = Array.isArray(domSnapshot && domSnapshot.lineElements)
      ? domSnapshot.lineElements
      : Array.from(document.querySelectorAll("line-item[data-line-key]"));
    if (!lineElements.length) {
      return;
    }

    const config = safeObject(lubricationConfig);
    const ui = safeObject(config.ui);
    const attachmentLabel = String(ui.attachment_ro || "Lubrifiere switch-uri").trim();
    const removeLabel = "Elimina";

    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    const itemByKey = {};
    items.forEach((item) => {
      const key = String(item && item.key ? item.key : "");
      if (key) {
        itemByKey[key] = item;
      }
    });

    const lineElementsByKey = (() => {
      if (domSnapshot && typeof domSnapshot === "object" && domSnapshot.lineElementsByKey) {
        return safeObject(domSnapshot.lineElementsByKey);
      }

      const fallback = {};
      lineElements.forEach((lineElement) => {
        const lineKey = String(lineElement.getAttribute("data-line-key") || "").trim();
        if (!lineKey) {
          return;
        }
        fallback[lineKey] = fallback[lineKey] || [];
        fallback[lineKey].push(lineElement);
      });
      return fallback;
    })();

    document.querySelectorAll(".qk-lube-attachment").forEach((element) => {
      element.remove();
    });

    const fallbackParentLineKeysByRuleAndScope = {};
    const parentCandidates = [];
    const processedParentLineKeys = new Set();
    lineElements.forEach((lineElement) => {
      const lineKey = String(lineElement.getAttribute("data-line-key") || "");
      if (!lineKey) {
        return;
      }

      if (processedParentLineKeys.has(lineKey)) {
        return;
      }
      processedParentLineKeys.add(lineKey);

      const line = itemByKey[lineKey];
      if (!line) {
        return;
      }

      if (!isEligibleLubricationParentLine(line)) {
        return;
      }

      if (!isTruthyLineProperty(line, ATTR_LUBE_SELECTED)) {
        parentCandidates.push({
          lineKey,
          selected: false,
          scope: "",
          ruleKey: "",
          quantity: Math.max(0, parseInteger(line && line.quantity)),
        });
        return;
      }

      const scope = normalizeLubricationScope(getLineProperty(line, ATTR_LUBE_SCOPE));
      const isSelectedLubeLine = Boolean(scope);
      const ruleKey = String(getLineProperty(line, ATTR_LUBE_RULE) || "").trim();

      parentCandidates.push({
        lineKey,
        selected: isSelectedLubeLine,
        scope,
        ruleKey,
        quantity: Math.max(0, parseInteger(line && line.quantity)),
      });

      if (isSelectedLubeLine && ruleKey) {
        const scopedRuleKey = `${scope}::${ruleKey}`;
        const wildcardRuleKey = `*::${ruleKey}`;

        fallbackParentLineKeysByRuleAndScope[scopedRuleKey] = fallbackParentLineKeysByRuleAndScope[scopedRuleKey] || [];
        if (!fallbackParentLineKeysByRuleAndScope[scopedRuleKey].includes(lineKey)) {
          fallbackParentLineKeysByRuleAndScope[scopedRuleKey].push(lineKey);
        }

        fallbackParentLineKeysByRuleAndScope[wildcardRuleKey] = fallbackParentLineKeysByRuleAndScope[wildcardRuleKey] || [];
        if (!fallbackParentLineKeysByRuleAndScope[wildcardRuleKey].includes(lineKey)) {
          fallbackParentLineKeysByRuleAndScope[wildcardRuleKey].push(lineKey);
        }
      }
    });

    const parentLineKeysWithAttachment = new Set();
    const hiddenManagedLineKeys = new Set();
    const attachmentPayloadByParent = {};
    const processedManagedLineKeys = new Set();
    const lubricationRuleMaps = buildLubricationRuleMaps(config);

    lineElements.forEach((lineElement) => {
      const lineKey = String(lineElement.getAttribute("data-line-key") || "");
      if (!lineKey || processedManagedLineKeys.has(lineKey)) {
        return;
      }

      const line = itemByKey[lineKey];
      if (!line || !isManagedLubricationLine(line)) {
        return;
      }
      processedManagedLineKeys.add(lineKey);

      const sourceLineKey =
        resolveLubricationManagedSourceLineKey(items, line, lubricationRuleMaps) ||
        normalizeManagedSourceLineKey(getLineProperty(line, ATTR_LUBE_SOURCE));
      let parentLineKey = "";
      if (sourceLineKey && Array.isArray(lineElementsByKey[sourceLineKey])) {
        parentLineKey = sourceLineKey;
      } else {
        const managedScope = normalizeLubricationScope(getLineProperty(line, ATTR_LUBE_SCOPE));
        const resolvedManagedRule = resolveLubricationRuleForManagedLine(line, lubricationRuleMaps);
        const ruleKey = String((resolvedManagedRule && resolvedManagedRule.key) || getLineProperty(line, ATTR_LUBE_RULE) || "").trim();
        const scopedRuleKey = `${managedScope || ""}::${ruleKey}`;
        const wildcardRuleKey = `*::${ruleKey}`;
        const matchedByRule = ruleKey
          ? (
              fallbackParentLineKeysByRuleAndScope[scopedRuleKey] ||
              fallbackParentLineKeysByRuleAndScope[wildcardRuleKey] ||
              []
            )
          : [];
        if (matchedByRule.length) {
          parentLineKey =
            matchedByRule.find((candidateLineKey) => !parentLineKeysWithAttachment.has(candidateLineKey)) || matchedByRule[0];
        }
      }

      if (!parentLineKey) {
        const managedScope = normalizeLubricationScope(getLineProperty(line, ATTR_LUBE_SCOPE));
        const managedQuantity = Math.max(0, parseInteger(line && line.quantity));
        const selectedCandidates = parentCandidates.filter((candidate) => {
          if (!candidate || !candidate.selected) {
            return false;
          }

          if (!managedScope || !candidate.scope) {
            return true;
          }

          return candidate.scope === managedScope;
        });
        if (selectedCandidates.length === 1) {
          parentLineKey = selectedCandidates[0].lineKey;
        } else if (selectedCandidates.length > 1) {
          const exactQuantityMatch = selectedCandidates.find((candidate) => candidate.quantity === managedQuantity);
          if (exactQuantityMatch) {
            parentLineKey = exactQuantityMatch.lineKey;
          }
        }
      }

      if (!parentLineKey) {
        const managedScope = normalizeLubricationScope(getLineProperty(line, ATTR_LUBE_SCOPE));
        const firstSelected = parentCandidates.find((candidate) => {
          if (!candidate || !candidate.selected) {
            return false;
          }

          if (!managedScope || !candidate.scope) {
            return true;
          }

          return candidate.scope === managedScope;
        });
        if (firstSelected) {
          parentLineKey = firstSelected.lineKey;
        }
      }

      if (!parentLineKey) {
        const selectedParentCandidates = parentCandidates.filter((candidate) => candidate && candidate.selected);
        if (selectedParentCandidates.length === 1) {
          parentLineKey = selectedParentCandidates[0].lineKey;
        }
      }

      if (!parentLineKey || !Array.isArray(lineElementsByKey[parentLineKey])) {
        return;
      }

      if (lineKey) {
        hiddenManagedLineKeys.add(lineKey);
      }

      parentLineKeysWithAttachment.add(parentLineKey);

      const managedScope = normalizeLubricationScope(getLineProperty(line, ATTR_LUBE_SCOPE));
      const managedRuleKey = String(getLineProperty(line, ATTR_LUBE_RULE) || "").trim();
      const payloadKey = `${managedScope || ""}::${managedRuleKey || normalizeLegacyId(line && line.variant_id) || lineKey}`;

      attachmentPayloadByParent[parentLineKey] = attachmentPayloadByParent[parentLineKey] || {};
      const existingPayload = attachmentPayloadByParent[parentLineKey][payloadKey];
      const nextPayload = existingPayload || {
        managedLineKey: lineKey,
        ruleKey: managedRuleKey,
        title: String(line.product_title || line.title || attachmentLabel).trim() || attachmentLabel,
        quantity: 0,
        priceCents: 0,
      };
      if (!nextPayload.ruleKey && managedRuleKey) {
        nextPayload.ruleKey = managedRuleKey;
      }
      nextPayload.quantity += Math.max(1, parseInteger(line.quantity));
      nextPayload.priceCents += resolveLineTotalPriceCents(line);
      attachmentPayloadByParent[parentLineKey][payloadKey] = nextPayload;
    });

    lineElements.forEach((lineElement) => {
      const lineKey = String(lineElement.getAttribute("data-line-key") || "");
      const container = getLineContainer(lineElement);
      container.classList.toggle("qk-lube-line--hidden", hiddenManagedLineKeys.has(lineKey));
    });

    Object.keys(attachmentPayloadByParent).forEach((parentLineKey) => {
      const parentElements = Array.isArray(lineElementsByKey[parentLineKey]) ? lineElementsByKey[parentLineKey] : [];
      if (!parentElements.length) {
        return;
      }

      const payloadEntries = Object.values(attachmentPayloadByParent[parentLineKey] || {});
      if (!payloadEntries.length) {
        return;
      }

      parentElements.forEach((parentElement) => {
        if (!(parentElement instanceof Element)) {
          return;
        }

        const info = parentElement.querySelector(".line-item__info");
        if (!(info instanceof Element)) {
          return;
        }

        const priceAndQuantity = info.querySelector(".price-quantity");
        payloadEntries.forEach((payload) => {
          const attachment = document.createElement("div");
          attachment.className = "qk-lube-attachment";
          attachment.setAttribute("data-qk-lube-attachment", "1");
          attachment.setAttribute("data-qk-parent-line-key", parentLineKey);
          attachment.setAttribute("data-qk-managed-line-key", String(payload.managedLineKey || ""));
          attachment.setAttribute("data-qk-lube-rule", String(payload.ruleKey || ""));

          const quantityMarkup = payload.quantity > 1
            ? `<span class=\"qk-lube-attachment__qty\">x${Math.max(1, parseInteger(payload.quantity))}</span>`
            : "";
          const priceMarkup = payload.priceCents > 0
            ? `<span class=\"qk-lube-attachment__price\">+${escapeHtml(formatLei(payload.priceCents))}</span>`
            : "";

          attachment.innerHTML = `
            <span class=\"qk-lube-attachment__meta\">
              <span class=\"qk-lube-attachment__dot\" aria-hidden=\"true\"></span>
              <span class=\"qk-lube-attachment__title\">${escapeHtml(payload.title || attachmentLabel)}</span>
              ${quantityMarkup}
            </span>
            ${priceMarkup}
            <button type=\"button\" class=\"qk-lube-attachment__remove\" data-qk-lube-remove>${escapeHtml(removeLabel)}</button>
          `;

          if (priceAndQuantity instanceof Element) {
            info.insertBefore(attachment, priceAndQuantity);
          } else {
            info.appendChild(attachment);
          }
        });
      });
    });
  }

  function renderGiftWrapUi(cart) {
    const mounts = Array.from(document.querySelectorAll("[data-qk-gift-wrap-mount]"));
    if (!mounts.length) {
      closeGiftWrapModal({ restoreFocus: false });
      return;
    }

    const uiState = resolveGiftWrapUiState(cart);
    const isBusy = isGiftWrapControlBusy();
    const canToggleOn = uiState.available;
    const canToggleOff = uiState.selected;
    const controlDisabled = isBusy || (!canToggleOn && !canToggleOff);

    mounts.forEach((mount) => {
      const shell = ensureGiftWrapMountShell(mount);
      if (!shell) {
        return;
      }
      const toggleWrap = shell.toggleWrap;
      const toggleButton = shell.toggleButton;

      mount.setAttribute("data-qk-gift-wrap-hydrated", "1");
      toggleWrap.classList.toggle("is-selected", uiState.selected);
      toggleWrap.classList.toggle("is-disabled", controlDisabled);
      toggleWrap.removeAttribute("aria-hidden");

      toggleButton.setAttribute("data-selected", uiState.selected ? "1" : "0");
      toggleButton.setAttribute("aria-pressed", uiState.selected ? "true" : "false");
      if (controlDisabled) {
        toggleButton.setAttribute("disabled", "disabled");
        toggleButton.setAttribute("aria-disabled", "true");
      } else {
        toggleButton.removeAttribute("disabled");
        toggleButton.removeAttribute("aria-disabled");
      }

      mount.querySelectorAll(".qk-gift-wrap-toggle__helper").forEach((helper) => {
        helper.remove();
      });
    });

    if (state.giftWrapAddPerfPending && uiState.selected && uiState.hasManagedLine) {
      markPerf("gift-wrap-add-line-visible");
      measurePerf("gift-wrap-add-click-to-line-visible", "gift-wrap-add-click-line", "gift-wrap-add-line-visible");
      state.giftWrapAddPerfPending = false;
    }

    renderGiftWrapModal(uiState, isBusy);
  }

  function ensureGiftWrapMountShell(mount) {
    if (!(mount instanceof HTMLElement)) {
      return null;
    }

    let toggleWrap = mount.querySelector(".qk-gift-wrap-toggle-wrap");
    let toggleButton = mount.querySelector("[data-qk-gift-wrap-toggle]");

    if (!(toggleWrap instanceof HTMLElement) || !(toggleButton instanceof HTMLButtonElement)) {
      mount.innerHTML = `
        <div class="qk-gift-wrap-toggle-wrap is-disabled" aria-hidden="true">
          <button
            type="button"
            class="qk-gift-wrap-toggle"
            data-qk-gift-wrap-toggle
            aria-pressed="false"
            aria-disabled="true"
            disabled
          >
            <span class="qk-gift-wrap-toggle__left">
              <span class="qk-gift-wrap-toggle__emoji" aria-hidden="true">🎁</span>
              <span class="qk-gift-wrap-toggle__label">Impachetare Cadou?</span>
            </span>
            <span class="qk-gift-wrap-toggle__checkbox" aria-hidden="true"></span>
          </button>
        </div>
      `;
      toggleWrap = mount.querySelector(".qk-gift-wrap-toggle-wrap");
      toggleButton = mount.querySelector("[data-qk-gift-wrap-toggle]");
    }

    if (!(toggleWrap instanceof HTMLElement) || !(toggleButton instanceof HTMLButtonElement)) {
      return null;
    }

    return {
      toggleWrap,
      toggleButton,
    };
  }

  function renderGiftWrapModal(uiState, isBusy) {
    const modal = ensureGiftWrapModalElement();
    if (!(modal instanceof HTMLElement)) {
      return;
    }

    const imageElement = modal.querySelector("[data-qk-gift-wrap-modal-image]");
    const titleElement = modal.querySelector("[data-qk-gift-wrap-modal-title]");
    const priceElement = modal.querySelector("[data-qk-gift-wrap-modal-price]");
    const descriptionElement = modal.querySelector("[data-qk-gift-wrap-modal-description]");
    const confirmButton = modal.querySelector("[data-qk-gift-wrap-modal-confirm]");

    if (titleElement instanceof HTMLElement) {
      titleElement.textContent = uiState.productTitle;
    }

    if (priceElement instanceof HTMLElement) {
      priceElement.textContent = uiState.priceCents > 0 ? formatLei(uiState.priceCents) : "";
      priceElement.hidden = !priceElement.textContent;
    }

    if (descriptionElement instanceof HTMLElement) {
      descriptionElement.textContent = uiState.descriptionText;
      descriptionElement.hidden = !uiState.descriptionText;
    }

    if (imageElement instanceof HTMLImageElement) {
      if (uiState.imageUrl) {
        imageElement.hidden = false;
        imageElement.src = uiState.imageUrl;
        imageElement.alt = uiState.productTitle;
      } else {
        imageElement.hidden = true;
        imageElement.removeAttribute("src");
        imageElement.alt = "";
      }
    }

    if (confirmButton instanceof HTMLButtonElement) {
      const shouldDisable = isBusy || !uiState.available || uiState.selected;
      confirmButton.disabled = shouldDisable;
      confirmButton.setAttribute("aria-disabled", shouldDisable ? "true" : "false");
      const isConfirmBusy = Boolean(state.giftWrapConfirmBusy);
      confirmButton.classList.toggle("is-loading", isConfirmBusy);
      confirmButton.setAttribute("aria-busy", isConfirmBusy ? "true" : "false");
    }

    if (state.giftWrapModalOpen && uiState.selected && !state.giftWrapUiBusy) {
      closeGiftWrapModal({ restoreFocus: false });
    }
  }

  function resolveGiftWrapUiState(cart) {
    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    const managedLine = items.find((line) => isManagedGiftWrapLine(line)) || null;
    const hasManagedLine = Boolean(managedLine);
    const selected = readGiftWrapSelected(cart, items);
    const hasBaseLine = hasEligibleGiftWrapBaseLine(items);
    const available = Boolean(state.giftWrapInStock && normalizeLegacyId(state.giftWrapVariantLegacyId) && hasBaseLine);
    const product = state.giftWrapProduct;

    const productTitle = String(
      (managedLine && (managedLine.product_title || managedLine.title)) ||
        (product && product.title) ||
        "Impachetare Cadou",
    ).trim();
    const priceCents = resolveGiftWrapPriceCents(product, state.giftWrapVariantLegacyId, managedLine);
    const descriptionText = resolveGiftWrapDescriptionText(product);
    const imageUrl = resolveGiftWrapProductImageUrl(product, managedLine);

    return {
      selected,
      available,
      hasBaseLine,
      hasManagedLine,
      productTitle,
      priceCents,
      descriptionText,
      imageUrl,
    };
  }

  function renderPackageInsuranceUi(cart) {
    const mounts = Array.from(document.querySelectorAll("[data-qk-package-insurance-mount]"));
    if (!mounts.length) {
      closePackageInsuranceModal({ restoreFocus: false });
      return;
    }

    const uiState = resolvePackageInsuranceUiState(cart);
    const isBusy = isPackageInsuranceControlBusy();
    const canToggleOn = uiState.available;
    const canToggleOff = uiState.selected;
    const controlDisabled = isBusy || (!canToggleOn && !canToggleOff);

    mounts.forEach((mount) => {
      const shell = ensurePackageInsuranceMountShell(mount);
      if (!shell) {
        return;
      }
      const toggleWrap = shell.toggleWrap;
      const toggleButton = shell.toggleButton;

      mount.setAttribute("data-qk-package-insurance-hydrated", "1");
      toggleWrap.classList.toggle("is-selected", uiState.selected);
      toggleWrap.classList.toggle("is-disabled", controlDisabled);
      toggleWrap.removeAttribute("aria-hidden");

      toggleButton.setAttribute("data-selected", uiState.selected ? "1" : "0");
      toggleButton.setAttribute("aria-pressed", uiState.selected ? "true" : "false");
      if (controlDisabled) {
        toggleButton.setAttribute("disabled", "disabled");
        toggleButton.setAttribute("aria-disabled", "true");
      } else {
        toggleButton.removeAttribute("disabled");
        toggleButton.removeAttribute("aria-disabled");
      }

      mount.querySelectorAll(".qk-gift-wrap-toggle__helper").forEach((helper) => {
        helper.remove();
      });
    });

    if (state.packageInsuranceAddPerfPending && uiState.selected && uiState.hasManagedLine) {
      markPerf("package-insurance-add-line-visible");
      measurePerf(
        "package-insurance-add-click-to-line-visible",
        "package-insurance-add-click-line",
        "package-insurance-add-line-visible",
      );
      state.packageInsuranceAddPerfPending = false;
    }

    renderPackageInsuranceModal(uiState, isBusy);
  }

  function ensurePackageInsuranceMountShell(mount) {
    if (!(mount instanceof HTMLElement)) {
      return null;
    }

    let toggleWrap = mount.querySelector(".qk-gift-wrap-toggle-wrap");
    let toggleButton = mount.querySelector("[data-qk-package-insurance-toggle]");

    if (!(toggleWrap instanceof HTMLElement) || !(toggleButton instanceof HTMLButtonElement)) {
      mount.innerHTML = `
        <div class="qk-gift-wrap-toggle-wrap is-disabled" aria-hidden="true">
          <button
            type="button"
            class="qk-gift-wrap-toggle"
            data-qk-package-insurance-toggle
            aria-pressed="false"
            aria-disabled="true"
            disabled
          >
            <span class="qk-gift-wrap-toggle__left">
              <span class="qk-gift-wrap-toggle__emoji" aria-hidden="true">🛡️</span>
              <span class="qk-gift-wrap-toggle__label">Asigurare Colet</span>
            </span>
            <span class="qk-gift-wrap-toggle__checkbox" aria-hidden="true"></span>
          </button>
        </div>
      `;
      toggleWrap = mount.querySelector(".qk-gift-wrap-toggle-wrap");
      toggleButton = mount.querySelector("[data-qk-package-insurance-toggle]");
    }

    if (!(toggleWrap instanceof HTMLElement) || !(toggleButton instanceof HTMLButtonElement)) {
      return null;
    }

    return {
      toggleWrap,
      toggleButton,
    };
  }

  function renderPackageInsuranceModal(uiState, isBusy) {
    const modal = ensurePackageInsuranceModalElement();
    if (!(modal instanceof HTMLElement)) {
      return;
    }

    const imageElement = modal.querySelector("[data-qk-package-insurance-modal-image]");
    const titleElement = modal.querySelector("[data-qk-package-insurance-modal-title]");
    const priceElement = modal.querySelector("[data-qk-package-insurance-modal-price]");
    const descriptionElement = modal.querySelector("[data-qk-package-insurance-modal-description]");
    const confirmButton = modal.querySelector("[data-qk-package-insurance-modal-confirm]");

    if (titleElement instanceof HTMLElement) {
      titleElement.textContent = uiState.productTitle;
    }

    if (priceElement instanceof HTMLElement) {
      priceElement.textContent = uiState.priceCents > 0 ? formatLei(uiState.priceCents) : "";
      priceElement.hidden = !priceElement.textContent;
    }

    if (descriptionElement instanceof HTMLElement) {
      descriptionElement.textContent = uiState.descriptionText;
      descriptionElement.hidden = !uiState.descriptionText;
    }

    if (imageElement instanceof HTMLImageElement) {
      if (uiState.imageUrl) {
        imageElement.hidden = false;
        imageElement.src = uiState.imageUrl;
        imageElement.alt = uiState.productTitle;
      } else {
        imageElement.hidden = true;
        imageElement.removeAttribute("src");
        imageElement.alt = "";
      }
    }

    if (confirmButton instanceof HTMLButtonElement) {
      const shouldDisable = isBusy || !uiState.available || uiState.selected;
      confirmButton.disabled = shouldDisable;
      confirmButton.setAttribute("aria-disabled", shouldDisable ? "true" : "false");
      const isConfirmBusy = Boolean(state.packageInsuranceConfirmBusy);
      confirmButton.classList.toggle("is-loading", isConfirmBusy);
      confirmButton.setAttribute("aria-busy", isConfirmBusy ? "true" : "false");
    }

    if (state.packageInsuranceModalOpen && uiState.selected && !state.packageInsuranceUiBusy) {
      closePackageInsuranceModal({ restoreFocus: false });
    }
  }

  function resolvePackageInsuranceUiState(cart) {
    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    const managedLine = items.find((line) => isManagedPackageInsuranceLine(line)) || null;
    const hasManagedLine = Boolean(managedLine);
    const selected = readPackageInsuranceSelected(cart, items);
    const hasBaseLine = hasEligibleGiftWrapBaseLine(items);
    const available = Boolean(
      state.packageInsuranceInStock &&
        normalizeLegacyId(state.packageInsuranceVariantLegacyId) &&
        hasBaseLine,
    );
    const product = state.packageInsuranceProduct;

    const productTitle = String(
      (managedLine && (managedLine.product_title || managedLine.title)) ||
        (product && product.title) ||
        "Asigurare Colet",
    ).trim();
    const priceCents = resolveGiftWrapPriceCents(product, state.packageInsuranceVariantLegacyId, managedLine);
    const descriptionText = resolvePackageInsuranceDescriptionText(product);
    const imageUrl = resolveGiftWrapProductImageUrl(product, managedLine);

    return {
      selected,
      available,
      hasBaseLine,
      hasManagedLine,
      productTitle,
      priceCents,
      descriptionText,
      imageUrl,
    };
  }

  function resolveGiftWrapProductImageUrl(product, fallbackLine) {
    const fallbackFeaturedImage = safeObject(fallbackLine && fallbackLine.featured_image);
    const fallbackImageObject = safeObject(fallbackLine && fallbackLine.image);
    const fallbackLineImage = fallbackLine && typeof fallbackLine.image === "string" ? fallbackLine.image : "";

    const imageCandidates = [];
    if (product && Array.isArray(product.images) && product.images.length) {
      const firstImage = product.images[0];
      if (typeof firstImage === "string") {
        imageCandidates.push(firstImage);
      } else {
        imageCandidates.push(firstImage && firstImage.src, firstImage && firstImage.url);
      }
    }

    imageCandidates.push(
      product && product.featured_image && product.featured_image.src,
      fallbackFeaturedImage.url,
      fallbackFeaturedImage.src,
      fallbackLineImage,
      fallbackImageObject.url,
      fallbackImageObject.src,
    );

    for (const candidate of imageCandidates) {
      const raw = String(candidate == null ? "" : candidate).trim();
      if (!raw) {
        continue;
      }

      if (raw.startsWith("//")) {
        return `https:${raw}`;
      }

      if (raw.startsWith("/")) {
        return `${window.location.origin}${raw}`;
      }

      return raw;
    }

    return "";
  }

  function resolveGiftWrapDescriptionText(product) {
    const rawHtml = String(product && (product.body_html || product.description || "")).trim();
    if (!rawHtml) {
      return "Imbunatatiti experienta de unboxing cu serviciul nostru de impachetare cadou.";
    }

    const container = document.createElement("div");
    container.innerHTML = rawHtml;
    const text = String(container.textContent || "")
      .replace(/\s+/g, " ")
      .trim();
    if (!text) {
      return "Imbunatatiti experienta de unboxing cu serviciul nostru de impachetare cadou.";
    }

    const maxLength = 340;
    if (text.length <= maxLength) {
      return text;
    }

    return `${text.slice(0, maxLength).trim()}…`;
  }

  function resolvePackageInsuranceDescriptionText(product) {
    const rawHtml = String(product && (product.body_html || product.description || "")).trim();
    if (!rawHtml) {
      return "";
    }

    const container = document.createElement("div");
    container.innerHTML = rawHtml;
    const text = String(container.textContent || "")
      .replace(/\s+/g, " ")
      .trim();
    if (!text) {
      return "";
    }

    const maxLength = 340;
    if (text.length <= maxLength) {
      return text;
    }

    return `${text.slice(0, maxLength).trim()}…`;
  }

  function resolveGiftWrapPriceCents(product, variantLegacyId, fallbackLine) {
    const normalizedVariantId = normalizeLegacyId(variantLegacyId);
    const variants = Array.isArray(product && product.variants) ? product.variants : [];
    if (normalizedVariantId && variants.length) {
      const matchedVariant = variants.find((variant) => normalizeLegacyId(variant && variant.id) === normalizedVariantId);
      if (matchedVariant) {
        const centsFromVariant = parsePriceStringToCents(matchedVariant.price);
        if (centsFromVariant > 0) {
          return centsFromVariant;
        }
      }
    }

    const fallbackCents = parseCentsCandidate(
      fallbackLine && (fallbackLine.final_price || fallbackLine.price || fallbackLine.original_price),
    );
    if (fallbackCents != null && fallbackCents > 0) {
      return fallbackCents;
    }

    const firstVariant = variants[0];
    const centsFromFirstVariant = parsePriceStringToCents(firstVariant && firstVariant.price);
    return Math.max(0, centsFromFirstVariant);
  }

  function readGiftWrapSelected(cart, items) {
    if (state.giftWrapPendingDeselection) {
      if (state.giftWrapUiBusy) {
        return false;
      }
      state.giftWrapPendingDeselection = false;
    }
    if (state.giftWrapPendingSelection) {
      return true;
    }

    const currentAttributes = safeObject(cart && cart.attributes);
    const rawValue = String(currentAttributes[ATTR_GIFT_WRAP_SELECTED] == null ? "" : currentAttributes[ATTR_GIFT_WRAP_SELECTED]).trim();
    const normalizedRawValue = rawValue.toLowerCase();
    if (rawValue === "1" || normalizedRawValue === "true") {
      return true;
    }
    if (rawValue === "0" || normalizedRawValue === "false") {
      return false;
    }

    return (Array.isArray(items) ? items : []).some((line) => isManagedGiftWrapLine(line));
  }

  function isGiftWrapControlBusy() {
    return Boolean(state.giftWrapUiBusy || isSyncInFlight());
  }

  function readPackageInsuranceSelected(cart, items) {
    if (state.packageInsurancePendingDeselection) {
      if (state.packageInsuranceUiBusy) {
        return false;
      }
      state.packageInsurancePendingDeselection = false;
    }
    if (state.packageInsurancePendingSelection) {
      return true;
    }

    const currentAttributes = safeObject(cart && cart.attributes);
    const rawValue = String(
      currentAttributes[ATTR_PACKAGE_INSURANCE_SELECTED] == null
        ? ""
        : currentAttributes[ATTR_PACKAGE_INSURANCE_SELECTED],
    ).trim();
    const normalizedRawValue = rawValue.toLowerCase();
    if (rawValue === "1" || normalizedRawValue === "true") {
      return true;
    }
    if (rawValue === "0" || normalizedRawValue === "false") {
      return false;
    }

    return (Array.isArray(items) ? items : []).some((line) => isManagedPackageInsuranceLine(line));
  }

  function isPackageInsuranceControlBusy() {
    return Boolean(state.packageInsuranceUiBusy || isSyncInFlight());
  }

  async function setGiftWrapSelection(selected, options) {
    const normalizedOptions = options || {};
    const reason = normalizedOptions.reason || "gift-wrap-selection";
    const shouldSkipSync = Boolean(normalizedOptions.skipSync);
    const requestedSelected = Boolean(selected);
    const modalContext = normalizeGiftWrapModalContext(normalizedOptions.context || state.giftWrapModalContext);
    const drawerElement = modalContext === "drawer" ? resolveCartDrawerElement() : null;
    const drawerWasOpen = Boolean(drawerElement && drawerElement.hasAttribute("open"));
    const baseCart = normalizeCartPayload(state.lastCart) || state.lastCart;
    if (!baseCart) {
      state.giftWrapConfirmBusy = false;
      state.giftWrapPendingSelection = false;
      if (!shouldSkipSync) {
        activateCartSync(reason, null, 30);
      }
      return;
    }

    if (requestedSelected && (!state.giftWrapInStock || !normalizeLegacyId(state.giftWrapVariantLegacyId))) {
      try {
        await ensureGiftWrapVariantId(baseCart);
      } catch (error) {
        debugLog("[qk-cart-rules] gift-wrap variant ensure on selection failed", error);
      }
    }

    const hasBaseLine = hasEligibleGiftWrapBaseLine(baseCart.items);
    const canSelect = Boolean(state.giftWrapInStock && normalizeLegacyId(state.giftWrapVariantLegacyId) && hasBaseLine);
    const nextSelected = requestedSelected && canSelect;
    if (!requestedSelected) {
      state.giftWrapConfirmBusy = false;
      state.giftWrapAddPerfPending = false;
      state.giftWrapPendingSelection = false;
    }

    if (requestedSelected && !canSelect) {
      state.giftWrapPendingDeselection = false;
      state.giftWrapPendingSelection = false;
      state.giftWrapConfirmBusy = false;
      state.giftWrapAddPerfPending = false;
      scheduleUiRefresh("gift-wrap-selection-unavailable");
      return;
    }

    state.giftWrapPendingDeselection = !nextSelected;
    state.giftWrapPendingSelection = nextSelected;

    const currentAttributes = safeObject(baseCart.attributes);
    const currentValue = String(currentAttributes[ATTR_GIFT_WRAP_SELECTED] == null ? "" : currentAttributes[ATTR_GIFT_WRAP_SELECTED]).trim();
    const desiredValue = nextSelected ? "1" : "0";
    const immediateVariantUpdates = buildGiftWrapImmediateVariantUpdates(baseCart, nextSelected);
    const hasImmediateVariantUpdates = Object.keys(immediateVariantUpdates).length > 0;

    if (currentValue === desiredValue && !hasImmediateVariantUpdates) {
      state.giftWrapConfirmBusy = false;
      state.giftWrapAddPerfPending = false;
      state.giftWrapPendingSelection = false;
      if (!shouldSkipSync) {
        const needsFollowUpSync = shouldScheduleGiftWrapFollowUpSync(baseCart, nextSelected);
        if (needsFollowUpSync) {
          scheduleSync(reason, baseCart, 40);
        }
      }
      restoreCartDrawerOpenStateIfNeeded(drawerElement, drawerWasOpen);
      return;
    }

    state.giftWrapUiBusy = true;
    refreshCheckoutButtonsBusy();
    scheduleUiRefresh("gift-wrap-selection-start");

    try {
      const sectionIds = collectBundledSectionIds();
      const payload = {
        attributes: Object.assign({}, currentAttributes, {
          [ATTR_GIFT_WRAP_SELECTED]: desiredValue,
        }),
      };
      if (hasImmediateVariantUpdates) {
        payload.updates = immediateVariantUpdates;
      }

      if (Array.isArray(sectionIds) && sectionIds.length) {
        payload.sections = sectionIds;
        payload.sections_url = window.location.pathname;
      }

      const updatedCart = normalizeCartPayload(await requestCartJson("cart/update.js", payload)) || baseCart;
      state.lastCart = updatedCart;
      updateMainCartSection(updatedCart);
      refreshUiFromState();
      dispatchCartChanged("qk:gift-wrap-selection", updatedCart);

      if (!shouldSkipSync) {
        const needsFollowUpSync = shouldScheduleGiftWrapFollowUpSync(updatedCart, nextSelected);
        if (needsFollowUpSync) {
          scheduleSync(reason, updatedCart, 40);
        }
      }
      restoreCartDrawerOpenStateIfNeeded(drawerElement, drawerWasOpen);
    } catch (error) {
      state.giftWrapConfirmBusy = false;
      state.giftWrapAddPerfPending = false;
      reportError(error, "Nu am putut actualiza optiunea de impachetare cadou.");
      if (!shouldSkipSync) {
        scheduleSync("gift-wrap-selection-fallback", baseCart, 60);
      }
      restoreCartDrawerOpenStateIfNeeded(drawerElement, drawerWasOpen);
    } finally {
      state.giftWrapUiBusy = false;
      state.giftWrapConfirmBusy = false;
      state.giftWrapPendingSelection = false;
      refreshCheckoutButtonsBusy();
      scheduleUiRefresh("gift-wrap-selection-end");
      if (drawerWasOpen) {
        window.setTimeout(() => restoreCartDrawerOpenStateIfNeeded(drawerElement, true), 0);
        window.setTimeout(() => restoreCartDrawerOpenStateIfNeeded(drawerElement, true), 180);
      }
    }
  }

  function shouldScheduleGiftWrapFollowUpSync(cart, selected) {
    const normalizedCart = normalizeCartPayload(cart) || safeObject(cart);
    const items = Array.isArray(normalizedCart && normalizedCart.items) ? normalizedCart.items : [];
    const giftWrapProductLegacyId = normalizeLegacyId(GIFT_WRAP_PRODUCT_LEGACY_ID);
    const targetVariantLegacyId = normalizeLegacyId(state.giftWrapVariantLegacyId);
    const relatedLines = items.filter((line) => {
      if (!line) {
        return false;
      }

      if (isManagedGiftWrapLine(line)) {
        return true;
      }

      return normalizeLegacyId(line.product_id) === giftWrapProductLegacyId;
    });

    if (!selected) {
      return relatedLines.length > 0;
    }

    if (relatedLines.length !== 1) {
      return true;
    }

    const line = relatedLines[0];
    const lineQuantity = Math.max(0, parseInteger(line && line.quantity));
    if (lineQuantity !== 1) {
      return true;
    }

    const lineVariantLegacyId = normalizeLegacyId(line && line.variant_id);
    if (targetVariantLegacyId && lineVariantLegacyId && lineVariantLegacyId !== targetVariantLegacyId) {
      return true;
    }

    const desiredManagedProperties = {
      [ATTR_GIFT_WRAP_MANAGED]: "1",
      [ATTR_GIFT_WRAP_SOURCE]: SOURCE_STOREFRONT,
    };

    return !lineHasProperties(line, desiredManagedProperties);
  }

  async function setPackageInsuranceSelection(selected, options) {
    const normalizedOptions = options || {};
    const reason = normalizedOptions.reason || "package-insurance-selection";
    const shouldSkipSync = Boolean(normalizedOptions.skipSync);
    const requestedSelected = Boolean(selected);
    const modalContext = normalizePackageInsuranceModalContext(
      normalizedOptions.context || state.packageInsuranceModalContext,
    );
    const drawerElement = modalContext === "drawer" ? resolveCartDrawerElement() : null;
    const drawerWasOpen = Boolean(drawerElement && drawerElement.hasAttribute("open"));
    const baseCart = normalizeCartPayload(state.lastCart) || state.lastCart;
    if (!baseCart) {
      state.packageInsuranceConfirmBusy = false;
      state.packageInsurancePendingSelection = false;
      if (!shouldSkipSync) {
        activateCartSync(reason, null, 30);
      }
      return;
    }

    if (requestedSelected && (!state.packageInsuranceInStock || !normalizeLegacyId(state.packageInsuranceVariantLegacyId))) {
      try {
        await ensurePackageInsuranceVariantId(baseCart);
      } catch (error) {
        debugLog("[qk-cart-rules] package insurance variant ensure on selection failed", error);
      }
    }

    const hasBaseLine = hasEligibleGiftWrapBaseLine(baseCart.items);
    const canSelect = Boolean(
      state.packageInsuranceInStock &&
        normalizeLegacyId(state.packageInsuranceVariantLegacyId) &&
        hasBaseLine,
    );
    const nextSelected = requestedSelected && canSelect;
    if (!requestedSelected) {
      state.packageInsuranceConfirmBusy = false;
      state.packageInsuranceAddPerfPending = false;
      state.packageInsurancePendingSelection = false;
    }

    if (requestedSelected && !canSelect) {
      state.packageInsurancePendingDeselection = false;
      state.packageInsurancePendingSelection = false;
      state.packageInsuranceConfirmBusy = false;
      state.packageInsuranceAddPerfPending = false;
      scheduleUiRefresh("package-insurance-selection-unavailable");
      return;
    }

    state.packageInsurancePendingDeselection = !nextSelected;
    state.packageInsurancePendingSelection = nextSelected;

    const currentAttributes = safeObject(baseCart.attributes);
    const currentValue = String(
      currentAttributes[ATTR_PACKAGE_INSURANCE_SELECTED] == null
        ? ""
        : currentAttributes[ATTR_PACKAGE_INSURANCE_SELECTED],
    ).trim();
    const desiredValue = nextSelected ? "1" : "0";
    const immediateVariantUpdates = buildPackageInsuranceImmediateVariantUpdates(baseCart, nextSelected);
    const hasImmediateVariantUpdates = Object.keys(immediateVariantUpdates).length > 0;

    if (currentValue === desiredValue && !hasImmediateVariantUpdates) {
      state.packageInsuranceConfirmBusy = false;
      state.packageInsuranceAddPerfPending = false;
      state.packageInsurancePendingSelection = false;
      if (!shouldSkipSync) {
        const needsFollowUpSync = shouldSchedulePackageInsuranceFollowUpSync(baseCart, nextSelected);
        if (needsFollowUpSync) {
          scheduleSync(reason, baseCart, 40);
        }
      }
      restoreCartDrawerOpenStateIfNeeded(drawerElement, drawerWasOpen);
      return;
    }

    state.packageInsuranceUiBusy = true;
    refreshCheckoutButtonsBusy();
    scheduleUiRefresh("package-insurance-selection-start");

    try {
      const sectionIds = collectBundledSectionIds();
      const payload = {
        attributes: Object.assign({}, currentAttributes, {
          [ATTR_PACKAGE_INSURANCE_SELECTED]: desiredValue,
        }),
      };
      if (hasImmediateVariantUpdates) {
        payload.updates = immediateVariantUpdates;
      }

      if (Array.isArray(sectionIds) && sectionIds.length) {
        payload.sections = sectionIds;
        payload.sections_url = window.location.pathname;
      }

      const updatedCart = normalizeCartPayload(await requestCartJson("cart/update.js", payload)) || baseCart;
      state.lastCart = updatedCart;
      updateMainCartSection(updatedCart);
      refreshUiFromState();
      dispatchCartChanged("qk:package-insurance-selection", updatedCart);

      if (!shouldSkipSync) {
        const needsFollowUpSync = shouldSchedulePackageInsuranceFollowUpSync(updatedCart, nextSelected);
        if (needsFollowUpSync) {
          scheduleSync(reason, updatedCart, 40);
        }
      }
      restoreCartDrawerOpenStateIfNeeded(drawerElement, drawerWasOpen);
    } catch (error) {
      state.packageInsuranceConfirmBusy = false;
      state.packageInsuranceAddPerfPending = false;
      reportError(error, "Nu am putut actualiza optiunea de asigurare colet.");
      if (!shouldSkipSync) {
        scheduleSync("package-insurance-selection-fallback", baseCart, 60);
      }
      restoreCartDrawerOpenStateIfNeeded(drawerElement, drawerWasOpen);
    } finally {
      state.packageInsuranceUiBusy = false;
      state.packageInsuranceConfirmBusy = false;
      state.packageInsurancePendingSelection = false;
      refreshCheckoutButtonsBusy();
      scheduleUiRefresh("package-insurance-selection-end");
      if (drawerWasOpen) {
        window.setTimeout(() => restoreCartDrawerOpenStateIfNeeded(drawerElement, true), 0);
        window.setTimeout(() => restoreCartDrawerOpenStateIfNeeded(drawerElement, true), 180);
      }
    }
  }

  function shouldSchedulePackageInsuranceFollowUpSync(cart, selected) {
    const normalizedCart = normalizeCartPayload(cart) || safeObject(cart);
    const items = Array.isArray(normalizedCart && normalizedCart.items) ? normalizedCart.items : [];
    const packageInsuranceProductLegacyId = normalizeLegacyId(PACKAGE_INSURANCE_PRODUCT_LEGACY_ID);
    const targetVariantLegacyId = normalizeLegacyId(state.packageInsuranceVariantLegacyId);
    const relatedLines = items.filter((line) => {
      if (!line) {
        return false;
      }

      if (isManagedPackageInsuranceLine(line)) {
        return true;
      }

      return normalizeLegacyId(line.product_id) === packageInsuranceProductLegacyId;
    });

    if (!selected) {
      return relatedLines.length > 0;
    }

    if (relatedLines.length !== 1) {
      return true;
    }

    const line = relatedLines[0];
    const lineQuantity = Math.max(0, parseInteger(line && line.quantity));
    if (lineQuantity !== 1) {
      return true;
    }

    const lineVariantLegacyId = normalizeLegacyId(line && line.variant_id);
    if (targetVariantLegacyId && lineVariantLegacyId && lineVariantLegacyId !== targetVariantLegacyId) {
      return true;
    }

    const desiredManagedProperties = {
      [ATTR_PACKAGE_INSURANCE_MANAGED]: "1",
      [ATTR_PACKAGE_INSURANCE_SOURCE]: SOURCE_STOREFRONT,
    };

    return !lineHasProperties(line, desiredManagedProperties);
  }

  function buildPackageInsuranceImmediateVariantUpdates(cart, selected) {
    const updates = {};
    const productLegacyId = normalizeLegacyId(PACKAGE_INSURANCE_PRODUCT_LEGACY_ID);
    const targetVariantLegacyId = normalizeLegacyId(state.packageInsuranceVariantLegacyId);
    const cartVariantLegacyId = normalizeLegacyId(findVariantByProductLegacyIdInCart(cart, productLegacyId));

    if (selected) {
      if (cartVariantLegacyId && targetVariantLegacyId && cartVariantLegacyId !== targetVariantLegacyId) {
        updates[cartVariantLegacyId] = 0;
      }
      if (targetVariantLegacyId) {
        updates[targetVariantLegacyId] = 1;
      }
      return updates;
    }

    if (cartVariantLegacyId) {
      updates[cartVariantLegacyId] = 0;
    } else if (targetVariantLegacyId) {
      updates[targetVariantLegacyId] = 0;
    }

    return updates;
  }

  function resolveLineTotalPriceCents(line) {
    const totalCandidates = [
      line && line.final_line_price,
      line && line.line_price,
      line && line.original_line_price,
    ];

    for (const candidate of totalCandidates) {
      const resolvedCandidate = parseCentsCandidate(candidate);
      if (resolvedCandidate != null) {
        return resolvedCandidate;
      }
    }

    const quantity = Math.max(1, parseInteger(line && line.quantity));
    const unitCandidates = [
      line && line.final_price,
      line && line.price,
      line && line.original_price,
    ];

    for (const candidate of unitCandidates) {
      const resolvedCandidate = parseCentsCandidate(candidate);
      if (resolvedCandidate != null) {
        return resolvedCandidate * quantity;
      }
    }

    return 0;
  }

  function parseCentsCandidate(value) {
    if (value == null) {
      return null;
    }

    const normalized = String(value).trim();
    if (!normalized || !/^-?\d+$/.test(normalized)) {
      return null;
    }

    return Math.max(0, parseInteger(normalized));
  }

  function parsePriceStringToCents(value) {
    if (value == null) {
      return 0;
    }

    if (typeof value === "number" && Number.isFinite(value)) {
      return Math.max(0, Math.round(value * 100));
    }

    const raw = String(value).trim();
    if (!raw) {
      return 0;
    }

    const numeric = raw.replace(/[^\d,.\-]/g, "");
    if (!numeric) {
      return 0;
    }

    const hasComma = numeric.includes(",");
    const hasDot = numeric.includes(".");
    let decimalSeparator = "";

    if (hasComma && hasDot) {
      decimalSeparator = numeric.lastIndexOf(",") > numeric.lastIndexOf(".") ? "," : ".";
    } else if (hasComma) {
      decimalSeparator = ",";
    } else if (hasDot) {
      decimalSeparator = ".";
    }

    if (!decimalSeparator) {
      const units = Number.parseInt(numeric.replace(/[^\d\-]/g, ""), 10);
      return Number.isFinite(units) ? Math.max(0, units * 100) : 0;
    }

    const separatorIndex = numeric.lastIndexOf(decimalSeparator);
    const unitsRaw = numeric.slice(0, separatorIndex).replace(/[^\d\-]/g, "");
    const decimalsRaw = numeric.slice(separatorIndex + 1).replace(/[^\d]/g, "");

    const units = Number.parseInt(unitsRaw || "0", 10);
    if (!Number.isFinite(units)) {
      return 0;
    }

    const decimals = Number.parseInt(`${decimalsRaw}00`.slice(0, 2), 10);
    if (!Number.isFinite(decimals)) {
      return 0;
    }

    return Math.max(0, units * 100 + decimals);
  }

  function getLineContainer(lineElement) {
    if (!(lineElement instanceof Element)) {
      return lineElement;
    }

    const tableRow = lineElement.closest(".order-summary__body tr");
    return tableRow || lineElement;
  }

  function updateMainCartSection(cart) {
    const sectionHost = document.querySelector("[data-main-cart-section-id]");
    if (!(sectionHost instanceof Element)) {
      return;
    }

    const sectionId = sectionHost.getAttribute("data-main-cart-section-id");
    if (!sectionId) {
      return;
    }

    const sections = safeObject(cart && cart.sections);
    const sectionHtml = sections[sectionId];
    if (typeof sectionHtml !== "string" || !sectionHtml.trim()) {
      return;
    }

    const currentSection = document.getElementById(`shopify-section-${sectionId}`);
    if (!currentSection) {
      return;
    }

    const parser = new DOMParser();
    const doc = parser.parseFromString(sectionHtml, "text/html");
    const replacement =
      doc.getElementById(`shopify-section-${sectionId}`) ||
      doc.querySelector(".shopify-section") ||
      null;

    if (replacement) {
      currentSection.replaceWith(replacement);
      ensureKlarnaPlacementsLocale(replacement);
      refreshCartUiObserverTargets();
      return;
    }

    currentSection.innerHTML = sectionHtml;
    ensureKlarnaPlacementsLocale(currentSection);
    refreshCartUiObserverTargets();
  }

  function dispatchCartChanged(baseEvent, cart) {
    const normalizedCart = normalizeCartPayload(cart) || state.lastCart || { items: [], item_count: 0 };
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent,
          cart: normalizedCart,
        },
      }),
    );
  }

  function dispatchSyncEvent(name, detail) {
    document.documentElement.dispatchEvent(
      new CustomEvent(name, {
        bubbles: true,
        detail: detail || {},
      }),
    );
  }

  function setCheckoutButtonsBusy(isBusy) {
    document.querySelectorAll("[data-qk-standard-checkout-form] [name='checkout']").forEach((button) => {
      if (!(button instanceof HTMLElement)) {
        return;
      }

      if (isBusy) {
        button.setAttribute("aria-busy", "true");
        button.setAttribute("disabled", "disabled");
      } else {
        button.removeAttribute("aria-busy");
        button.removeAttribute("disabled");
      }
    });
  }

  async function ensureCartSections(cart, providedSectionIds) {
    const sectionIds = Array.isArray(providedSectionIds) ? providedSectionIds : collectBundledSectionIds();
    if (!sectionIds.length) {
      return cart;
    }

    const currentSections = safeObject(cart && cart.sections);
    const missingIds = sectionIds.filter((sectionId) => typeof currentSections[sectionId] !== "string");
    if (!missingIds.length) {
      return cart;
    }

    const missingSections = await fetchSectionsById(missingIds);
    return Object.assign({}, cart || {}, {
      sections: Object.assign({}, currentSections, missingSections),
    });
  }

  function collectBundledSectionIds() {
    const sections = [];

    document.documentElement.dispatchEvent(
      new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: {
          sections,
        },
      }),
    );

    const mainCartHost = document.querySelector("[data-main-cart-section-id]");
    if (mainCartHost instanceof Element) {
      const mainCartSectionId = mainCartHost.getAttribute("data-main-cart-section-id");
      if (mainCartSectionId) {
        sections.push(mainCartSectionId);
      }
    }

    return uniqueStrings(sections);
  }

  function readGiftWrapSessionCache(options) {
    const normalizedOptions = options || {};
    const allowStale = Boolean(normalizedOptions.allowStale);
    let rawValue = "";
    try {
      rawValue = String(window.sessionStorage.getItem(GIFT_WRAP_SESSION_CACHE_KEY) || "").trim();
    } catch {
      return null;
    }

    if (!rawValue) {
      return null;
    }

    let parsed = null;
    try {
      parsed = JSON.parse(rawValue);
    } catch {
      return null;
    }

    const source = safeObject(parsed);
    const cachedAt = Number(source.cachedAt || 0);
    const isFresh = Number.isFinite(cachedAt) && cachedAt > 0 && Date.now() - cachedAt <= GIFT_WRAP_CACHE_TTL_MS;
    if (!isFresh && !allowStale) {
      return null;
    }

    const product = source.product && typeof source.product === "object" ? source.product : null;
    const stockEntry = safeObject(source.stockEntry);
    const variantLegacyId = normalizeLegacyId(source.variantLegacyId);
    const inStock = Boolean(source.inStock);
    const hasStockEntry = Object.keys(stockEntry).length > 0;
    if (!product && !hasStockEntry && !variantLegacyId) {
      return null;
    }

    return {
      cachedAt,
      isFresh,
      product,
      stockEntry,
      variantLegacyId,
      inStock,
    };
  }

  function hydrateGiftWrapStateFromSessionCache(options) {
    const productLegacyId = normalizeLegacyId(GIFT_WRAP_PRODUCT_LEGACY_ID);
    if (!productLegacyId) {
      return false;
    }

    const cached = readGiftWrapSessionCache(options);
    if (!cached) {
      return false;
    }

    if (cached.product) {
      state.giftWrapProduct = cached.product;
      productLookupCacheByLegacyId[productLegacyId] = cached.product;
    }

    if (Object.keys(cached.stockEntry).length > 0) {
      state.giftWrapStockByProductId = Object.assign({}, state.giftWrapStockByProductId, {
        [productLegacyId]: cached.stockEntry,
      });
      state.giftWrapStockFetchedAt = Math.max(0, cached.cachedAt);
    }

    if (cached.variantLegacyId) {
      state.giftWrapVariantLegacyId = cached.variantLegacyId;
    }

    if (cached.variantLegacyId) {
      state.giftWrapInStock = Boolean(cached.inStock);
    }

    return true;
  }

  function persistGiftWrapStateToSessionCache() {
    const productLegacyId = normalizeLegacyId(GIFT_WRAP_PRODUCT_LEGACY_ID);
    if (!productLegacyId) {
      return;
    }

    const product = state.giftWrapProduct && typeof state.giftWrapProduct === "object" ? state.giftWrapProduct : null;
    const stockEntry = safeObject(state.giftWrapStockByProductId[productLegacyId]);
    const variantLegacyId = normalizeLegacyId(state.giftWrapVariantLegacyId);
    const payload = {
      cachedAt: Date.now(),
      product,
      stockEntry,
      variantLegacyId,
      inStock: Boolean(state.giftWrapInStock && variantLegacyId),
    };

    try {
      window.sessionStorage.setItem(GIFT_WRAP_SESSION_CACHE_KEY, JSON.stringify(payload));
    } catch {
      // ignore storage failures
    }
  }

  function readPackageInsuranceSessionCache(options) {
    const normalizedOptions = options || {};
    const allowStale = Boolean(normalizedOptions.allowStale);
    let rawValue = "";
    try {
      rawValue = String(window.sessionStorage.getItem(PACKAGE_INSURANCE_SESSION_CACHE_KEY) || "").trim();
    } catch {
      return null;
    }

    if (!rawValue) {
      return null;
    }

    let parsed = null;
    try {
      parsed = JSON.parse(rawValue);
    } catch {
      return null;
    }

    const source = safeObject(parsed);
    const cachedAt = Number(source.cachedAt || 0);
    const isFresh = Number.isFinite(cachedAt) && cachedAt > 0 && Date.now() - cachedAt <= GIFT_WRAP_CACHE_TTL_MS;
    if (!isFresh && !allowStale) {
      return null;
    }

    const product = source.product && typeof source.product === "object" ? source.product : null;
    const stockEntry = safeObject(source.stockEntry);
    const variantLegacyId = normalizeLegacyId(source.variantLegacyId);
    const inStock = Boolean(source.inStock);
    const hasStockEntry = Object.keys(stockEntry).length > 0;
    if (!product && !hasStockEntry && !variantLegacyId) {
      return null;
    }

    return {
      cachedAt,
      isFresh,
      product,
      stockEntry,
      variantLegacyId,
      inStock,
    };
  }

  function hydratePackageInsuranceStateFromSessionCache(options) {
    const productLegacyId = normalizeLegacyId(PACKAGE_INSURANCE_PRODUCT_LEGACY_ID);
    if (!productLegacyId) {
      return false;
    }

    const cached = readPackageInsuranceSessionCache(options);
    if (!cached) {
      return false;
    }

    if (cached.product) {
      state.packageInsuranceProduct = cached.product;
      productLookupCacheByLegacyId[productLegacyId] = cached.product;
    }

    if (Object.keys(cached.stockEntry).length > 0) {
      state.packageInsuranceStockByProductId = Object.assign({}, state.packageInsuranceStockByProductId, {
        [productLegacyId]: cached.stockEntry,
      });
      state.packageInsuranceStockFetchedAt = Math.max(0, cached.cachedAt);
    }

    if (cached.variantLegacyId) {
      state.packageInsuranceVariantLegacyId = cached.variantLegacyId;
      state.packageInsuranceInStock = Boolean(cached.inStock);
    }

    return true;
  }

  function persistPackageInsuranceStateToSessionCache() {
    const productLegacyId = normalizeLegacyId(PACKAGE_INSURANCE_PRODUCT_LEGACY_ID);
    if (!productLegacyId) {
      return;
    }

    const product =
      state.packageInsuranceProduct && typeof state.packageInsuranceProduct === "object"
        ? state.packageInsuranceProduct
        : null;
    const stockEntry = safeObject(state.packageInsuranceStockByProductId[productLegacyId]);
    const variantLegacyId = normalizeLegacyId(state.packageInsuranceVariantLegacyId);
    const payload = {
      cachedAt: Date.now(),
      product,
      stockEntry,
      variantLegacyId,
      inStock: Boolean(state.packageInsuranceInStock && variantLegacyId),
    };

    try {
      window.sessionStorage.setItem(PACKAGE_INSURANCE_SESSION_CACHE_KEY, JSON.stringify(payload));
    } catch {
      // ignore storage failures
    }
  }

  async function ensureGiftVariantIds(cart, config) {
    const giftTiers = Array.isArray(config && config.gift && config.gift.tiers) ? config.gift.tiers : [];
    if (!giftTiers.length) {
      return;
    }

    const giftProductLegacyIds = uniqueStrings(
      giftTiers.map((tier) => normalizeLegacyId(tier && tier.giftProductLegacyId)).filter(Boolean),
    );
    const now = Date.now();
    const shouldRefreshStock =
      now - Number(state.giftStockFetchedAt || 0) > GIFT_STOCK_CACHE_TTL_MS ||
      giftProductLegacyIds.some((productLegacyId) => !state.giftStockByProductId[productLegacyId]);

    if (giftProductLegacyIds.length && shouldRefreshStock) {
      const fetchedStock = await fetchGiftVariantStockByProductLegacyIds(giftProductLegacyIds);
      state.giftStockByProductId = Object.assign({}, state.giftStockByProductId, fetchedStock);
      state.giftStockFetchedAt = now;
    }

    giftTiers.forEach((tier) => {
      const productLegacyId = normalizeLegacyId(tier && tier.giftProductLegacyId);
      if (!productLegacyId) {
        tier.giftVariantLegacyId = "";
        tier.inStock = false;
        tier.hasSellableVariant = false;
        return;
      }

      const stockEntry = safeObject(state.giftStockByProductId[productLegacyId]);
      const hasStockEntry = Object.keys(stockEntry).length > 0;
      const sellableVariantLegacyIds = uniqueStrings(
        Array.isArray(stockEntry.sellableVariantLegacyIds)
          ? stockEntry.sellableVariantLegacyIds.map((variantId) => normalizeLegacyId(variantId)).filter(Boolean)
          : [],
      );
      const hasSellableVariant = sellableVariantLegacyIds.length > 0;
      const preferredSellableVariantId = normalizeLegacyId(stockEntry.preferredVariantLegacyId);

      const directVariantId = normalizeLegacyId(tier.giftVariantLegacyId);
      const fromCache = normalizeLegacyId(state.resolvedGiftVariantsByProductId[productLegacyId]);
      const fromCart = normalizeLegacyId(findVariantByProductLegacyIdInCart(cart, productLegacyId));
      const staticFallbackVariantId = normalizeLegacyId(FALLBACK_GIFT_VARIANT_BY_PRODUCT_ID[productLegacyId]);
      const manualFallbackVariantId = normalizeLegacyId(
        directVariantId || fromCache || fromCart || staticFallbackVariantId,
      );
      const fallbackVariants = [directVariantId, fromCache, fromCart, staticFallbackVariantId, preferredSellableVariantId];

      let resolvedVariantId = "";
      if (!hasStockEntry) {
        resolvedVariantId = normalizeLegacyId(directVariantId || fromCache || fromCart || staticFallbackVariantId);
        tier.giftVariantLegacyId = resolvedVariantId;
        tier.inStock = true;
        tier.hasSellableVariant = Boolean(resolvedVariantId);
        if (resolvedVariantId) {
          state.resolvedGiftVariantsByProductId[productLegacyId] = resolvedVariantId;
        }
        return;
      }

      fallbackVariants.forEach((candidate) => {
        if (resolvedVariantId || !candidate) {
          return;
        }

        if (!hasSellableVariant || sellableVariantLegacyIds.includes(candidate)) {
          resolvedVariantId = candidate;
        }
      });

      if (!resolvedVariantId && hasSellableVariant) {
        resolvedVariantId = sellableVariantLegacyIds[0];
      }

      if (!hasSellableVariant) {
        if (manualFallbackVariantId) {
          tier.giftVariantLegacyId = manualFallbackVariantId;
          tier.inStock = true;
          tier.hasSellableVariant = true;
          state.resolvedGiftVariantsByProductId[productLegacyId] = manualFallbackVariantId;
          return;
        }

        tier.giftVariantLegacyId = "";
        tier.inStock = false;
        tier.hasSellableVariant = false;
        delete state.resolvedGiftVariantsByProductId[productLegacyId];
        return;
      }

      tier.giftVariantLegacyId = normalizeLegacyId(resolvedVariantId);
      tier.inStock = Boolean(tier.giftVariantLegacyId);
      tier.hasSellableVariant = hasSellableVariant;

      if (tier.giftVariantLegacyId) {
        state.resolvedGiftVariantsByProductId[productLegacyId] = tier.giftVariantLegacyId;
      }
    });
  }

  async function ensureGiftWrapVariantId(cart) {
    const productLegacyId = normalizeLegacyId(GIFT_WRAP_PRODUCT_LEGACY_ID);
    if (!productLegacyId) {
      state.giftWrapVariantLegacyId = "";
      state.giftWrapInStock = false;
      state.giftWrapProduct = null;
      return;
    }

    hydrateGiftWrapStateFromSessionCache({ allowStale: true });
    const now = Date.now();
    const shouldRefreshStock =
      now - Number(state.giftWrapStockFetchedAt || 0) > GIFT_WRAP_CACHE_TTL_MS ||
      !Object.prototype.hasOwnProperty.call(state.giftWrapStockByProductId, productLegacyId);

    if (shouldRefreshStock) {
      try {
        const productsById = await fetchProductsByLegacyIds([productLegacyId]);
        const product = productsById[productLegacyId] || null;
        if (product) {
          productLookupCacheByLegacyId[productLegacyId] = product;
        }
        state.giftWrapProduct = product;
        state.giftWrapStockByProductId = Object.assign({}, state.giftWrapStockByProductId, {
          [productLegacyId]: buildVariantStockEntry(product),
        });
        state.giftWrapStockFetchedAt = now;
        persistGiftWrapStateToSessionCache();
      } catch (error) {
        debugLog("[qk-cart-rules] Gift-wrap stock lookup failed", error);
        const cachedStockEntry = safeObject(state.giftWrapStockByProductId[productLegacyId]);
        if (!Object.keys(cachedStockEntry).length) {
          state.giftWrapStockByProductId = Object.assign({}, state.giftWrapStockByProductId, {
            [productLegacyId]: buildVariantStockEntry(null),
          });
          state.giftWrapStockFetchedAt = now;
        }
      }
    }

    if (!state.giftWrapProduct && Object.prototype.hasOwnProperty.call(productLookupCacheByLegacyId, productLegacyId)) {
      state.giftWrapProduct = productLookupCacheByLegacyId[productLegacyId] || null;
    }

    const stockEntry = safeObject(state.giftWrapStockByProductId[productLegacyId]);
    const sellableVariantLegacyIds = uniqueStrings(
      Array.isArray(stockEntry.sellableVariantLegacyIds)
        ? stockEntry.sellableVariantLegacyIds.map((variantId) => normalizeLegacyId(variantId)).filter(Boolean)
        : [],
    );
    const hasSellableVariant = sellableVariantLegacyIds.length > 0;
    const preferredSellableVariantId = normalizeLegacyId(stockEntry.preferredVariantLegacyId);

    const fromCache = normalizeLegacyId(state.giftWrapVariantLegacyId);
    const fromCart = normalizeLegacyId(findVariantByProductLegacyIdInCart(cart, productLegacyId));
    const fallbackCandidates = [fromCache, fromCart, preferredSellableVariantId];

    let resolvedVariantId = "";
    fallbackCandidates.forEach((candidate) => {
      if (resolvedVariantId || !candidate) {
        return;
      }

      if (sellableVariantLegacyIds.includes(candidate)) {
        resolvedVariantId = candidate;
      }
    });

    if (!resolvedVariantId && hasSellableVariant) {
      resolvedVariantId = sellableVariantLegacyIds[0];
    }

    state.giftWrapVariantLegacyId = normalizeLegacyId(resolvedVariantId);
    state.giftWrapInStock = Boolean(hasSellableVariant && state.giftWrapVariantLegacyId);
    persistGiftWrapStateToSessionCache();
  }

  async function ensurePackageInsuranceVariantId(cart) {
    const productLegacyId = normalizeLegacyId(PACKAGE_INSURANCE_PRODUCT_LEGACY_ID);
    if (!productLegacyId) {
      state.packageInsuranceVariantLegacyId = "";
      state.packageInsuranceInStock = false;
      state.packageInsuranceProduct = null;
      return;
    }

    hydratePackageInsuranceStateFromSessionCache({ allowStale: true });
    const now = Date.now();
    const shouldRefreshStock =
      now - Number(state.packageInsuranceStockFetchedAt || 0) > GIFT_WRAP_CACHE_TTL_MS ||
      !Object.prototype.hasOwnProperty.call(state.packageInsuranceStockByProductId, productLegacyId);

    if (shouldRefreshStock) {
      try {
        const productsById = await fetchProductsByLegacyIds([productLegacyId]);
        const product = productsById[productLegacyId] || null;
        if (product) {
          productLookupCacheByLegacyId[productLegacyId] = product;
        }
        state.packageInsuranceProduct = product;
        state.packageInsuranceStockByProductId = Object.assign({}, state.packageInsuranceStockByProductId, {
          [productLegacyId]: buildVariantStockEntry(product),
        });
        state.packageInsuranceStockFetchedAt = now;
        persistPackageInsuranceStateToSessionCache();
      } catch (error) {
        debugLog("[qk-cart-rules] Package insurance stock lookup failed", error);
        const cachedStockEntry = safeObject(state.packageInsuranceStockByProductId[productLegacyId]);
        if (!Object.keys(cachedStockEntry).length) {
          state.packageInsuranceStockByProductId = Object.assign({}, state.packageInsuranceStockByProductId, {
            [productLegacyId]: buildVariantStockEntry(null),
          });
          state.packageInsuranceStockFetchedAt = now;
        }
      }
    }

    if (
      !state.packageInsuranceProduct &&
      Object.prototype.hasOwnProperty.call(productLookupCacheByLegacyId, productLegacyId)
    ) {
      state.packageInsuranceProduct = productLookupCacheByLegacyId[productLegacyId] || null;
    }

    const stockEntry = safeObject(state.packageInsuranceStockByProductId[productLegacyId]);
    const sellableVariantLegacyIds = uniqueStrings(
      Array.isArray(stockEntry.sellableVariantLegacyIds)
        ? stockEntry.sellableVariantLegacyIds.map((variantId) => normalizeLegacyId(variantId)).filter(Boolean)
        : [],
    );
    const hasSellableVariant = sellableVariantLegacyIds.length > 0;
    const preferredSellableVariantId = normalizeLegacyId(stockEntry.preferredVariantLegacyId);

    const fromCache = normalizeLegacyId(state.packageInsuranceVariantLegacyId);
    const fromCart = normalizeLegacyId(findVariantByProductLegacyIdInCart(cart, productLegacyId));
    const fallbackCandidates = [fromCache, fromCart, preferredSellableVariantId];

    let resolvedVariantId = "";
    fallbackCandidates.forEach((candidate) => {
      if (resolvedVariantId || !candidate) {
        return;
      }

      if (sellableVariantLegacyIds.includes(candidate)) {
        resolvedVariantId = candidate;
      }
    });

    if (!resolvedVariantId && hasSellableVariant) {
      resolvedVariantId = sellableVariantLegacyIds[0];
    }

    state.packageInsuranceVariantLegacyId = normalizeLegacyId(resolvedVariantId);
    state.packageInsuranceInStock = Boolean(hasSellableVariant && state.packageInsuranceVariantLegacyId);
    persistPackageInsuranceStateToSessionCache();
  }

  function buildGiftWrapImmediateVariantUpdates(cart, selected) {
    const updates = {};
    const productLegacyId = normalizeLegacyId(GIFT_WRAP_PRODUCT_LEGACY_ID);
    const targetVariantLegacyId = normalizeLegacyId(state.giftWrapVariantLegacyId);
    const cartVariantLegacyId = normalizeLegacyId(findVariantByProductLegacyIdInCart(cart, productLegacyId));

    if (selected) {
      if (cartVariantLegacyId && targetVariantLegacyId && cartVariantLegacyId !== targetVariantLegacyId) {
        updates[cartVariantLegacyId] = 0;
      }
      if (targetVariantLegacyId) {
        updates[targetVariantLegacyId] = 1;
      }
      return updates;
    }

    if (cartVariantLegacyId) {
      updates[cartVariantLegacyId] = 0;
    } else if (targetVariantLegacyId) {
      updates[targetVariantLegacyId] = 0;
    }

    return updates;
  }

  function warmGiftWrapProductState(options) {
    const normalizedOptions = options || {};
    const immediate = Boolean(normalizedOptions.immediate);
    const productLegacyId = normalizeLegacyId(GIFT_WRAP_PRODUCT_LEGACY_ID);
    if (!productLegacyId) {
      return;
    }

    hydrateGiftWrapStateFromSessionCache({ allowStale: true });
    const shouldSkip =
      Boolean(state.giftWrapProduct) &&
      Boolean(state.giftWrapVariantLegacyId) &&
      Object.prototype.hasOwnProperty.call(state.giftWrapStockByProductId, productLegacyId) &&
      Date.now() - Number(state.giftWrapStockFetchedAt || 0) <= GIFT_WRAP_CACHE_TTL_MS;
    if (shouldSkip) {
      return;
    }

    const load = async () => {
      try {
        const productsById = await fetchProductsByLegacyIds([productLegacyId]);
        const product = productsById[productLegacyId] || null;
        if (!product) {
          return;
        }

        productLookupCacheByLegacyId[productLegacyId] = product;
        const stockEntry = buildVariantStockEntry(product);
        state.giftWrapProduct = product;
        state.giftWrapStockByProductId = Object.assign({}, state.giftWrapStockByProductId, {
          [productLegacyId]: stockEntry,
        });
        state.giftWrapStockFetchedAt = Date.now();

        if (!state.giftWrapVariantLegacyId) {
          state.giftWrapVariantLegacyId = normalizeLegacyId(stockEntry.preferredVariantLegacyId);
        }
        state.giftWrapInStock = Boolean(
          stockEntry.hasSellableVariant &&
          normalizeLegacyId(state.giftWrapVariantLegacyId || stockEntry.preferredVariantLegacyId),
        );
        persistGiftWrapStateToSessionCache();
        scheduleUiRefresh("gift-wrap-prewarm");
      } catch (error) {
        debugLog("[qk-cart-rules] Gift-wrap prewarm failed", error);
      }
    };

    if (state.giftWrapWarmPromise) {
      return;
    }

    const runLoad = () => {
      if (state.giftWrapWarmPromise) {
        return;
      }

      state.giftWrapWarmPromise = load()
        .catch(() => {
          // load() already logs error
        })
        .finally(() => {
          state.giftWrapWarmPromise = null;
        });
    };

    if (immediate) {
      runLoad();
      return;
    }

    if (typeof window.requestIdleCallback === "function") {
      window.requestIdleCallback(() => {
        runLoad();
      }, { timeout: 1000 });
    } else {
      window.setTimeout(() => {
        runLoad();
      }, 80);
    }
  }

  function warmPackageInsuranceProductState(options) {
    const normalizedOptions = options || {};
    const immediate = Boolean(normalizedOptions.immediate);
    const productLegacyId = normalizeLegacyId(PACKAGE_INSURANCE_PRODUCT_LEGACY_ID);
    if (!productLegacyId) {
      return;
    }

    hydratePackageInsuranceStateFromSessionCache({ allowStale: true });
    const shouldSkip =
      Boolean(state.packageInsuranceProduct) &&
      Boolean(state.packageInsuranceVariantLegacyId) &&
      Object.prototype.hasOwnProperty.call(state.packageInsuranceStockByProductId, productLegacyId) &&
      Date.now() - Number(state.packageInsuranceStockFetchedAt || 0) <= GIFT_WRAP_CACHE_TTL_MS;
    if (shouldSkip) {
      return;
    }

    const load = async () => {
      try {
        const productsById = await fetchProductsByLegacyIds([productLegacyId]);
        const product = productsById[productLegacyId] || null;
        if (!product) {
          return;
        }

        productLookupCacheByLegacyId[productLegacyId] = product;
        const stockEntry = buildVariantStockEntry(product);
        state.packageInsuranceProduct = product;
        state.packageInsuranceStockByProductId = Object.assign({}, state.packageInsuranceStockByProductId, {
          [productLegacyId]: stockEntry,
        });
        state.packageInsuranceStockFetchedAt = Date.now();

        if (!state.packageInsuranceVariantLegacyId) {
          state.packageInsuranceVariantLegacyId = normalizeLegacyId(stockEntry.preferredVariantLegacyId);
        }
        state.packageInsuranceInStock = Boolean(
          stockEntry.hasSellableVariant &&
            normalizeLegacyId(
              state.packageInsuranceVariantLegacyId || stockEntry.preferredVariantLegacyId,
            ),
        );
        persistPackageInsuranceStateToSessionCache();
        scheduleUiRefresh("package-insurance-prewarm");
      } catch (error) {
        debugLog("[qk-cart-rules] Package insurance prewarm failed", error);
      }
    };

    if (state.packageInsuranceWarmPromise) {
      return;
    }

    const runLoad = () => {
      if (state.packageInsuranceWarmPromise) {
        return;
      }

      state.packageInsuranceWarmPromise = load()
        .catch(() => {
          // load() already logs error
        })
        .finally(() => {
          state.packageInsuranceWarmPromise = null;
        });
    };

    if (immediate) {
      runLoad();
      return;
    }

    if (typeof window.requestIdleCallback === "function") {
      window.requestIdleCallback(() => {
        runLoad();
      }, { timeout: 1000 });
    } else {
      window.setTimeout(() => {
        runLoad();
      }, 80);
    }
  }

  async function ensureLubricationVariantIds(cart, lubricationConfig) {
    const config = safeObject(lubricationConfig);
    const rules = collectLubricationConfigRules(config);
    if (!rules.length) {
      return;
    }

    const productLegacyIds = uniqueStrings(
      rules.map((rule) => normalizeLegacyId(rule && rule.productLegacyId)).filter(Boolean),
    );

    const now = Date.now();
    const shouldRefreshStock =
      now - Number(state.lubricationStockFetchedAt || 0) > GIFT_STOCK_CACHE_TTL_MS ||
      productLegacyIds.some((productLegacyId) => !state.lubricationStockByProductId[productLegacyId]);

    if (productLegacyIds.length && shouldRefreshStock) {
      const fetchedStock = await fetchLubricationVariantStockByProductLegacyIds(productLegacyIds);
      state.lubricationStockByProductId = Object.assign({}, state.lubricationStockByProductId, fetchedStock);
      state.lubricationStockFetchedAt = now;
    }

    rules.forEach((rule) => {
      const productLegacyId = normalizeLegacyId(rule && rule.productLegacyId);
      if (!productLegacyId) {
        rule.variantLegacyId = "";
        rule.inStock = false;
        rule.hasSellableVariant = false;
        return;
      }

      const stockEntry = safeObject(state.lubricationStockByProductId[productLegacyId]);
      const hasStockEntry = Object.keys(stockEntry).length > 0;
      const sellableVariantLegacyIds = uniqueStrings(
        Array.isArray(stockEntry.sellableVariantLegacyIds)
          ? stockEntry.sellableVariantLegacyIds.map((variantId) => normalizeLegacyId(variantId)).filter(Boolean)
          : [],
      );
      const hasSellableVariant = sellableVariantLegacyIds.length > 0;
      const preferredSellableVariantId = normalizeLegacyId(stockEntry.preferredVariantLegacyId);

      const directVariantId = normalizeLegacyId(rule.variantLegacyId);
      const fromCache = normalizeLegacyId(state.resolvedLubricationVariantsByProductId[productLegacyId]);
      const fromCart = normalizeLegacyId(findVariantByProductLegacyIdInCart(cart, productLegacyId));
      const fallbackVariants = [directVariantId, fromCache, fromCart, preferredSellableVariantId];

      let resolvedVariantId = "";
      if (!hasStockEntry) {
        resolvedVariantId = normalizeLegacyId(directVariantId || fromCache || fromCart);
        rule.variantLegacyId = resolvedVariantId;
        rule.inStock = Boolean(resolvedVariantId);
        rule.hasSellableVariant = Boolean(resolvedVariantId);
        if (resolvedVariantId) {
          state.resolvedLubricationVariantsByProductId[productLegacyId] = resolvedVariantId;
        }
        return;
      }

      fallbackVariants.forEach((candidate) => {
        if (resolvedVariantId || !candidate) {
          return;
        }

        if (!hasSellableVariant || sellableVariantLegacyIds.includes(candidate)) {
          resolvedVariantId = candidate;
        }
      });

      if (!resolvedVariantId && hasSellableVariant) {
        resolvedVariantId = sellableVariantLegacyIds[0];
      }

      if (!hasSellableVariant) {
        rule.variantLegacyId = "";
        rule.inStock = false;
        rule.hasSellableVariant = false;
        delete state.resolvedLubricationVariantsByProductId[productLegacyId];
        return;
      }

      rule.variantLegacyId = normalizeLegacyId(resolvedVariantId);
      rule.inStock = Boolean(rule.variantLegacyId);
      rule.hasSellableVariant = hasSellableVariant;
      if (rule.variantLegacyId) {
        state.resolvedLubricationVariantsByProductId[productLegacyId] = rule.variantLegacyId;
      }
    });
  }

  function findVariantByProductLegacyIdInCart(cart, productLegacyId) {
    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    for (const line of items) {
      if (normalizeLegacyId(line && line.product_id) !== productLegacyId) {
        continue;
      }

      const variantLegacyId = normalizeLegacyId(line && line.variant_id);
      if (variantLegacyId) {
        return variantLegacyId;
      }
    }

    return "";
  }

  async function fetchGiftVariantStockByProductLegacyIds(productLegacyIds) {
    const uniqueProductIds = uniqueStrings(
      (Array.isArray(productLegacyIds) ? productLegacyIds : []).map((id) => normalizeLegacyId(id)).filter(Boolean),
    );
    if (!uniqueProductIds.length) {
      return {};
    }

    try {
      const productsById = await fetchProductsByLegacyIds(uniqueProductIds);
      const resolved = {};

      uniqueProductIds.forEach((productLegacyId) => {
        resolved[productLegacyId] = buildVariantStockEntry(productsById[productLegacyId]);
      });

      return resolved;
    } catch (error) {
      debugLog("[qk-cart-rules] Gift stock lookup failed", error);
      return uniqueProductIds.reduce((acc, productLegacyId) => {
        acc[productLegacyId] = buildVariantStockEntry(null);
        return acc;
      }, {});
    }
  }

  async function fetchLubricationVariantStockByProductLegacyIds(productLegacyIds) {
    return fetchGiftVariantStockByProductLegacyIds(productLegacyIds);
  }

  function buildVariantStockEntry(product) {
    const variants = Array.isArray(product && product.variants) ? product.variants : [];
    if (!variants.length) {
      return {
        hasSellableVariant: false,
        sellableVariantLegacyIds: [],
        preferredVariantLegacyId: "",
      };
    }

    const sellableVariants = variants.filter((variant) => variant && variant.available !== false);
    const sellableVariantLegacyIds = sellableVariants
      .map((variant) => normalizeLegacyId(variant && variant.id))
      .filter(Boolean);
    const preferredVariantLegacyId = sellableVariantLegacyIds[0] || "";

    return {
      hasSellableVariant: Boolean(preferredVariantLegacyId),
      sellableVariantLegacyIds,
      preferredVariantLegacyId,
    };
  }

  async function fetchProductsByLegacyIds(productLegacyIds) {
    const requestedProductIds = uniqueStrings(
      (Array.isArray(productLegacyIds) ? productLegacyIds : []).map((id) => normalizeLegacyId(id)).filter(Boolean),
    );
    if (!requestedProductIds.length) {
      return {};
    }

    const resolvedById = {};
    const missingProductIds = requestedProductIds.filter(
      (productLegacyId) => !Object.prototype.hasOwnProperty.call(productLookupCacheByLegacyId, productLegacyId),
    );

    requestedProductIds.forEach((productLegacyId) => {
      if (!Object.prototype.hasOwnProperty.call(productLookupCacheByLegacyId, productLegacyId)) {
        return;
      }

      const cachedProduct = productLookupCacheByLegacyId[productLegacyId];
      if (cachedProduct) {
        resolvedById[productLegacyId] = cachedProduct;
      }
    });

    if (missingProductIds.length) {
      const fetchedFromIdsEndpoint = await fetchProductsByLegacyIdsViaIdsEndpoint(missingProductIds);
      Object.keys(fetchedFromIdsEndpoint).forEach((productLegacyId) => {
        const product = fetchedFromIdsEndpoint[productLegacyId];
        if (!product) {
          return;
        }
        productLookupCacheByLegacyId[productLegacyId] = product;
        resolvedById[productLegacyId] = product;
      });
    }

    const unresolvedAfterIdsEndpoint = requestedProductIds.filter(
      (productLegacyId) =>
        !resolvedById[productLegacyId] &&
        !Object.prototype.hasOwnProperty.call(productLookupCacheByLegacyId, productLegacyId),
    );
    if (unresolvedAfterIdsEndpoint.length) {
      const fetchedFromCatalog = await fetchProductsByLegacyIdsViaCatalogScan(unresolvedAfterIdsEndpoint);
      unresolvedAfterIdsEndpoint.forEach((productLegacyId) => {
        const product = fetchedFromCatalog[productLegacyId] || null;
        productLookupCacheByLegacyId[productLegacyId] = product;
        if (product) {
          resolvedById[productLegacyId] = product;
        }
      });
    }

    return resolvedById;
  }

  async function fetchProductsByLegacyIdsViaIdsEndpoint(productLegacyIds) {
    const requestedProductIds = uniqueStrings(
      (Array.isArray(productLegacyIds) ? productLegacyIds : []).map((id) => normalizeLegacyId(id)).filter(Boolean),
    );
    if (!requestedProductIds.length) {
      return {};
    }

    const endpoint = `${getRootPath()}products.json?ids=${encodeURIComponent(requestedProductIds.join(","))}&limit=${Math.max(1, requestedProductIds.length)}`;

    try {
      const response = await fetch(endpoint, {
        credentials: "same-origin",
      });
      if (!response.ok) {
        return {};
      }

      const payload = await response.json();
      const products = Array.isArray(payload && payload.products) ? payload.products : [];
      const requestedSet = new Set(requestedProductIds);
      const resolvedById = {};

      products.forEach((product) => {
        const productLegacyId = normalizeLegacyId(product && product.id);
        if (!productLegacyId || !requestedSet.has(productLegacyId)) {
          return;
        }

        resolvedById[productLegacyId] = product;
      });

      return resolvedById;
    } catch {
      return {};
    }
  }

  async function fetchProductsByLegacyIdsViaCatalogScan(productLegacyIds) {
    const targetProductIds = uniqueStrings(
      (Array.isArray(productLegacyIds) ? productLegacyIds : []).map((id) => normalizeLegacyId(id)).filter(Boolean),
    );
    if (!targetProductIds.length) {
      return {};
    }

    targetProductIds.forEach((productLegacyId) => {
      if (productCatalogByLegacyId[productLegacyId] && !productLookupCacheByLegacyId[productLegacyId]) {
        productLookupCacheByLegacyId[productLegacyId] = productCatalogByLegacyId[productLegacyId];
      }
    });

    const pendingTargets = targetProductIds.filter((productLegacyId) => !productCatalogByLegacyId[productLegacyId]);
    if (pendingTargets.length && !productCatalogExhausted) {
      await scanCatalogPagesForProducts(new Set(pendingTargets));
    }

    const resolvedById = {};
    targetProductIds.forEach((productLegacyId) => {
      if (productCatalogByLegacyId[productLegacyId]) {
        resolvedById[productLegacyId] = productCatalogByLegacyId[productLegacyId];
      }
    });

    return resolvedById;
  }

  async function scanCatalogPagesForProducts(targetProductIds) {
    const targets = targetProductIds instanceof Set ? targetProductIds : new Set();
    if (!targets.size || productCatalogExhausted) {
      return;
    }

    if (productCatalogScanPromise) {
      await productCatalogScanPromise;
      if (!productCatalogExhausted && hasMissingCatalogTargets(targets)) {
        await scanCatalogPagesForProducts(targets);
      }
      return;
    }

    productCatalogScanPromise = (async () => {
      while (!productCatalogExhausted && hasMissingCatalogTargets(targets)) {
        if (productCatalogNextPage > PRODUCT_LOOKUP_MAX_PAGES) {
          productCatalogExhausted = true;
          break;
        }

        const endpoint = `${getRootPath()}products.json?limit=${PRODUCT_LOOKUP_PAGE_LIMIT}&page=${productCatalogNextPage}`;
        let payload = null;

        try {
          const response = await fetch(endpoint, {
            credentials: "same-origin",
          });
          if (!response.ok) {
            productCatalogExhausted = true;
            break;
          }
          payload = await response.json();
        } catch {
          productCatalogExhausted = true;
          break;
        }

        const products = Array.isArray(payload && payload.products) ? payload.products : [];
        if (!products.length) {
          productCatalogExhausted = true;
          break;
        }

        products.forEach((product) => {
          const productLegacyId = normalizeLegacyId(product && product.id);
          if (productLegacyId) {
            productCatalogByLegacyId[productLegacyId] = product;
          }
        });

        if (products.length < PRODUCT_LOOKUP_PAGE_LIMIT) {
          productCatalogExhausted = true;
        }

        productCatalogNextPage += 1;
      }
    })()
      .finally(() => {
        productCatalogScanPromise = null;
      });

    await productCatalogScanPromise;
  }

  function hasMissingCatalogTargets(targetProductIds) {
    const targets = targetProductIds instanceof Set ? targetProductIds : new Set();
    for (const productLegacyId of targets) {
      if (!productCatalogByLegacyId[productLegacyId]) {
        return true;
      }
    }
    return false;
  }

  async function fetchSectionsById(sectionIds) {
    const root = getRootPath();
    const responses = await Promise.all(
      sectionIds.map(async (sectionId) => {
        const response = await fetch(`${root}?section_id=${encodeURIComponent(sectionId)}`, {
          credentials: "same-origin",
        });

        if (!response.ok) {
          throw new Error(`Section ${sectionId} fetch failed (${response.status})`);
        }

        const html = await response.text();
        return [sectionId, html];
      }),
    );

    return responses.reduce((acc, entry) => {
      acc[entry[0]] = entry[1];
      return acc;
    }, {});
  }

  async function fetchCartJson() {
    const root = getRootPath();
    const response = await fetch(`${root}cart.js`, {
      credentials: "same-origin",
    });

    if (!response.ok) {
      throw new Error(`Cart fetch failed (${response.status})`);
    }

    return response.json();
  }

  async function requestCartJson(endpoint, payload) {
    const root = getRootPath();
    const fetchInit = {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload || {}),
    };
    fetchInit["__qkFallbackFetch"] = true;
    const response = await fetch(`${root}${endpoint}`, fetchInit);

    if (!response.ok) {
      const text = await response.text();
      throw new Error(`Cart request failed (${response.status}): ${text.slice(0, 250)}`);
    }

    return response.json();
  }

  function getConfig() {
    if (state.config) {
      return state.config;
    }

    const rawConfig = parseJsonScript("qk-cart-rules", "Metafield-ul qwertykey.cart_rules nu este JSON valid.");
    state.config = normalizeConfig(rawConfig);
    return state.config;
  }

  function getLubricationConfig() {
    if (state.lubricationConfig) {
      return state.lubricationConfig;
    }

    const rawConfig = parseJsonScript("qk-lubrication-config", "Config-ul qk-lubrication-config nu este JSON valid.");
    state.lubricationConfig = normalizeLubricationConfig(rawConfig);
    state.lubricationManagedProductIds = buildLubricationManagedProductLookup(state.lubricationConfig);
    return state.lubricationConfig;
  }

  function buildLubricationManagedProductLookup(config) {
    const lookup = {};
    const rules = collectLubricationConfigRules(config);
    rules.forEach((rule) => {
      const productLegacyId = normalizeLegacyId(rule && rule.productLegacyId);
      if (!productLegacyId) {
        return;
      }
      lookup[productLegacyId] = true;
    });
    return lookup;
  }

  function parseJsonScript(scriptId, invalidMessage) {
    const element = document.getElementById(scriptId);
    if (!(element instanceof HTMLScriptElement)) {
      return null;
    }

    const raw = String(element.textContent || "").trim();
    if (!raw || raw === "null") {
      return null;
    }

    try {
      return JSON.parse(raw);
    } catch (error) {
      reportError(error, invalidMessage || `Config-ul ${scriptId} nu este JSON valid.`);
      return null;
    }
  }

  function normalizeConfig(rawConfig) {
    const source = safeObject(rawConfig);
    const defaults = DEFAULT_RULES;

    const sourceGift = safeObject(source.gift);
    const sourceFee = safeObject(source.fees);
    const sourceUi = safeObject(source.ui);
    const sourceFlags = safeObject(source.flags);

    const runtimeFlags = safeObject(window.qkCartRulesFlags);

    const sourceGiftTiers = normalizeGiftTierSources(sourceGift.tiers);
    const candidateGiftTiers = [1, 2, 3].map((index) => {
      const fallbackTier = defaults.gift.tiers[index - 1];
      const sourceTier = sourceGiftTiers[index - 1];

      const thresholdRon = readPositiveNumber(sourceTier.thresholdRon, fallbackTier.thresholdRon);
      return {
        index,
        enabled: readBoolean(sourceTier.enabled, fallbackTier.enabled),
        thresholdRon,
        thresholdCents: Math.round(thresholdRon * 100),
        giftTitle: String(sourceTier.giftTitle || sourceTier.title || "").trim(),
        giftProductLegacyId: readGiftTierProductLegacyId(sourceTier, fallbackTier),
        giftVariantLegacyId: readGiftTierVariantLegacyId(sourceTier),
        inStock: true,
        hasSellableVariant: true,
      };
    });

    let giftTiers = candidateGiftTiers;
    let giftMode = String(sourceGift.mode || defaults.gift.mode || "cumulative") === "cumulative" ? "cumulative" : "replace";

    const validationError = validateGiftTierConfig(candidateGiftTiers);
    if (validationError) {
      reportError(new Error(validationError), "Config-ul qwertykey.cart_rules este invalid. Folosesc fallback sigur.");

      const safeThreshold1Cents = Math.max(100, parseInteger(candidateGiftTiers[0].thresholdCents));
      const safeThreshold2Cents = Math.max(safeThreshold1Cents + 100, parseInteger(candidateGiftTiers[1].thresholdCents));
      const safeThreshold3Cents = Math.max(safeThreshold2Cents + 100, parseInteger(candidateGiftTiers[2].thresholdCents));

      giftTiers = [
        {
          index: 1,
          enabled: true,
          thresholdRon: safeThreshold1Cents / 100,
          thresholdCents: safeThreshold1Cents,
          giftTitle: "",
          giftProductLegacyId:
            normalizeLegacyId(candidateGiftTiers[0].giftProductLegacyId) || defaults.gift.tiers[0].giftProductLegacyId,
          giftVariantLegacyId: normalizeLegacyId(candidateGiftTiers[0].giftVariantLegacyId) || "",
          inStock: true,
          hasSellableVariant: true,
        },
        {
          index: 2,
          enabled: true,
          thresholdRon: safeThreshold2Cents / 100,
          thresholdCents: safeThreshold2Cents,
          giftTitle: "",
          giftProductLegacyId:
            normalizeLegacyId(candidateGiftTiers[1].giftProductLegacyId) || defaults.gift.tiers[1].giftProductLegacyId,
          giftVariantLegacyId: normalizeLegacyId(candidateGiftTiers[1].giftVariantLegacyId) || "",
          inStock: true,
          hasSellableVariant: true,
        },
        {
          index: 3,
          enabled: false,
          thresholdRon: safeThreshold3Cents / 100,
          thresholdCents: safeThreshold3Cents,
          giftTitle: "",
          giftProductLegacyId:
            normalizeLegacyId(candidateGiftTiers[2].giftProductLegacyId) || defaults.gift.tiers[2].giftProductLegacyId,
          giftVariantLegacyId: normalizeLegacyId(candidateGiftTiers[2].giftVariantLegacyId) || "",
          inStock: true,
          hasSellableVariant: true,
        },
      ];
      giftMode = "replace";
    }

    const feeRuleByKey = {};
    defaults.fees.rules.forEach((rule) => {
      feeRuleByKey[rule.key] = Object.assign({}, rule);
    });

    if (Array.isArray(sourceFee.rules)) {
      sourceFee.rules.forEach((rawRule) => {
        const sourceRule = safeObject(rawRule);
        const key = String(sourceRule.key || "").trim();
        if (!KNOWN_FEE_RULE_KEYS.includes(key)) {
          return;
        }

        const fallbackRule = feeRuleByKey[key] || {};
        feeRuleByKey[key] = {
          key,
          feeProductLegacyId: normalizeLegacyId(sourceRule.feeProductLegacyId) || fallbackRule.feeProductLegacyId || "",
          feeVariantLegacyId: normalizeLegacyId(sourceRule.feeVariantLegacyId) || fallbackRule.feeVariantLegacyId || "",
          includeTags: normalizeTagList(Array.isArray(sourceRule.includeTags) ? sourceRule.includeTags : fallbackRule.includeTags || []),
          excludeTags: normalizeTagList(Array.isArray(sourceRule.excludeTags) ? sourceRule.excludeTags : fallbackRule.excludeTags || []),
          suppresses: (Array.isArray(sourceRule.suppresses) ? sourceRule.suppresses : fallbackRule.suppresses || [])
            .map((entry) => String(entry || "").trim())
            .filter((entry) => KNOWN_FEE_RULE_KEYS.includes(entry)),
        };
      });
    }

    const feesRules = KNOWN_FEE_RULE_KEYS.map((ruleKey) => feeRuleByKey[ruleKey]).filter(Boolean);

    const mergedFlags = {
      managedRulesEnabled: readBoolean(
        runtimeFlags.managedRulesEnabled,
        readBoolean(sourceFlags.managedRulesEnabled, defaults.flags.managedRulesEnabled),
      ),
      shadowMode: readBoolean(runtimeFlags.shadowMode, readBoolean(sourceFlags.shadowMode, defaults.flags.shadowMode)),
      log: readBoolean(runtimeFlags.log, readBoolean(sourceFlags.log, defaults.flags.log)),
      killSwitch: readBoolean(runtimeFlags.killSwitch, readBoolean(sourceFlags.killSwitch, defaults.flags.killSwitch)),
    };

    return {
      version: readPositiveNumber(source.version, defaults.version),
      currency: String(source.currency || defaults.currency || "RON"),
      gift: {
        mode: giftMode,
        tiers: giftTiers,
      },
      fees: {
        rules: feesRules,
      },
      ui: {
        progressTitle: String(sourceUi.progressTitle || defaults.ui.progressTitle),
        unlockedLabel: String(sourceUi.unlockedLabel || defaults.ui.unlockedLabel),
        eligibleLabel: String(sourceUi.eligibleLabel || defaults.ui.eligibleLabel),
        lockedLabel: String(sourceUi.lockedLabel || defaults.ui.lockedLabel),
      },
      flags: mergedFlags,
    };
  }

  function normalizeLubricationConfig(rawConfig) {
    const source = safeObject(rawConfig);
    const defaults = DEFAULT_LUBRICATION_CONFIG;
    const keyboard = safeObject(source.keyboard);
    const switchConfig = safeObject(source.switch);
    const ui = safeObject(source.ui);

    return {
      version: readPositiveNumber(source.version, defaults.version),
      enabled: readBoolean(source.enabled, defaults.enabled),
      keyboard: {
        enabled: readBoolean(keyboard.enabled, defaults.keyboard.enabled),
        rules: normalizeLubricationRules(keyboard.rules),
      },
      switch: {
        enabled: readBoolean(switchConfig.enabled, defaults.switch.enabled),
        rules: normalizeLubricationRules(switchConfig.rules),
      },
      ui: {
        label_ro: String(ui.label_ro || defaults.ui.label_ro),
        attachment_ro: String(ui.attachment_ro || defaults.ui.attachment_ro),
      },
    };
  }

  function normalizeLubricationRules(rawRules) {
    const entries = Array.isArray(rawRules) ? rawRules : [];
    const byKey = {};

    entries.forEach((rawRule) => {
      const sourceRule = safeObject(rawRule);
      const key = String(sourceRule.key || "").trim();
      const productLegacyId = normalizeLegacyId(sourceRule.productLegacyId);
      if (!key || !productLegacyId) {
        return;
      }

      const configuredAliases = Array.isArray(sourceRule.aliases)
        ? sourceRule.aliases.map((alias) => normalizeLayoutAlias(alias)).filter(Boolean)
        : [];
      const fallbackAliases = [
        normalizeLayoutAlias(key),
        normalizeLayoutAlias(`${key}%`),
      ].filter(Boolean);
      const aliases = uniqueStrings(configuredAliases.concat(fallbackAliases));

      byKey[key] = {
        key,
        productLegacyId,
        variantLegacyId: normalizeLegacyId(sourceRule.variantLegacyId),
        aliases,
        inStock: true,
        hasSellableVariant: true,
      };
    });

    return Object.values(byKey);
  }

  function collectLubricationConfigRules(config) {
    const sourceConfig = safeObject(config);
    if (!sourceConfig.enabled) {
      return [];
    }

    const collected = [];
    const keyboard = safeObject(sourceConfig.keyboard);
    if (keyboard.enabled && Array.isArray(keyboard.rules)) {
      keyboard.rules.forEach((rule) => {
        if (rule && typeof rule === "object") {
          collected.push(rule);
        }
      });
    }

    const switchConfig = safeObject(sourceConfig.switch);
    if (switchConfig.enabled && Array.isArray(switchConfig.rules)) {
      switchConfig.rules.forEach((rule) => {
        if (rule && typeof rule === "object") {
          collected.push(rule);
        }
      });
    }

    return collected;
  }

  function normalizeGiftTierSources(rawTiers) {
    const tiers = Array.isArray(rawTiers) ? rawTiers : [];
    const byIndex = {};

    tiers.forEach((tier, position) => {
      const sourceTier = safeObject(tier);
      const index = parseInteger(sourceTier.index);
      if (index >= 1 && index <= 3) {
        byIndex[index] = sourceTier;
        return;
      }

      if (!byIndex[position + 1]) {
        byIndex[position + 1] = sourceTier;
      }
    });

    return [1, 2, 3].map((index) => safeObject(byIndex[index]));
  }

  function readGiftTierProductLegacyId(sourceTier, fallbackTier) {
    const tier = safeObject(sourceTier);
    const fallback = safeObject(fallbackTier);
    return (
      normalizeLegacyId(tier.giftProductLegacyId) ||
      normalizeLegacyId(tier.giftProductId) ||
      normalizeLegacyId(tier.productLegacyId) ||
      normalizeLegacyId(tier.productId) ||
      normalizeLegacyId(fallback.giftProductLegacyId)
    );
  }

  function readGiftTierVariantLegacyId(sourceTier) {
    const tier = safeObject(sourceTier);
    return (
      normalizeLegacyId(tier.giftVariantLegacyId) ||
      normalizeLegacyId(tier.giftVariantId) ||
      normalizeLegacyId(tier.variantLegacyId) ||
      normalizeLegacyId(tier.variantId)
    );
  }

  function validateGiftTierConfig(tiers) {
    const normalizedTiers = Array.isArray(tiers) ? tiers : [];
    const enabledTierIndexes = normalizedTiers
      .filter((tier) => Boolean(tier && tier.enabled))
      .map((tier) => parseInteger(tier.index));

    if (!enabledTierIndexes.length) {
      return "Cel putin un tier trebuie sa fie activ.";
    }

    if (enabledTierIndexes[0] !== 1) {
      return "Tierele active trebuie sa inceapa de la tier 1.";
    }

    for (let index = 0; index < enabledTierIndexes.length; index += 1) {
      if (enabledTierIndexes[index] !== index + 1) {
        return "Tierele active trebuie sa fie contigue (1,2,3 fara goluri).";
      }
    }

    let previousThreshold = 0;
    for (const tier of normalizedTiers) {
      if (!tier || !tier.enabled) {
        continue;
      }

      if (parseInteger(tier.thresholdCents) <= 0) {
        return `Pragul pentru tier ${parseInteger(tier.index)} trebuie sa fie pozitiv.`;
      }

      if (parseInteger(tier.thresholdCents) <= previousThreshold) {
        return "Pragurile tierelor active trebuie sa fie strict crescatoare.";
      }

      const normalizedGiftId = String(tier.giftProductLegacyId || "").trim();
      if (!/^\d+$/.test(normalizedGiftId) || Number(normalizedGiftId) <= 0) {
        return `ID-ul produsului pentru tier ${parseInteger(tier.index)} este invalid.`;
      }

      previousThreshold = parseInteger(tier.thresholdCents);
    }

    return null;
  }

  function uniqueStrings(values) {
    return Array.from(
      new Set(
        (Array.isArray(values) ? values : [])
          .map((value) => String(value || "").trim())
          .filter(Boolean),
      ),
    );
  }

  function normalizeTagList(tags) {
    return uniqueStrings(tags).map((tag) => tag.toLowerCase());
  }

  function normalizeLayoutAlias(value) {
    return String(value == null ? "" : value)
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "")
      .replace(/\(tkl\)/g, "tkl");
  }

  function getLineProperty(line, key) {
    const properties = safeObject(line && line.properties);
    const directValue = properties[key];
    if (directValue != null && String(directValue) !== "") {
      return String(directValue);
    }

    const normalizedKey = String(key || "").trim();
    if (!normalizedKey) {
      return "";
    }

    const aliasKey = normalizedKey.startsWith("_")
      ? normalizedKey.slice(1)
      : `_${normalizedKey}`;
    const aliasValue = properties[aliasKey];
    return aliasValue == null ? "" : String(aliasValue);
  }

  function lineHasProperties(line, expectedProperties) {
    return Object.keys(expectedProperties || {}).every(
      (key) => getLineProperty(line, key) === String(expectedProperties[key]),
    );
  }

  function lineHasPropertiesExcludingKeys(line, expectedProperties, excludedKeys) {
    const excludedLookup = {};
    (Array.isArray(excludedKeys) ? excludedKeys : []).forEach((key) => {
      const normalizedKey = String(key || "").trim();
      if (normalizedKey) {
        excludedLookup[normalizedKey] = true;
      }
    });

    return Object.keys(expectedProperties || {}).every((key) => {
      if (excludedLookup[String(key || "").trim()]) {
        return true;
      }
      return getLineProperty(line, key) === String(expectedProperties[key]);
    });
  }

  function isManagedGiftLine(line) {
    return getLineProperty(line, ATTR_GWP_MANAGED) === "1";
  }

  function isManagedGiftWrapLine(line) {
    if (getLineProperty(line, ATTR_GIFT_WRAP_MANAGED) === "1") {
      return true;
    }

    return normalizeLegacyId(line && line.product_id) === normalizeLegacyId(GIFT_WRAP_PRODUCT_LEGACY_ID);
  }

  function isManagedPackageInsuranceLine(line) {
    if (getLineProperty(line, ATTR_PACKAGE_INSURANCE_MANAGED) === "1") {
      return true;
    }

    return normalizeLegacyId(line && line.product_id) === normalizeLegacyId(PACKAGE_INSURANCE_PRODUCT_LEGACY_ID);
  }

  function isManagedFeeLine(line) {
    return getLineProperty(line, ATTR_FEE_MANAGED) === "1";
  }

  function isManagedLubricationLine(line) {
    if (getLineProperty(line, ATTR_LUBE_MANAGED) === "1") {
      return true;
    }

    const productLegacyId = normalizeLegacyId(line && line.product_id);
    if (!productLegacyId) {
      return false;
    }

    return Boolean(safeObject(state.lubricationManagedProductIds)[productLegacyId]);
  }

  function findLineByKey(cart, lineKey) {
    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    return items.find((line) => String(line.key || "") === String(lineKey || "")) || null;
  }

  function findLineIndexByKey(cart, lineKey) {
    const requestedKey = String(lineKey || "").trim();
    if (!requestedKey) {
      return -1;
    }

    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    return items.findIndex((line) => String(line && line.key ? line.key : "").trim() === requestedKey);
  }

  async function requestCartLineChangeWithFallback(cart, input) {
    const payload = input && typeof input === "object" ? input : {};
    const lineKey = String(payload.lineKey || "").trim();
    const quantity = Math.max(0, parseInteger(payload.quantity));
    const properties = safeObject(payload.properties);
    const hasProperties = Object.keys(properties).length > 0;

    if (!lineKey) {
      throw new Error("Missing line key for cart change request.");
    }

    const idPayload = {
      id: lineKey,
      quantity,
    };
    if (hasProperties) {
      idPayload.properties = properties;
    }

    try {
      return await requestCartJson("cart/change.js", idPayload);
    } catch (idError) {
      const lineIndex = findLineIndexByKey(cart, lineKey);
      if (lineIndex < 0) {
        throw idError;
      }

      const linePayload = {
        line: lineIndex + 1,
        quantity,
      };
      if (hasProperties) {
        linePayload.properties = properties;
      }

      return requestCartJson("cart/change.js", linePayload);
    }
  }

  function findLineItemElementsByKey(lineKey) {
    const requested = String(lineKey || "");
    return Array.from(document.querySelectorAll("line-item[data-line-key]")).filter((element) => {
      return String(element.getAttribute("data-line-key") || "") === requested;
    });
  }

  function findQuantityInputByLineKey(lineKey) {
    const requested = String(lineKey || "");
    const inputs = Array.from(document.querySelectorAll("input[data-line-key]"));
    return inputs.find((input) => String(input.getAttribute("data-line-key") || "") === requested) || null;
  }

  function isInsideCartUI(element) {
    return Boolean(element.closest("cart-drawer, .shopify-section--main-cart, .cart, line-item"));
  }

  function resolveEventTargetElement(event) {
    if (event && event.target instanceof Element) {
      return event.target;
    }

    if (!event || typeof event.composedPath !== "function") {
      return null;
    }

    const path = event.composedPath();
    if (!Array.isArray(path)) {
      return null;
    }

    for (const node of path) {
      if (node instanceof Element) {
        return node;
      }
    }

    return null;
  }

  function getRootPath() {
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }

    return "/";
  }

  function resolveKlarnaLocale() {
    const rawLang = String((document.documentElement && document.documentElement.lang) || "").trim().replace(/_/g, "-");
    const normalizedLang = rawLang.toLowerCase();
    const countryFromShopify = String(window.Shopify && window.Shopify.country ? window.Shopify.country : "")
      .trim()
      .toUpperCase();

    if (/^[a-z]{2}-[a-z]{2}$/i.test(rawLang)) {
      const [lang, country] = rawLang.split("-");
      return `${lang.toLowerCase()}-${country.toUpperCase()}`;
    }

    if (/^[a-z]{2}$/.test(normalizedLang)) {
      if (/^[A-Z]{2}$/.test(countryFromShopify)) {
        return `${normalizedLang}-${countryFromShopify}`;
      }
      if (normalizedLang === "ro") {
        return "ro-RO";
      }
      return `${normalizedLang}-${normalizedLang.toUpperCase()}`;
    }

    return "ro-RO";
  }

  function ensureKlarnaPlacementsLocale(root) {
    const scope = root instanceof Element || root instanceof Document ? root : document;
    const locale = resolveKlarnaLocale();
    const placements = Array.from(scope.querySelectorAll ? scope.querySelectorAll("klarna-placement") : []);

    placements.forEach((placement) => {
      if (!(placement instanceof Element)) {
        return;
      }

      const currentLocale = String(placement.getAttribute("locale") || "").trim();
      const currentDataLocale = String(placement.getAttribute("data-locale") || "").trim();
      const hasLocale = Boolean(currentLocale && currentLocale.toLowerCase() !== "null" && currentLocale.toLowerCase() !== "undefined");
      const hasDataLocale =
        Boolean(currentDataLocale && currentDataLocale.toLowerCase() !== "null" && currentDataLocale.toLowerCase() !== "undefined");

      if (!hasLocale) {
        placement.setAttribute("locale", locale);
      }

      if (!hasDataLocale) {
        placement.setAttribute("data-locale", locale);
      }
    });
  }

  function parseInteger(value) {
    const parsed = Number.parseInt(String(value == null ? "" : value), 10);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function readPositiveNumber(value, fallback) {
    const parsed = Number(value);
    if (!Number.isFinite(parsed) || parsed <= 0) {
      return Number(fallback) || 0;
    }

    return parsed;
  }

  function readBoolean(value, fallback) {
    if (typeof value === "boolean") {
      return value;
    }

    if (typeof value === "number") {
      return value !== 0;
    }

    if (typeof value === "string") {
      const normalized = value.trim().toLowerCase();
      if (["1", "true", "yes", "on"].includes(normalized)) {
        return true;
      }

      if (["0", "false", "no", "off"].includes(normalized)) {
        return false;
      }
    }

    return Boolean(fallback);
  }

  function normalizeLegacyId(value) {
    const normalized = String(value == null ? "" : value).trim();
    if (/^\d+$/.test(normalized)) {
      return normalized;
    }

    const gidMatch = normalized.match(/\/(\d+)\s*$/);
    return gidMatch ? gidMatch[1] : "";
  }

  function safeObject(value) {
    return value && typeof value === "object" ? value : {};
  }

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/\"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  function formatThresholdLabel(thresholdCents) {
    return `${Math.round(Math.max(0, Number(thresholdCents) || 0) / 100)}+ RON`;
  }

  function formatLei(cents) {
    const normalizedCents = Math.max(0, Number(cents) || 0);
    return LEI_CURRENCY_FORMATTER.format(normalizedCents / 100);
  }

  function isPerfDebugEnabled() {
    const config = state.config || DEFAULT_RULES;
    return Boolean(
      config &&
        config.flags &&
        config.flags.log &&
        window.performance &&
        typeof window.performance.mark === "function" &&
        typeof window.performance.measure === "function",
    );
  }

  function markPerf(name) {
    if (!isPerfDebugEnabled()) {
      return;
    }

    const markName = `qk-cart-rules:${String(name || "").trim()}`;
    if (!markName.endsWith(":")) {
      window.performance.mark(markName);
    }
  }

  function measurePerf(label, startMark, endMark) {
    if (!isPerfDebugEnabled()) {
      return;
    }

    const normalizedLabel = String(label || "").trim();
    const start = `qk-cart-rules:${String(startMark || "").trim()}`;
    const end = `qk-cart-rules:${String(endMark || "").trim()}`;
    const measureName = `qk-cart-rules:${normalizedLabel}`;
    if (!normalizedLabel || start.endsWith(":") || end.endsWith(":")) {
      return;
    }

    try {
      window.performance.measure(measureName, start, end);
      const entries = window.performance.getEntriesByName(measureName);
      const latest = entries.length ? entries[entries.length - 1] : null;
      if (latest && Number.isFinite(latest.duration)) {
        debugLog("[qk-cart-rules][perf]", normalizedLabel, `${Math.round(latest.duration)}ms`);
      }
      window.performance.clearMeasures(measureName);
      window.performance.clearMarks(start);
      window.performance.clearMarks(end);
    } catch {
      // ignore measurement errors
    }
  }

  function debugLog() {
    const config = state.config || DEFAULT_RULES;
    if (!config.flags || !config.flags.log) {
      return;
    }

    try {
      console.log.apply(console, arguments);
    } catch {
      // no-op
    }
  }

  function reportError(error, fallbackMessage) {
    const message = error instanceof Error ? error.message : String(error || fallbackMessage || "Unknown error");
    console.error("[qk-cart-rules]", fallbackMessage || "Error", message);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
